import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fetchWP from '../utils/fetchWP';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCheckCircle,  faFileInvoice, faEnvelopeOpenText, faPlusSquare, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import md5 from 'md5-hash';
import CircularProgress from '@material-ui/core/CircularProgress';
import Select from 'react-select';
import Popup from "reactjs-popup";
import ReactHtmlParser from 'react-html-parser';

export default class Shortcode extends Component {

    constructor(props) {
        super(props);

        this.refGlas = React.createRef()
        this.refMaße = React.createRef()
        this.refBefestigung = React.createRef()
        this.refZubehoer = React.createRef()
        this.refMontage = React.createRef()
        this.refAufbau = React.createRef()

        // Set the default states
        this.state = {
            AmountBefestigung: 0,
            PriceVPBrutto: 0,
            Sync: true,
            Module: {},
            Lizenz: "",
            SNDB: true,
            SNB:false,
            Clicked: {
                ClickFunnelPage: "ClickFunnelPage",
                Dimension: "notClicked",
                Glas: "notClicked",
                Beschlag: "notClicked",
                Battery: "notClicked",
                Zubehoer: "notClicked",
                Befestigungsmaterial: "notClicked",
                Montage: "notClicked",
                TechnischeZeichnung: "notClicked",
                Dachrahmen: "notClicked",
                Optik: "notClicked",
                Regenrinne: "notClicked",
                LED: "notClicked",
                Heizstrahler: "notClicked",
                Unterdachmarkise: "notClicked",
                Wechselrichter: "notClicked",
                StromSpeicher: "notClicked",
                Ladestation: "notClicked",
                SolarModul: "notClicked",
                Farbe: "notClicked",
                Windschutz: "notClicked",
                Unterkonstruktion: "notClicked",
                Aufbau: "notClicked",
                Keilfenster: "notClicked",
                Glasschiebeelemente: "notClicked",
                Seitenteil: "notClicked",
                Traegerart: "notClicked",
                Abdeckung: "notClicked",
                Geraeteraum: "notClicked"
            },
            CFSteps: 0,
            SubPieces: 1,
            Phone: "",
            Mail: "",
            finanzierung: "",
            selectedCheapest: false,
            KFL: false,
            KFR: false,
            KFB: false,
            GSL: false,
            GSR: false,
            GSV: false,
            VordachMaxWidth: 0,
            VordachMaxDeepth: 0,
            VordachMinWidth: 0,
            VordachMinDeepth: 0,
            Rate: 0,
            prevPage: [0],
            LEDAmount: 8,
            Aufschlag: {
                Klarglas: 0,
                Milchglas: 0,
                Mattglas: 0,
                Farbglas: 0,
                Rechteckig: 0,
                Halbrund: 0,
                Trapez: 0,
                Segment: 0,
                Regenrinne: 0,
                Montage: 0,
            },
            HeizstrahlerAmount: 1,
            GlasschiebeelementAmount: 0,
            GlasschiebeelementAmountRight: 0,
            GlasschiebeelementAmountLeft: 0,
            confPopUp: "",
            confLength: 0,
            PopUpText: "",
            PopUpTextSubmited: "",
            submited: false,
            DSGVO: "",
            DSGVOLink: "",
            downloadLink: "",
            trigger: false,
            Width: "",
            Deepth: "",
            Pieces: 1,
            MwSt: 1.19,
            Weight: 0,
            Konfiguration: [],
            Products: {
                Glas: [],
                Beschlag: [],
                ZubTerUeb: [],
                ZubVord: [],
                ZubAlg: [],
                Zubehoer: [],
                Befestigungsmaterial: [],
                Terrassenueberdachung: [{ IMG: "" }],
                Vordach: [{IMG:""}],
                TerUeb: [],
                Kanten: [],
                Maut: [],
                Bohrung: [],
                Montage: [],
                TechnischeZeichnung: [],
                Dachrahmen: [],
                Optik: [],
                Regenrinne: [],
                LED: [],
                Heizstrahler: [],
                Unterdachmarkise: [],
                Wechselrichter: [],
                StromSpeicher: [],
                Ladestation: [],
                SolarModul: [],
                Farbe: [],
                Windschutz: [],
                Unterkonstruktion: [],
                Aufbau: [],
                Keilfenster: [],
                Glasschiebeelemente: [],
                Seitenteil: [],
                Traegerart: [],
                Abdeckung: [],
                IMG: [],
                Geraeteraum: [],
                Seitenelemente: [],
                PDFDATA: [],
                SolarModule: [],
                Senkrechtmarkise: [],
            },
            sqmAufschlag: 1,
            QMAufschlag:[],
            selected: {
                StromSpeicher: "",
                SolarType:"",
                Ladestation: "",
                Wechselrichter: "",
                Montage: "",
                TechnischeZeichnung: "",
                Kanten: "",
                Maut: "",
                Bohrung: "",
                Vordach: "",
                Glas: "",
                Beschlag: "",
                ZubTerUeb: "",
                ZubVord: "",
                ZubAlg: "",
                Befestigungsmaterial: "",
                Dachrahmen: "",
                Optik: "",
                Regenrinne: "",
                SolarModul: "",
                Unterkonstruktion: "",
                Unterdachmarkise: "",
                Aufbau: "",
                LED: "",
                Keilfenster: "",
                Heizstrahler: "",
                Versand: "",
                Glasschiebeelemente: {
                    links: {},
                    rechts: {},
                    vorne: {},
                },
                Senkrechtmarkise: {
                    links: {},
                    rechts: {},
                    vorne: {},
                },
                Seitenelemente: {
                    links: {},
                    rechts: {},
                    vorne: {},
                },
                Seitenteil: "",
                Traegerart: "",
                Abdeckung: "",
                Farbe: "",
                Geraeteraum: "",
                Input: {
                    width: "",
                    deepth:""
                }
            },
            available: {
                Vordach: [],
                Montage: [],
                Glas: [],
                Beschlag: [],
                ZubTerUeb: [],
                ZubVord: [],
                ZubAlg: [],
                Zubehoer: [],
                Befestigungsmaterial: [],
                Dachrahmen: [],
                Optik: [],
                Regenrinne: [],
                Solarmodul: [],
                Unterkonstruktion: [],
                Unterdachmarkise: [],
                Aufbau: [],
                LED: [],
                Keilfenster: [],
                Heizstrahler: [],
                Glasschiebeelemente: [],
                Seitenteil: [],
                Traegerart: [],
                Abdeckung: [],
                Geraeteraum: [],
                Seitenelemente: [],
                StromSpeicher: [],
                PDFDATA: []
            },
            Price: "",
            PriceB: 0,
            Customer: {
                isSet: false,
                FirstName: "",
                LastName: "",
                Street: "",
                Zip: "",
                City: "",
                Phone: "",
                Mail: "",
                Anmerkungen: "",
                Anrede:"",
            }
        };

        this.fetchWP = new fetchWP({
            restURL: this.props.wpObject.api_url,
            restNonce: this.props.wpObject.api_nonce,
        });
        this.getSetting();
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                ClickFunnelPage: "ClickFunnelPage enter"
            })
        }, 300)
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.CFSteps < 0) {
            this.setState({
                CFSteps: 0
            })
        }

        if (prevState.CFSteps !== this.state.CFSteps) {
            this.selectVordach();
            this.setState({ CFD: 'notClicked' })
            setTimeout(() => {
                this.setState({
                    ClickFunnelPage: "ClickFunnelPage enter"
                })
            }, 150)
        }
        if (prevState.selected.Unterkonstruktion !== this.state.selected.Unterkonstruktion) {
            if (prevState.selected.Unterkonstruktion.Farbe !== undefined) {
                this.unselectItem(prevState.selected.Unterkonstruktion.Farbe);
            }
        }
        if (prevState.selected.Unterkonstruktion.Farbe !== this.state.selected.Farbe) {
            if (prevState.selected.Unterkonstruktion.Farbe !== undefined) {
                this.unselectItem(prevState.selected.Unterkonstruktion.Farbe);
            }
        }

        if (prevState.qm !== this.state.qm) {
            if (this.state.selected.Montage !== "") {
                var selected = this.state.selected;
                //this.unselectItem(selected.Montage);
                selected.Montage = "";
                this.setState({
                    selected: selected,
                })
            }
        }

    }

    init = () => {
        this.setState({
            AmountBefestigung: 0,
            PriceVPBrutto: 0,
            Sync: true,
            Module: {},
            Lizenz: "",
            SNDB: true,
            SNB: false,
            Clicked: {
                ClickFunnelPage: "ClickFunnelPage",
                Dimension: "notClicked",
                Glas: "notClicked",
                Beschlag: "notClicked",
                Battery: "notClicked",
                Zubehoer: "notClicked",
                Befestigungsmaterial: "notClicked",
                Montage: "notClicked",
                TechnischeZeichnung: "notClicked",
                Dachrahmen: "notClicked",
                Optik: "notClicked",
                Regenrinne: "notClicked",
                LED: "notClicked",
                Heizstrahler: "notClicked",
                Unterdachmarkise: "notClicked",
                Wechselrichter: "notClicked",
                StromSpeicher: "notClicked",
                Ladestation: "notClicked",
                SolarModul: "notClicked",
                Farbe: "notClicked",
                Windschutz: "notClicked",
                Unterkonstruktion: "notClicked",
                Aufbau: "notClicked",
                Keilfenster: "notClicked",
                Glasschiebeelemente: "notClicked",
                Seitenteil: "notClicked",
                Traegerart: "notClicked",
                Abdeckung: "notClicked",
                Geraeteraum: "notClicked"
            },
            CFSteps: 0,
            SubPieces: 1,
            Phone: "",
            Mail: "",
            finanzierung: "",
            selectedCheapest: false,
            KFL: false,
            KFR: false,
            KFB: false,
            GSL: false,
            GSR: false,
            GSV: false,
            VordachMaxWidth: 0,
            VordachMaxDeepth: 0,
            VordachMinWidth: 0,
            VordachMinDeepth: 0,
            Rate: 0,
            prevPage: [0],
            LEDAmount: 8,
            Aufschlag: {
                Klarglas: 0,
                Milchglas: 0,
                Mattglas: 0,
                Farbglas: 0,
                Rechteckig: 0,
                Halbrund: 0,
                Trapez: 0,
                Segment: 0,
                Regenrinne: 0,
                Montage: 0,
            },
            HeizstrahlerAmount: 1,
            GlasschiebeelementAmount: 0,
            GlasschiebeelementAmountRight: 0,
            GlasschiebeelementAmountLeft: 0,
            confPopUp: "",
            confLength: 0,
            PopUpText: "",
            PopUpTextSubmited: "",
            submited: false,
            DSGVO: "",
            DSGVOLink: "",
            downloadLink: "",
            trigger: false,
            Width: "",
            Deepth: "",
            Pieces: 1,
            Weight: 0,
            Konfiguration: [],
            Products: {
                Glas: [],
                Beschlag: [],
                ZubTerUeb: [],
                ZubVord: [],
                ZubAlg: [],
                Zubehoer: [],
                Befestigungsmaterial: [],
                Terrassenueberdachung: [{ IMG: "" }],
                Vordach: [{ IMG: "" }],
                TerUeb: [],
                Kanten: [],
                Maut: [],
                Bohrung: [],
                Montage: [],
                TechnischeZeichnung: [],
                Dachrahmen: [],
                Optik: [],
                Regenrinne: [],
                LED: [],
                Heizstrahler: [],
                Unterdachmarkise: [],
                Wechselrichter: [],
                StromSpeicher: [],
                Ladestation: [],
                SolarModul: [],
                Farbe: [],
                Windschutz: [],
                Unterkonstruktion: [],
                Aufbau: [],
                Keilfenster: [],
                Glasschiebeelemente: [],
                Seitenteil: [],
                Traegerart: [],
                Abdeckung: [],
                IMG: [],
                Geraeteraum: [],
                Seitenelemente: [],
                PDFDATA: [],
                SolarModule: [],
                Senkrechtmarkise: [],
            },
            sqmAufschlag: 1,
            QMAufschlag: [],
            selected: {
                StromSpeicher: "",
                SolarType: "",
                Ladestation: "",
                Wechselrichter: "",
                Montage: "",
                TechnischeZeichnung: "",
                Kanten: "",
                Maut: "",
                Bohrung: "",
                Vordach: "",
                Glas: "",
                Beschlag: "",
                ZubTerUeb: "",
                ZubVord: "",
                ZubAlg: "",
                Befestigungsmaterial: "",
                Dachrahmen: "",
                Optik: "",
                Regenrinne: "",
                SolarModul: "",
                Unterkonstruktion: "",
                Unterdachmarkise: "",
                Aufbau: "",
                LED: "",
                Keilfenster: "",
                Heizstrahler: "",
                Versand: "",
                Glasschiebeelemente: {
                    links: {},
                    rechts: {},
                    vorne: {},
                },
                Senkrechtmarkise: {
                    links: {},
                    rechts: {},
                    vorne: {},
                },
                Seitenelemente: {
                    links: {},
                    rechts: {},
                    vorne: {},
                },
                Seitenteil: "",
                Traegerart: "",
                Abdeckung: "",
                Farbe: "",
                Geraeteraum: "",
                Input: {
                    width: "",
                    deepth: ""
                }
            },
            available: {
                Vordach: [],
                Montage: [],
                Glas: [],
                Beschlag: [],
                ZubTerUeb: [],
                ZubVord: [],
                ZubAlg: [],
                Zubehoer: [],
                Befestigungsmaterial: [],
                Dachrahmen: [],
                Optik: [],
                Regenrinne: [],
                Solarmodul: [],
                Unterkonstruktion: [],
                Unterdachmarkise: [],
                Aufbau: [],
                LED: [],
                Keilfenster: [],
                Heizstrahler: [],
                Glasschiebeelemente: [],
                Seitenteil: [],
                Traegerart: [],
                Abdeckung: [],
                Geraeteraum: [],
                Seitenelemente: [],
                StromSpeicher: [],
                PDFDATA: []
            },
            Price: "",
            PriceB: 0,
            Customer: {
                isSet: false,
                FirstName: "",
                LastName: "",
                Street: "",
                Zip: "",
                City: "",
                Phone: "",
                Mail: "",
                Anmerkungen: "",
                Anrede: "",
            }
        }, () => {
            this.getSetting();
        })
    }

    checkMinMax = () => {
        if (floatval(this.state.Deepth) > floatval(this.state.Max_Deepth)) {
            this.setState({
                Deepth: this.state.Max_Deepth
            })
        }

        if (floatval(this.state.Deepth) < floatval(this.state.Min_Deepth)) {
            this.setState({
                Deepth: this.state.Min_Deepth
            })
        }

        if (floatval(this.state.Width) > floatval(this.state.Min_Width)) {
            this.setState({
                Width: this.state.Min_Width
            })
        }
    }

    numberWithDot = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    handleCustomer = (c, e) => {

        var Customer = this.state.Customer;
        switch (c) {
            case "firstname":
                Customer.FirstName = e.target.value;
                break;
            case "lastname":
                Customer.LastName = e.target.value;
                break;
            case "street":
                Customer.Street = e.target.value;
                break;
            case "zip":
                Customer.Zip = e.target.value;
                break;
            case "city":
                Customer.City = e.target.value;
                break;
            case "email":
                Customer.Mail = e.target.value;
                break;
            case "phone":
                Customer.Phone = e.target.value;
                break;
            case "anmerkungen":
                Customer.Anmerkungen = e.target.value;
                break;
        }

        this.setState({
            Customer: Customer
        })

    }

    getSetting = () => {
        this.fetchWP.post('ciab').then((json) => {
            if (json.check) {
                this.fetchWP.get('shortcode')
                    .then(
                        (json) => {
                            var Products = {
                                Glas: json.glas,
                                Beschlag: json.fitting,
                                ZubTerUeb: json.terraceCoveringExtensions,
                                ZubVord: json.canopyExtensions,
                                ZubAlg: json.extensions,
                                Zubehoer: [...json.extensions, ...json.canopyExtensions],
                                Befestigungsmaterial: json.fasteningMaterial,
                                Vordach: json.canopy,
                                TerUeb: json.terraceCovering,
                                Bohrung: json.drilling,
                                Kanten: json.polishEdges,
                                Maut: json.tool,
                                Montage: json.assembly,
                                TechnischeZeichnung: json.technicalDrawing,
                                Dachrahmen: json.roofFrame,
                                Optik: json.optics,
                                Regenrinne: json.gutter,
                                Terrassenueberdachung: json.terraceCovering,
                                LED: json.led,
                                Heizstrahler: json.heater,
                                Unterdachmarkise: json.awing,
                                StromSpeicher: json.battery,
                                Ladestation: json.charger,
                                Farbe: json.color,
                                Unterkonstruktion: json.substructure,
                                Keilfenster: json.wedgeWindow,
                                Glasschiebeelemente: json.slidingElement,
                                Wechselrichter: json.inverter,
                                SolarModule: json.solarModule,
                                Aufbau: json.construction,
                                Seitenteil: json.sideelement,
                                Traegerart: json.carrierType,
                                Abdeckung: json.cover,
                                IMG: json.productIMG,
                                Geraeteraum: json.deviceStorage,
                                Seitenelemente: json.sideelement,
                                PDFDATA: json.pdfData,
                                Shipping: json.shipping,
                                Senkrechtmarkise: json.senkrechtmarkise,
                                MontagePrice: json.montagePrice
                            }

                            var newPDFDATA = {};
                            Products.PDFDATA.map((item, key) => {
                                newPDFDATA[item.ProductName] = item;
                            })

                            var selectedShipping = 0;
                            if (Products.Shipping) {
                                Products.Shipping.map((item, key) => {
                                    if (this.props.wpObject.type === item.CanopyType) {
                                        selectedShipping = item.Price;
                                    }
                                    else if (this.props.wpObject.type.toLowerCase().includes("vordach")) {
                                        if ("Vordach" === item.CanopyType) {
                                            selectedShipping = item.Price;
                                        }
                                    }
                                })
                            }

                            Products.PDFDATA = newPDFDATA;

                            this.setState({
                                Products: Products,
                                Shipping: selectedShipping
                            })

                            if (this.props.wpObject.type.replace(" Alu", "") !== "Terrassenüberdachung" && this.props.wpObject.type !== "Solar-Terrassenüberdachung" && this.props.wpObject.type !== "Freitragendes Vordach") {
                                var VordachMaxWidth = Math.max(...json.canopy.map(o => parseFloat(o.Max_Width)), 0);
                                var VordachMaxDeepth = 0;
                                if (this.props.wpObject.type === "Trägervordach" || this.props.wpObject.type === "Winkelarmvordach") {
                                    VordachMaxDeepth = Math.max(...json.fitting.map((o) => { if (o.CanopyType === this.props.wpObject.type) { return parseFloat(o.Max_Deepth) } else { return 0 } }), 0);
                                }
                                else {
                                    VordachMaxDeepth = Math.max(...json.canopy.map(o => parseFloat(o.Max_Deepth)), 0);
                                }

                                var VordachMinWidth = Math.min(...json.canopy.map(o => parseFloat(o.Min_Width)));
                                var VordachMinDeepth = Math.min(...json.canopy.map(o => parseFloat(o.Min_Deepth)));
                            }
                            else if (this.props.wpObject.type.endsWith(" Alu")) {
                                var VordachMaxWidth = Math.max(...json.terraceCovering.map(o => { if (o.ProductName.endsWith(" Alu")) { return parseFloat(o.Max_Width) } else { return 0 } }), 0);
                                var VordachMaxDeepth = Math.max(...json.terraceCovering.map(o => { if (o.ProductName.endsWith(" Alu")) { return parseFloat(o.Max_Deepth) } else { return 0 } }), 0);
                                var VordachMinWidth = Math.min(...json.terraceCovering.map(o => { if (o.ProductName.endsWith(" Alu")) { return parseFloat(o.Min_Width) } else { return VordachMaxWidth } }));
                                var VordachMinDeepth = Math.min(...json.terraceCovering.map(o => { if (o.ProductName.endsWith(" Alu")) { return parseFloat(o.Min_Deepth) } else { return VordachMaxDeepth } }));
                            }
                            else if (this.props.wpObject.type === "Freitragendes Vordach") {
                                var VordachMaxWidth = Math.max(...json.canopy.map(o => { if (o.CanopyType === "Freitragendes Vordach") { return parseFloat(o.Max_Width) } else { return 0 } }), 0);
                                var VordachMaxDeepth = Math.max(...json.canopy.map(o => { if (o.CanopyType === "Freitragendes Vordach") { return parseFloat(o.Max_Deepth) } else { return 0 } }), 0);
                                var VordachMinWidth = Math.min(...json.canopy.map(o => { if (o.CanopyType === "Freitragendes Vordach") { return parseFloat(o.Min_Width) } else { return VordachMaxWidth } }));
                                var VordachMinDeepth = Math.min(...json.canopy.map(o => { if (o.CanopyType === "Freitragendes Vordach") { return parseFloat(o.Min_Deepth) } else { return VordachMaxDeepth } }));
                            }
                            else {
                                var VordachMaxWidth = Math.max(...json.terraceCovering.map(o => parseFloat(o.Max_Width)), 0);
                                var VordachMaxDeepth = Math.max(...json.terraceCovering.map(o => parseFloat(o.Max_Deepth)), 0);
                                var VordachMinWidth = Math.min(...json.terraceCovering.map(o => parseFloat(o.Min_Width)));
                                var VordachMinDeepth = Math.min(...json.terraceCovering.map(o => parseFloat(o.Min_Deepth)));
                            }
                            var available = this.state.available;
                            available.SolarType = [
                                {
                                    Amount: 0,
                                    CalcPrice: 0,
                                    CanopyType: "",
                                    Fittings: 0,
                                    GlasType: "",
                                    IMG: "https://glasvordach.de/wp-content/uploads/2020/06/Wandbefestigung.jpg",
                                    Id: "TUEB",
                                    Max_Deepth: "0",
                                    Max_Width: "0",
                                    Min_Deepth: "0",
                                    Min_Width: "0",
                                    Price: "0",
                                    ProductDescription: "",
                                    ProductName: "Terrassendach",
                                    ProductType: "SolarType",
                                    Strength: "0",
                                    Weight: null
                                },
                                {
                                    Amount: 0,
                                    CalcPrice: 0,
                                    CanopyType: "",
                                    Fittings: 0,
                                    GlasType: "",
                                    IMG: "https://glasvordach.de/wp-content/uploads/2020/06/Freistehend.jpg",
                                    Id: "CARP",
                                    Max_Deepth: "0",
                                    Max_Width: "0",
                                    Min_Deepth: "0",
                                    Min_Width: "0",
                                    Price: "0",
                                    ProductDescription: "",
                                    ProductName: "Carport",
                                    ProductType: "SolarType",
                                    Strength: "0",
                                    Weight: null
                                }
                            ]

                            this.setState({
                                Products: Products,
                                QMAufschlag: json.qmAufschlag,
                                DSGVO: json.DSGVO,
                                DSGVOLink: json.DSGVOLink,
                                PopUpText: json.PopUpText,
                                PopUpTextSubmited: json.PopUpTextSubmited,
                                VordachMaxWidth: VordachMaxWidth,
                                VordachMaxDeepth: VordachMaxDeepth,
                                VordachMinWidth: VordachMinWidth,
                                VordachMinDeepth: VordachMinDeepth,
                                finanzierung: json.finanzierung,
                                Phone: json.phone,
                                Mail: json.mail,
                                Web: json.web,
                                Company: json.company,
                                available: available,

                            },
                                () => {
                                    if (!this.props.wpObject.type.toLowerCase().includes("solar")) {
                                        this.setState({
                                            Width: this.state.VordachMinWidth,
                                            Deepth: this.state.VordachMinDeepth,
                                            oldConfig: true
                                        }, () => {
                                                if (this.props.wpObject.type.toLowerCase().includes("vordach")) {
                                                    this.selectVordach();
                                                }
                                                else {
                                                    this.checkDimensions();
                                                }
                                                setTimeout(() => {
                                                    this.selectAll()
                                                }, 500);
                                        })
                                    }
                                }
                            )
                        },
                        (err) => console.log('error', err)
                    );
            }
            else {
                this.setState({
                    Lizenz: "NO"
                })
            }
        })
    };

    selectVordach = () => {
        if (this.props.wpObject.type.replace(" Alu", "") !== "Terrassenüberdachung" &&
            this.props.wpObject.type !== "Solar-Terrassenüberdachung" &&
            this.props.wpObject.type !== "Freitragendes Vordach") {
            var available = {
                Vordach: [],
                Montage: [],
                Glas: [],
                Beschlag: [],
                ZubTerUeb: [],
                ZubVord: [],
                ZubAlg: [],
                Zubehoer: [],
                Befestigungsmaterial: [],
                Dachrahmen: [],
                Optik: [],
                Regenrinne: [],
                Solarmodul: [],
                Unterkonstruktion: [],
                Unterdachmarkise: [],
                Aufbau: [],
                LED: [],
                Keilfenster: [],
                Heizstrahler: [],
                Glasschiebeelemente: [],
                Seitenteil: [],
                Traegerart: [],
                Abdeckung: [],
                Geraeteraum: [],
                Seitenelemente: [],
                StromSpeicher: [],
                Glasschiebeelemente: [],
            };

            var selected = this.state.selected;
            this.state.Products.Vordach.map((item, key) => {
                if (Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                    Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width) &&
                    parseFloat(this.state.Deepth) <= parseFloat(item.Max_Deepth) &&
                    parseFloat(this.state.Deepth) >= parseFloat(item.Min_Deepth) && 
                    item.CanopyType !== "Freitragendes Vordach") {
                    available.Vordach.push(item);
                }
            })


            var VordachMinStrength = Math.min(...available.Vordach.map(o => parseFloat(o.Strength)));

            available.Vordach.map((item, key) => {
                if (parseFloat(item.Strength) === VordachMinStrength) {
                    selected.Vordach = item;
                    selected.Vordach.CanopyType = this.props.wpObject.type;
                }
            })

            this.setState({
                selected: selected,
            }, () => {
                var vdStrength = this.state.selected.Vordach.Strength === undefined ? 0 : this.state.selected.Vordach.Strength;
                var vdType = this.props.wpObject.type;

                this.state.Products.Glas.map((item, key) => {
                    if (parseFloat(item.Strength) === parseFloat(vdStrength) &&
                        this.props.wpObject.type.replace(" Alu", "") !== "Terrassenüberdachung" &&
                        this.props.wpObject.type !== "Solar-Terrassenüberdachung" && item.CanopyType !== "Terrassenüberdachung") {
                        available.Glas.push(item);
                        if (this.state.selected.Glas !== "") {
                            if (this.state.selected.Glas !== item) {
                                if (item.ProductName === this.state.selected.Glas.ProductName) {
                                    this.reselect(item);
                                }
                            }
                        }
                    }
                });

                    this.state.Products.Seitenteil.map((item, key) => {
                        if (item.CanopyType === vdType &&
                            Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                            Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width)) {
                            available.Seitenteil.push(item);
                        }
                    });

                    this.state.Products.Senkrechtmarkise.map((item, key) => {
                        if (item.CanopyType === vdType &&
                            Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                            Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width)) {
                            available.Seitenteil.push(item);
                        }
                    });

                    this.state.Products.Optik.map((item, key) => {
                        if (item.CanopyType === vdType) {
                            available.Optik.push(item);
                        }
                    });

                    this.state.Products.Abdeckung.map((item, key) => {
                        if (item.CanopyType === vdType) {
                            available.Abdeckung.push(item);
                        }
                    });

                    this.state.Products.Traegerart.map((item, key) => {
                        if (item.CanopyType === vdType) {
                            available.Traegerart.push(item);
                        }
                    });

                this.state.Products.Beschlag.map((item, key) => {
                    if (item.CanopyType === vdType && parseFloat(item.Min_Deepth) <= parseFloat(this.state.Deepth) && parseFloat(item.Max_Deepth) >= parseFloat(this.state.Deepth)) {
                        item.Farben = this.mapItem(this.state.Products.Farbe, "pulverbeschichtet")
                        available.Beschlag.push(item);
                        if (this.state.selected.Beschlag !== "") {
                            if (this.state.selected.Beschlag.ProductName === item.ProductName && item !== this.state.selected.Beschlag ) {
                                this.select(item);
                            }
                        }
                    }
                });

                this.state.Products.Regenrinne.map((item, key) => {
                    if (item.CanopyType === "" || item.CanopyType === vdType) {
                             available.Regenrinne.push(item);
                    }
                });


                this.state.Products.Bohrung.map((item, key) => {
                    if (parseFloat(item.Strength) === parseFloat(vdStrength)) {
                        selected.Bohrung = item;
                        this.setState({
                            selected: selected,
                        })
                    }
                });

                this.state.Products.Maut.map((item, key) => {
                    if (parseFloat(item.Strength) === parseFloat(vdStrength)) {
                        selected.Maut = item;
                        this.setState({
                            selected: selected,
                        })
                    }
                });

                this.state.Products.Kanten.map((item, key) => {
                    if (parseFloat(item.Strength) === parseFloat(vdStrength)) {
                        selected.Kanten = item;
                        this.setState({
                            selected: selected,
                        })
                    }
                });

                this.state.Products.Zubehoer.map((item, key) => {
                    if (item.CanopyType === "" && item.Max_Width === "0" && item.Min_Width === "0" && item.Max_Deepth === "0" && item.Min_Deepth === "0") {
                        available.Zubehoer.push(item)
                    }
                });

                this.state.Products.Befestigungsmaterial.map((item, key) => {
                    if (item.CanopyType === "" || item.CanopyType === vdType) {
                        available.Befestigungsmaterial.push(item);
                    }
                })

                this.state.Products.Montage.map((item, key) => {
                    if (item.CanopyType === this.state.selected.Vordach.CanopyType &&
                        Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                        Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width) || item.ProductName === "Selbstmontage" && item.CanopyType === "") {
                        available.Montage.push(item)
                    }
                })
                    available.LED = this.mapItem(this.state.Products.LED, vdType);
                this.setState({
                    available: available
                },
                    () => {
                    if (!this.state.selectedCheapest) {
                        this.selectCheapest();
                    }
                    }
                )
                this.calcPrice();
            })
        }
        else if(this.props.wpObject.type === "Freitragendes Vordach"){
            var available = {
                Vordach: [],
                Montage: [],
                Glas: [],
                Beschlag: [],
                ZubTerUeb: [],
                ZubVord: [],
                ZubAlg: [],
                Zubehoer: [],
                Befestigungsmaterial: [],
                Dachrahmen: [],
                Optik: [],
                Regenrinne: [],
                Solarmodul: [],
                Unterkonstruktion: [],
                Unterdachmarkise: [],
                Aufbau: [],
                LED: [],
                Keilfenster: [],
                Heizstrahler: [],
                Glasschiebeelemente: [],
                Seitenteil: [],
                Traegerart: [],
                Abdeckung: [],
                StromSpeicher: [],
                Geraeteraum: [],
                Seitenelemente: [],
            };

            var selected = this.state.selected;
            this.state.Products.Vordach.map((item, key) => {
                if (Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                    Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width) &&
                    parseFloat(this.state.Deepth) <= parseFloat(item.Max_Deepth) &&
                    parseFloat(this.state.Deepth) >= parseFloat(item.Min_Deepth) &&
                    this.props.wpObject.type === item.CanopyType ) {
                    available.Vordach.push(item);
                }
            })


            var VordachMinStrength = Math.min(...available.Vordach.map(o => parseFloat(o.Strength)));

            available.Vordach.map((item, key) => {
                if (parseFloat(item.Strength) === VordachMinStrength) {
                    selected.Vordach = item;
                    selected.Vordach.CanopyType = this.props.wpObject.type;
                }
            })

            this.setState({
                selected: selected,
            }, () => {
                var vdStrength = this.state.selected.Vordach.Strength === undefined ? 0 : this.state.selected.Vordach.Strength;
                var vdType = this.props.wpObject.type;

                this.state.Products.Glas.map((item, key) => {
                    if (parseFloat(item.Strength) === parseFloat(vdStrength) &&
                        item.CanopyType !== "Terrassenüberdachung") {
                        available.Glas.push(item);
                    }
                });


                    this.state.Products.Seitenteil.map((item, key) => {
                        if (item.CanopyType === vdType &&
                            Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                                Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width)) {
                            available.Seitenteil.push(item);
                        }
                    });

                    this.state.Products.Optik.map((item, key) => {
                        if (item.CanopyType === vdType) {
                            available.Optik.push(item);
                        }
                    });

                    this.state.Products.Traegerart.map((item, key) => {
                        if (item.CanopyType === vdType) {
                            available.Traegerart.push(item);
                        }
                    });

                this.state.Products.Beschlag.map((item, key) => {
                    if (item.CanopyType === vdType) {
                            item.Farben = this.mapItem(this.state.Products.Farbe, "Pulverbeschichtung")
                            available.Beschlag.push(item);
                    }
                });

                this.state.Products.Regenrinne.map((item, key) => {
                    if (item.CanopyType === "" || item.CanopyType === vdType) {
                        if (!item.ProductName.toLowerCase().includes("kasten")) {
                            available.Regenrinne.push(item);
                        }
                    }
                });

                    
                this.state.Products.Bohrung.map((item, key) => {
                    if (parseFloat(item.Strength) === parseFloat(vdStrength)) {
                        selected.Bohrung = item;
                        this.setState({
                            selected: selected,
                        })
                    }
                });

                this.state.Products.Maut.map((item, key) => {
                    if (parseFloat(item.Strength) === parseFloat(vdStrength)) {
                        selected.Maut = item;
                        this.setState({
                            selected: selected,
                        })
                    }
                });

                this.state.Products.Kanten.map((item, key) => {
                    if (parseFloat(item.Strength) === parseFloat(vdStrength)) {
                        selected.Kanten = item;
                        this.setState({
                            selected: selected,
                        })
                    }
                });

                this.state.Products.Zubehoer.map((item, key) => {
                    if (item.CanopyType === "" && item.Max_Width === "0" && item.Min_Width === "0" && item.Max_Deepth === "0" && item.Min_Deepth === "0") {
                        available.Zubehoer.push(item)
                    }
                });

                this.state.Products.Befestigungsmaterial.map((item, key) => {
                    if (item.CanopyType === "" || item.CanopyType === vdType) {
                        available.Befestigungsmaterial.push(item);
                    }
                })

                this.state.Products.Montage.map((item, key) => {
                    if (item.CanopyType === this.state.selected.Vordach.CanopyType &&
                        Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                            Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width) || item.ProductName === "Selbstmontage" && item.CanopyType === "") {
                        available.Montage.push(item)
                    }
                })

                    available.LED = this.mapItem(this.state.Products.LED, vdType);


                this.setState({
                    available: available
                }, () => {
                    if (!this.state.selectedCheapest) {
                        this.selectCheapest();
                    }
                })
                    this.calcPrice();
            })
        }
        else if (this.props.wpObject.type.replace(" Alu", "") === "Terrassenüberdachung" ||
            this.props.wpObject.type === "Solar-Terrassenüberdachung"){
            var selected = this.state.selected;
            var GlasType = "Klarglas";
            var Unterkonstruktion = this.props.wpObject.type.endsWith("Alu") || this.props.wpObject.type.toLowerCase().includes("solar") ? "Aluminium" : this.state.selected.Unterkonstruktion.ProductName;
            if (this.state.selected.Unterkonstruktion !== "" || this.props.wpObject.type.endsWith("Alu")) {
                switch (Unterkonstruktion) {
                    case "Aluminium":
                        if (!this.props.wpObject.type.toLowerCase().includes("solar")) {
                            Unterkonstruktion = "Alu"
                        }
                        else {
                            Unterkonstruktion = "UK"
                        }
                        break;
                    case "Stahl verzinkt":
                        Unterkonstruktion = "verzinkt"
                        break;
                    case "Stahl verzinkt und gepulvert":
                        Unterkonstruktion = "gepulvert"
                        break;
                    case "Edelstahl":
                        Unterkonstruktion = "Edelstahl"
                        break;
                }
                if (this.state.selected.Glas !== "" && Unterkonstruktion === "Alu") {
                    GlasType = this.state.selected.Glas.GlasType
                }
                else {
                    GlasType = "Klarglas"
                }

                this.state.Products.TerUeb.map((item, key) => {
                    if (Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                        Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width) &&
                        parseFloat(this.state.Deepth) <= parseFloat(item.Max_Deepth) &&
                        parseFloat(this.state.Deepth) >= parseFloat(item.Min_Deepth) &&
                        item.ProductName.endsWith(Unterkonstruktion) && item.GlasType === GlasType &&
                        item.ProductName.endsWith("Alu") ||
                        Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                    Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width) &&
                        parseFloat(this.state.Deepth) <= parseFloat(item.Max_Deepth) &&
                            parseFloat(this.state.Deepth) >= parseFloat(item.Min_Deepth) &&
                            item.ProductName.endsWith(Unterkonstruktion) && !item.ProductName.endsWith("Alu")) {

                        selected.Vordach = item;
                        selected.Vordach.CanopyType = this.props.wpObject.type;

                        this.setState({
                            selected: selected,
                        }, () => {
                                var available = {
                                    Vordach: [],
                                Montage: [],
                                Glas: [],
                                Beschlag: [],
                                ZubTerUeb: [],
                                ZubVord: [],
                                ZubAlg: [],
                                Zubehoer: [],
                                Befestigungsmaterial: [],
                                Dachrahmen: [],
                                Optik: [],
                                Regenrinne: [],
                                Solarmodul: [],
                                Unterkonstruktion: [],
                                Unterdachmarkise: [],
                                Aufbau: [],
                                LED: [],
                                Keilfenster: [],
                                Heizstrahler: [],
                                Glasschiebeelemente: [],
                                Seitenteil: [],
                                Traegerart: [],
                                Abdeckung: [],
                                    Seitenelemente: [],
                                    Geraeteraum: [],
                                    StromSpeicher: [],
                                    Glasschiebeelemente: [],
                            };

                            var vdType = this.props.wpObject.type;

                            available.Glas = this.mapItem(this.state.Products.Glas, vdType.replace(" Alu", ""));
                            available.Aufbau = this.mapItem(this.state.Products.Aufbau, "");
                                if (vdType.endsWith("Alu")) {
                                    available.Unterkonstruktion = this.mapItem(this.state.Products.Unterkonstruktion, "Alu", false, false, false, false, "color");
                                }
                                else {
                                    if (!vdType.endsWith("Alu") && vdType !== ("Solar-Terrassenüberdachung")) {
                                        available.Unterkonstruktion = this.mapItem(this.state.Products.Unterkonstruktion, "", false, false, false, false, "color");
                                        available.Unterkonstruktion = available.Unterkonstruktion.filter((obj) => {
                                            return obj.CanopyType !== 'Solar';
                                        });
                                    }
                                    if (vdType === ("Solar-Terrassenüberdachung")) {
                                        available.Unterkonstruktion1 = this.mapItem(this.state.Products.Unterkonstruktion, "Alu", false, false, false, false, "color");
                                    }
                                    if (vdType === ("Solar-Terrassenüberdachung")) {
                                        available.Unterkonstruktion2 = this.mapItem(this.state.Products.Unterkonstruktion, "Solar", false, false, false, false, "color");
                                        available.Unterkonstruktion = available.Unterkonstruktion1.concat(available.Unterkonstruktion2);
                                        if (vdType === ("Solar-Terrassenüberdachung") && parseFloat(this.state.Deepth) < 5001) {
                                            available.Unterkonstruktion = available.Unterkonstruktion.filter((obj) => {
                                                return !obj.ProductName.toLowerCase().includes('alu');
                                            });
                                        }
                                        else {
                                            available.Unterkonstruktion = available.Unterkonstruktion.filter((obj) => {
                                                return !obj.ProductName.toLowerCase().includes('alu');
                                            });
                                        }
                                        //available.Unterkonstruktion = available.Unterkonstruktion.filter((obj) => {
                                        //});
                                    }


                                }
                                available.Ladestation = this.mapItem(this.state.Products.Ladestation, vdType);
                                available.Glasschiebeelemente = this.mapItem(this.state.Products.Glasschiebeelemente, vdType.replace(" Alu", "").replace("Solar-", ""), false, parseFloat(this.state.Deepth), false, true);
                                available.Senkrechtmarkise = this.mapItem(this.state.Products.Senkrechtmarkise, "", parseFloat(this.state.Width), false, false, true);
                                available.SolarModul = this.mapItem(this.state.Products.SolarModule, vdType);
                                available.Windschutz = this.mapItem(this.state.Products.Windschutz, vdType.replace(" Alu", "").replace("Solar-", ""));
                                available.Zubehoer = this.mapItem(this.state.Products.Zubehoer, vdType.replace(" Alu", "").replace("Solar-", ""));
                                available.Befestigungsmaterial = this.mapItem(this.state.Products.Befestigungsmaterial, "");
                                available.Montage = this.mapItem(this.state.Products.Montage, vdType.replace(" Alu", ""), false, false, false, false, false, true);
                                available.LED = this.mapItem(this.state.Products.LED, "");
                                available.Heizstrahler = this.mapItem(this.state.Products.Heizstrahler, "");

                                if (vdType.endsWith("Alu")) {
                                    available.Unterdachmarkise = this.mapItem(this.state.Products.Unterdachmarkise, "", Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))), parseFloat(this.state.Deepth));
                                    if (!available.Unterdachmarkise[0].ProductName.toLowerCase().includes('ohne')) {
                                        available.Unterdachmarkise = available.Unterdachmarkise.reverse();
                                    }
                                } else {
                                    available.Unterdachmarkise = this.mapItem(this.state.Products.Unterdachmarkise, "", Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.SubPieces))), parseFloat(this.state.Deepth));
                                    if (!available.Unterdachmarkise[0].ProductName.toLowerCase().includes('ohne')) {
                                        available.Unterdachmarkise = available.Unterdachmarkise.reverse();
                                    }
                                }

               this.state.Products.Maut.map((item, key) => {
                    if (item.CanopyType === "Terrasenueberdachung") {
                        selected.Maut = item;
                        this.setState({
                            selected: selected,
                        })
                    }
                });

                this.state.Products.Kanten.map((item, key) => {
                    if (item.CanopyType === "Terrasenueberdachung") {
                        selected.Kanten = item;
                        this.setState({
                            selected: selected,
                        })
                    }
                });

                            if (vdType !== "Solar-Terrassenüberdachung") {
                                available.Keilfenster = this.mapItem(this.state.Products.Keilfenster, "", false, parseFloat(this.state.Deepth));
                            }
                            if (vdType === "Solar-Terrassenüberdachung") {
                                available.Ladestation = this.mapItem(this.state.Products.Ladestation, "");
                                available.StromSpeicher = this.mapItem(this.state.Products.StromSpeicher, "");
                                available.Wechselrichter = this.mapItem(this.state.Products.Wechselrichter, "");
                            }
                                //if (vdType.includes("Alu")) {
                                //    var polycarb = {
                                //        Id: "Polycarb",
                                //        ProductType: "Glas",
                                //        ProductName: "Polycarbonat",
                                //        ProductDescription: "",
                                //        GlasType: "Polycarbonat",
                                //        CanopyType: "Terrassenüberdachung",
                                //        Min_Deepth: "0",
                                //        Max_Deepth: "0",
                                //        Min_Width: "0",
                                //        Max_Width: "0",
                                //        Strength: "0",
                                //        Fittings: "0",
                                //        Amount: "0",
                                //        Price: "80",
                                //        CalcPrice: "0",
                                //        IMG: "https://glasvordach.de/wp-content/uploads/2020/06/Polycarbonat.jpg",
                                //        Weight: null
                                //    }
                                //    available.Glas.unshift(polycarb);
                                //}

                                
                            this.setState({
                                available: available
                            }, () => {
                                if (!this.state.selectedCheapest) {
                                        this.selectCheapest();
                                    }
                            })
                                this.calcPrice();
                        })
                    }
                })
            }
            else if (this.props.wpObject.type.replace(" Alu", "") === "Terrassenüberdachung" ||
                this.props.wpObject.type === "Solar-Terrassenüberdachung") {
                this.state.Products.TerUeb.map((item, key) => {
                    if (Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                        Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width) &&
                        parseFloat(this.state.Deepth) <= parseFloat(item.Max_Deepth) &&
                        parseFloat(this.state.Deepth) >= parseFloat(item.Min_Deepth)) {
                        selected.Vordach = item;
                        selected.Vordach.CanopyType = this.props.wpObject.type;

                        this.setState({
                            selected: selected,
                        }, () => {
                                var available = {
                                    Vordach: [],
                                Montage: [],
                                Glas: [],
                                Beschlag: [],
                                ZubTerUeb: [],
                                ZubVord: [],
                                ZubAlg: [],
                                Zubehoer: [],
                                Befestigungsmaterial: [],
                                Dachrahmen: [],
                                Optik: [],
                                Regenrinne: [],
                                Solarmodul: [],
                                Unterkonstruktion: [],
                                Unterdachmarkise: [],
                                Aufbau: [],
                                LED: [],
                                Keilfenster: [],
                                Heizstrahler: [],
                                Glasschiebeelemente: [],
                                Seitenteil: [],
                                Traegerart: [],
                                Abdeckung: [],
                                    Seitenelemente: [],
                                    Geraeteraum: [],
                                    StromSpeicher: [],
                                    Glasschiebeelemente: [],
                            };

                            var vdType = this.props.wpObject.type;

                                available.Glas = this.mapItem(this.state.Products.Glas, vdType.replace(" Alu", ""));
                                available.Aufbau = this.mapItem(this.state.Products.Aufbau, "");

                                if (vdType === ("Solar-Terrassenüberdachung") && parseFloat(this.state.Deepth) < 5001) {
                                    available.Unterkonstruktion = this.mapItem(this.state.Products.Unterkonstruktion, "Alu", false, false, false, false, "color");
                                }
                                else if (vdType === ("Solar-Terrassenüberdachung") && parseFloat(this.state.Deepth) > 5000) {
                                    available.Unterkonstruktion = this.mapItem(this.state.Products.Unterkonstruktion, "Solar", false, false, false, false, "color");
                                    available.Unterkonstruktion = available.Unterkonstruktion.filter((obj) => {
                                        return obj.ProductName !== 'Aluminium';
                                    });
                                }
                                else if (vdType !== "Solar-Terrassenüberdachung"){
                                    available.Unterkonstruktion = this.mapItem(this.state.Products.Unterkonstruktion, "", false, false, false, false, "color");
                                    available.Unterkonstruktion = available.Unterkonstruktion.filter((obj) => {
                                        return obj.CanopyType !== 'Solar';
                                    });
                                }
                                available.Senkrechtmarkise = this.mapItem(this.state.Products.Senkrechtmarkise, "", parseFloat(this.state.Width), false, false, true);

                                available.Unterdachmarkise = this.mapItem(this.state.Products.Unterdachmarkise, "", Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))), parseFloat(this.state.Deepth));
                                available.Ladestation = this.mapItem(this.state.Products.Ladestation, vdType);
                                available.Glasschiebeelemente = this.mapItem(this.state.Products.Glasschiebeelemente, vdType.replace(" Alu", "").replace("Solar-", ""), false, parseFloat(this.state.Deepth), false, true);
                                available.SolarModul = this.mapItem(this.state.Products.SolarModule, vdType);
                                available.Windschutz = this.mapItem(this.state.Products.Windschutz, vdType.replace(" Alu", "").replace("Solar-", ""));
                                available.Zubehoer = this.mapItem(this.state.Products.Zubehoer, vdType.replace(" Alu", "").replace("Solar-", ""));
                                available.Befestigungsmaterial = this.mapItem(this.state.Products.Befestigungsmaterial, "");
                                available.Montage = this.mapItem(this.state.Products.Montage, vdType.replace(" Alu", ""), false, false, false, false, false, true);
                                available.LED = this.mapItem(this.state.Products.LED, "");
                                available.Heizstrahler = this.mapItem(this.state.Products.Heizstrahler, "");


                            this.state.Products.Maut.map((item, key) => {
                    if (this.deUmlaut(item.CanopyType) === "Terrassenueberdachung") {
                        selected.Maut = item;
                        this.setState({
                            selected: selected,
                        })
                    }
                });

                this.state.Products.Kanten.map((item, key) => {
                    if (this.deUmlaut(item.CanopyType) === "Terrassenueberdachung") {
                        selected.Kanten = item;
                        this.setState({
                            selected: selected,
                        })
                    }
                });

                             if (vdType !== "Solar-Terrassenüberdachung") {
                                available.Keilfenster = this.mapItem(this.state.Products.Keilfenster, "", false, parseFloat(this.state.Deepth));
                            }
                            if (vdType === "Solar-Terrassenüberdachung") {
                                available.Ladestation = this.mapItem(this.state.Products.Ladestation, "");
                                available.StromSpeicher = this.mapItem(this.state.Products.StromSpeicher, "");
                                available.Wechselrichter = this.mapItem(this.state.Products.Wechselrichter, "");
                            }


                            this.setState({
                                available: available
                            }, () => {
                                    if (!this.state.selectedCheapest) {
                                        this.selectCheapest();
                                    }
                            })
                                this.calcPrice();
                        })
                    }
                })
            }
        }
    }


    mapItem = (Oitem, vdType, width = false, deepth = false, noType = false, oneTime = false, extension = false, cqm = false) => {
        var newItem = [];
        if (Array.isArray(Oitem)) {
            Oitem.map((item, key) => {
                if (oneTime) {
                    if (deepth || deepth === 0 ) {
                        if (deepth <= parseFloat(item.Max_Deepth) &&
                            deepth >= parseFloat(item.Min_Deepth)) {
                            newItem.push({ ...item });
                        } else {
                            if (newItem.length < 2) {
                                if (newItem.filter(e => e.ProductName !== item.ProductName).length > 2) {
                                    newItem.push({ ...item });
                                } else {
                                    if (newItem.length < 2 && item.ProductName.includes("ohne") || newItem.length < 2 && item.ProductName.includes("Ohne")) {
                                        newItem.push({ ...item });
                                    }
                                }
                            }
                        }
                    }
                }
                if (noType) {
                    if (item.CanopyType === "") {
                        newItem.push({ ...item });
                    }
                }
                if (!width && deepth && !oneTime) {
                    if (deepth <= parseFloat(item.Max_Deepth) &&
                        deepth >= parseFloat(item.Min_Deepth) || item.ProductName.includes("ohne") || item.ProductName.includes("Ohne")) {
                        newItem.push({ ...item });
                    }
                }
                if (width && deepth) {
                    if (item.CanopyType === vdType && width <= parseFloat(item.Max_Width) &&
                        width >= parseFloat(item.Min_Width) &&
                        deepth <= parseFloat(item.Max_Deepth) &&
                        deepth >= parseFloat(item.Min_Deepth) || item.CanopyType === vdType &&
                        item.Min_Deepth === "0" && item.Max_Deepth === "0" &&
                        item.Max_Width === "0" && item.Min_Width === "0") {
                        newItem.push({ ...item });
                    }
                }
                else {
                    if (!deepth && extension === "color" && item.CanopyType !== "Aluminium" && vdType !== "Alu" && vdType !== "Solar") {
                        item.Farben = this.mapItem(this.state.Products.Farbe, item.ProductName)
                        newItem.push({ ...item });
                    }
                    if (!deepth && extension === "color" && item.CanopyType === "Aluminium" && vdType === "Alu") {
                        item.Farben = this.mapItem(this.state.Products.Farbe, item.ProductName)
                        newItem.push({ ...item });
                    }
                    if (!deepth && extension === "color" && item.CanopyType === "Solar" && vdType === "Solar") {
                        item.Farben = this.mapItem(this.state.Products.Farbe, item.ProductName)
                        newItem.push({ ...item });
                    }
                    if (item.CanopyType === vdType && cqm) {
                        var qm = ((parseFloat(this.state.Width) / 1000) * (parseFloat(this.state.Deepth) / 1000)) / parseFloat(this.state.Pieces);
                        if (newItem.length < 2) {
                            if (parseFloat(item.Strength) >= qm || parseFloat(item.Strength) === 0 || item.Strength === "") {
                                newItem.push({ ...item });
                            }
                        }
                    }
                    if (item.CanopyType === vdType && !deepth && !extension && !cqm) {
                        newItem.push({ ...item });
                    }
                }
            });
        }
        return newItem;

    }

    getMarkiseMontage = (type, align = false) => {
        var MPrice = 0;
        if (align) {
            this.state.Products.MontagePrice.map((item, key) => {
                if (item.Min_Width >= this.state.selected[type][align].Min_Width && item.Max_Width <= this.state.selected[type][align].Max_Width) {
                    MPrice = parseFloat(item.Price);
                }
            });
        }
        else {
            this.state.Products.MontagePrice.map((item, key) => {
                if (item.Min_Width >= this.state.selected[type].Min_Width && item.Max_Width <= this.state.selected[type].Max_Width) {
                    MPrice = parseFloat(item.Price);
                }
            });
        }
        return MPrice;
    }


    selectCheapest = () => {
        var available = this.state.available;

        this.setState({
            selectedCheapest: true
        }, () => {

            Object.keys(available).map((item, i) => {
                available[item].map((o) => {
                    var lowestPrice = Math.min(...available[item].map((o) => { return parseFloat(o.Price) }));
                    if (parseFloat(o.Price) === lowestPrice && o.ProductType !== "Vordach" && o.ProductName !== "Farbglas" && o.ProductName !== "Mattglas") {

                        if(this.props.wpObject.type.includes("Alu") && o.ProductType === "Glas"){
                            var klarglas = { "Id": "542", "ProductType": "Glas", "ProductName": "Klarglas", "ProductDescription": "", "GlasType": "Klarglas", "CanopyType": "Terrassenüberdachung", "Min_Deepth": "0", "Max_Deepth": "0", "Min_Width": "0", "Max_Width": "0", "Strength": "12", "Fittings": "0", "Amount": "0", "Price": "46.5", "CalcPrice": "0", "IMG": "https://glasvordach.de/wp-content/uploads/2020/04/Klarglas.jpg", "Weight": null }
                            this.select(klarglas)
                        }
                        else {
                            if (this.props.wpObject.type === "Zugstangenvordach" && !o.ProductName.includes("ueber") || this.props.wpObject.type !== "Zugstangenvordach")
                            {
                              this.select(o);
                            }
                        }
                    }
                })
            })
            var lowestPrice = 0;

            lowestPrice = Math.min(...this.state.Products.TechnischeZeichnung.map((o) => { return parseFloat(o.Price) }));
            this.state.Products.TechnischeZeichnung.map((i) => {
                if (parseFloat(i.Price) === lowestPrice) {
                    this.select(i);
                }
            })
        })
    }

    unselectItem = (item) => {
        if (item !== "") {
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = 'unset';
            }
        }
    }

    unselectAll = () => {
        document.getElementById(this.state.selected.Glas.Id).style.border = 'unset';
        document.getElementById(this.state.selected.TechnischeZeichnung.Id).style.border = 'unset';
        document.getElementById(this.state.selected.Montage.Id).style.border = 'unset';
        document.getElementById(this.state.selected.Beschlag.Id).style.border = 'unset';
        document.getElementById(this.state.selected.Befestigungsmaterial.Id).style.border = 'unset';
        document.getElementById(this.state.selected.ZubAlg.Id).style.border = 'unset';
        document.getElementById(this.state.selected.ZubVord.Id).style.border = 'unset';
        document.getElementById(this.state.selected.ZubTerUeb.Id).style.border = 'unset';
    }

    selectAll = () => {
        document.getElementById(this.state.selected.Glas.Id).style.border = '5px solid #ef9839';
        document.getElementById(this.state.selected.TechnischeZeichnung.Id).style.border = '5px solid #ef9839';
        document.getElementById(this.state.selected.Montage.Id).style.border = '5px solid #ef9839';
        document.getElementById(this.state.selected.Beschlag.Id).style.border = '5px solid #ef9839';
        document.getElementById(this.state.selected.Befestigungsmaterial.Id).style.border = '5px solid #ef9839';
        document.getElementById(this.state.selected.ZubAlg.Id).style.border = '5px solid #ef9839';
        document.getElementById(this.state.selected.ZubVord.Id).style.border = '5px solid #ef9839';
        document.getElementById(this.state.selected.ZubTerUeb.Id).style.border = '5px solid #ef9839';
    }

    reset = (c) => {

        switch (c) {
            case "GSE":
                this.setState({
                    GlasschiebeelementAmount: 0,
                    GlasschiebeelementAmountRight: 0,
                    GlasschiebeelementAmountLeft: 0,
                    GSL: false,
                    GSR: false,
                    GSV: false,
                })
                break;
            case "KF":
                this.setState({
                    KFL: false,
                    KFR: false,
                    KFB: false,
                })
                break;
        }
    }

    productPrice = (product, type) => {
        var Aufschlag = this.state.Aufschlag;
        switch (type) {
            case "Glas":

                this.state.available.Glas.map((o) => {
                    if (o.Strength === this.state.selected.Vordach.Strength ) {
                        if (o.ProductName === "Klarglas") {
                            Aufschlag.Klarglas = o.Price
                            Aufschlag.Klarglas = ((parseFloat(Aufschlag.Klarglas) - parseFloat(this.state.selected.Glas.Price)) * this.state.MwSt).toFixed(2);
                        }
                        if (o.ProductName === "Milchglas") {
                            Aufschlag.Milchglas = o.Price
                            Aufschlag.Milchglas = ((parseFloat(Aufschlag.Milchglas) - parseFloat(this.state.selected.Glas.Price)) * this.state.MwSt).toFixed(2);
                        }
                        if (o.ProductName === "Farbglas") {
                            Aufschlag.Farbglas = o.Price
                            Aufschlag.Farbglas = ((parseFloat(Aufschlag.Farbglas) - parseFloat(this.state.selected.Glas.Price)) * this.state.MwSt).toFixed(2);
                        }
                        if (o.ProductName === "Mattglas") {
                            Aufschlag.Mattglas = o.Price
                            Aufschlag.Mattglas = ((parseFloat(Aufschlag.Mattglas) - parseFloat(this.state.selected.Glas.Price)) * this.state.MwSt).toFixed(2);
                        }
                    }
                })

                
                this.setState({
                    Aufschlag: Aufschlag,
                })
                break;
            case "Regenrinne":

                Aufschlag.Regenrinne = (parseFloat(this.state.available.Regenrinne[1].Price) * this.state.MwSt).toFixed(2);

                this.setState({
                    Aufschlag: Aufschlag,
                })
                break;

           case "Montage":
            
                var Montage = { Price: 0 };
                    if(this.state.available.Montage[1] !== undefined){
                    Montage.Price = parseFloat(this.state.available.Montage[1].Price);
                    }
                    if(this.state.selected.Unterdachmarkise !== ""){
                        Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Unterdachmarkise.Price) * 0.1)
                    }                
                    if (this.state.selected.Keilfenster !== "") {
                        Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Keilfenster.Price) * 0.2)
                    }
                    if (this.state.selected.LED !== "" && !this.state.selected.LED.ProductName.includes("Ohne")) {
                        var LEDAmount = this.state.LEDAmount;
                        Montage.Price = parseFloat(Montage.Price) +  (parseFloat(LEDAmount) * 10)
                    }            
                    if (this.state.selected.Glasschiebeelemente !== ""){
                        if (this.state.selected.Glasschiebeelemente.links !== "" && this.state.selected.Glasschiebeelemente.links.Price !== undefined) {
                        Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Glasschiebeelemente.links.Price) * 0.2)
                    }
                        if (this.state.selected.Glasschiebeelemente.rechts !== "" && this.state.selected.Glasschiebeelemente.rechts.Price !== undefined) {
                        Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Glasschiebeelemente.rechts.Price) * 0.2)
                    }
                        if (this.state.selected.Glasschiebeelemente.vorne !== "" && this.state.selected.Glasschiebeelemente.vorne.Price !== undefined) {
                        Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Glasschiebeelemente.vorne.Price) * 0.2)
                    }}

                Aufschlag.Montage = (parseFloat(Montage.Price) * this.state.MwSt).toFixed(2);

    

                this.setState({
                    Aufschlag: Aufschlag,
                })
                break;


        }
    }

    selectColor = (item) => {

        var selected = this.state.selected;


        if (this.state.selected.Unterkonstruktion !== "") {

            if (item.CanopyType === "Aluminium" && this.state.selected.Unterkonstruktion.ProductName === item.CanopyType) {
                if (this.state.selected.Farbe !== undefined) {
                    this.unselectItem(this.state.selected.Farbe);
                }
                if (document.getElementById(item.Id)) {
                    document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
                selected.Farbe = item;
            }


            if (item.CanopyType === "Stahl verzinkt und gepulvert" && this.state.selected.Unterkonstruktion.ProductName === item.CanopyType) {
                if (this.state.selected.Farbe !== undefined) {
                this.unselectItem(this.state.selected.Farbe);
                }
                if (document.getElementById(item.Id)) {
                    document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
                selected.Farbe = item;
            }
        }

        if (this.state.selected.Beschlag !== "") {
            if (this.state.selected.Beschlag.ProductName.includes("pulverbeschichtet")) {
                if (this.state.selected.Beschlag.Farbe !== undefined) {
                    this.unselectItem(this.state.selected.Beschlag.Farbe);
                }
                if (document.getElementById(item.Id)) {
                    document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
                selected.Beschlag.Farbe = item;
            }
        }

        if (this.state.selected.Beschlag !== "") {
            if (this.state.selected.Beschlag.ProductName.includes("Pulverbeschichtung")) {
                if (this.state.selected.Beschlag.Farbe !== undefined) {
                    this.unselectItem(this.state.selected.Beschlag.Farbe);
                }
                if (document.getElementById(item.Id)) {
                    document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
                selected.Beschlag.Farbe = item;
            }
        }

        this.setState({
            selected: selected,
        }, () => {
            this.calcPrice();
        })
    }

    reselect = (item) => {
        this.setState({
            downloadLink: ""
        })
        var selected = this.state.selected;
        selected.Glas = item;

        this.setState({
            selected: selected
        })
    }

    select = (item) => {
        this.setState({
            downloadLink: ""
        })
        var selected = this.state.selected;
        var available = this.state.available;

        if (item.ProductType === "SolarType") {
            selected.SolarType = item;
        }

        if (item.ProductType === "Schuppen") {
            selected.Schuppen = item;
        }

        if (item.ProductType === "Glas") {
            if (this.state.selected.Glas !== "" && this.props.wpObject.type !== "Solar-Terrassenüberdachung") {
                if (document.getElementById(this.state.selected.Glas.Id)) {
                    this.unselectItem(this.state.selected.Glas);
                    if (document.getElementById(this.state.selected.Glas.Id)) {
                        document.getElementById(item.Id).style.border = '5px solid #ef9839';
                    }
                }
            }
            if (this.props.wpObject.type !== "Solar-Terrassenüberdachung") {
            }

            this.unselectItem(this.state.selected.Glas);
            if (document.getElementById(this.state.selected.Glas.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }

            selected.Glas = item;

        }


        if (item.ProductType === "Solarmodul") {
            selected.SolarModul = item;
        }

        if (item.ProductType === "Keilfenster") {
            if (item.ProductName.toLowerCase() === "ohne keilfenster") {
                this.reset("KF");
                if (document.getElementById(item.Id) && this.props.wpObject.type !== "Solar-Terrassenüberdachung") {
                }
                selected.Keilfenster = item;
            }
            else {
                if (document.getElementById(item.Id) && this.props.wpObject.type !== "Solar-Terrassenüberdachung") {
                }
            }
        }

        if (item.ProductType === "Glasschiebeelemente") {
            if (item.ProductName.toLowerCase() === "ohne glasschiebeelemente") {
                if (document.getElementById(item.Id) && this.props.wpObject.type !== "Solar-Terrassenüberdachung") {
                    if (this.state.GSE) {
                        document.getElementById(this.state.GSE.links.Id.replace("L", "")).style.border = 'unset';
                    }
                    document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
                selected.Glasschiebeelemente.vorne = item;
                selected.Glasschiebeelemente.links = item;
                selected.Glasschiebeelemente.rechts = item;
            }
            else if (item.Position === "Vorne" )
            {
                selected.Glasschiebeelemente.vorne = item;
            }
            else if ( item.Position === "Links" )
                {
                selected.Glasschiebeelemente.links = item;
            }
            else if ( item.Position === "Rechts" )
                {
                selected.Glasschiebeelemente.rechts = item;
            }
            else {
                if (document.getElementById(item.Id) && this.props.wpObject.type !== "Solar-Terrassenüberdachung") {
                    this.unselectItem(this.state.Products.Glasschiebeelemente[0]);
                    document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
            }
        }

        if (item.ProductType === "Senkrechtmarkise") {
            if (item.ProductName.toLowerCase() === "ohne senkrechtmarkise") {
                if (document.getElementById(item.Id) && this.props.wpObject.type !== "Solar-Terrassenüberdachung") {
                    if (this.state.GSE) {
                        document.getElementById(this.state.GSE.links.Id.replace("L", "")).style.border = 'unset';
                    }
                    document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
                selected.Senkrechtmarkise.vorne = item;
                selected.Senkrechtmarkise.links = item;
                selected.Senkrechtmarkise.rechts = item;
            }
            else if (item.Position === "Vorne") {
                selected.Senkrechtmarkise.vorne = item;
            }
            else if (item.Position === "Links") {
                selected.Senkrechtmarkise.links = item;
            }
            else if (item.Position === "Rechts") {
                selected.Senkrechtmarkise.rechts = item;
            }
            else {
                if (document.getElementById(item.Id) && this.props.wpObject.type !== "Solar-Terrassenüberdachung") {
                    this.unselectItem(this.state.Products.Glasschiebeelemente[0]);
                    document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
            }
        }
        
        if (item.ProductType === "Technische Zeichnung") {
            this.unselectItem(this.state.selected.TechnischeZeichnung);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.TechnischeZeichnung = item;
        }

        if (item.ProductType === "Abdeckung") {
            this.unselectItem(this.state.selected.Abdeckung);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Abdeckung = item;
        }

        if (item.ProductType === "Wechselrichter") {
                this.unselectItem(this.state.selected.Wechselrichter);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            
            selected.Wechselrichter = item;
        }

        if (item.ProductType === "Optik") {
            this.unselectItem(this.state.selected.Optik);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
            selected.Optik = item;
        }

        if (item.ProductType === "Traegerart") {
            this.unselectItem(this.state.selected.Traegerart);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Traegerart = item;
        }

        if (item.ProductType === "Seitenteil") {
            this.unselectItem(this.state.selected.Seitenteil);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }

            selected.Seitenteil = item;
        }
        if (item.ProductType === "Ladestation") {
                this.unselectItem(this.state.selected.Ladestation);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
            
            selected.Ladestation = item;
        }
        if (item.ProductType === "Stromspeicher") {
                this.unselectItem(this.state.selected.StromSpeicher);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
                }
            
            selected.StromSpeicher = item;
        }
        if (item.ProductType === "Montage" ) {
            this.unselectItem(this.state.selected.Montage);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Montage = item;
        }

        if (item.ProductType === "Beschlag") {
            this.unselectItem(this.state.selected.Beschlag);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Beschlag = item;
        }

        if (item.ProductType === "Farbe") {
            this.unselectItem(this.state.selected.Farbe);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Farbe = item;
        }

        if (item.ProductType === "Befestigungsmaterial") {
            this.unselectItem(this.state.selected.Befestigungsmaterial);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Befestigungsmaterial = item;
        }
        if (item.ProductType === "Zubehoer_Alg") {
            this.unselectItem(this.state.selected.ZubAlg);
            if (document.getElementById(item.Id)) {
            }
            selected.ZubAlg = item;
        }
        if (item.ProductType === "Zubehoer_Vordach") {
            this.unselectItem(this.state.selected.ZubVord);
            if (document.getElementById(item.Id)) {
            }
            selected.ZubVord = item;
        }
        if (item.ProductType === "Zubehoer_Terrasenueberdachung") {
            this.unselectItem(this.state.selected.ZubTerUeb);
            if (document.getElementById(item.Id)) {
            }
            selected.ZubTerUeb = item;
        }
        if (item.ProductType === "Regenrinne") {
            this.unselectItem(this.state.selected.Regenrinne);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Regenrinne = item;
        }
        if (item.ProductType === "Unterkonstruktion") {
            this.unselectItem(this.state.selected.Unterkonstruktion);

            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Unterkonstruktion = item;
        }

        if (item.ProductType === "Unterdachmarkise") {
            this.unselectItem(this.state.selected.Unterdachmarkise);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Unterdachmarkise = item;
        }

        if (item.ProductType === "LED") {
            this.unselectItem(this.state.selected.LED);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.LED = item;
        }

        if (item.ProductType === "Heizstrahler") {
            this.unselectItem(this.state.selected.Heizstrahler);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Heizstrahler = item;
        }
        if (item.ProductType === "Aufbau") {
            this.unselectItem(this.state.selected.Aufbau);
            if (document.getElementById(item.Id)) {
                document.getElementById(item.Id).style.border = '5px solid #ef9839';
            }
            selected.Aufbau = item;
        }

        this.setState({
            selected: selected,
            available: available,
        }, () => {
                this.selectVordach();
                this.calcPrice();
        })

    }

    handleWidthAgain = (width, pieces) => {

        if ((parseFloat(width) / pieces) >= 3001 && this.props.wpObject.type.toLowerCase().includes("vordach") ) {
            pieces = pieces + 1;
            this.handleWidthAgain(width, pieces);
        }
        else if ((parseFloat(width) / pieces) >= 10001 && this.props.wpObject.type.toLowerCase().includes("terrassen")) {
            pieces = pieces + 1;
            this.handleWidthAgain(width, pieces);
        }
        else {
            this.setState({
                Width: width,
                Pieces: pieces,
            }, () => {
                this.handleQm();
            })
        }

    }

    handleWidth = (event) => {

        var width = event.target.value !== "" ? parseFloat(event.target.value) * 1000 : event.target.value;
        var pieces = parseFloat(this.state.Pieces);
        var selected = this.state.selected;

        selected.Input.width = width;

        if (width === "") {
            this.setState({
                Width: width,
                selected: selected,
                Module: {}
            })
        }

        if (parseFloat(width) < 10001 && pieces < 2) {
            this.setState({
                Width: width,
                Pieces: pieces,
                selected: selected,
            }, () => {
                this.handleQm();
            })
        }
        else if (parseFloat(width) < 10001 && pieces > 1) {
            pieces = 1;
            this.setState({
                Width: width,
                Pieces: pieces,
                selected: selected,
            }, () => {
                this.handleQm();
            })
        }
        else if ((parseFloat(width) / pieces) >= 10001) {
            this.handleWidthAgain(width, pieces);
        }

        if (parseFloat(width) < 3001 && pieces < 2 && this.props.wpObject.type.toLowerCase().includes("vordach")) {
            this.setState({
                Width: width,
                Pieces: pieces,
                selected: selected,
            }, () => {
                this.handleQm();
            })
        }
        else if (parseFloat(width) < 3001 && pieces > 1 && this.props.wpObject.type.toLowerCase().includes("vordach")) {
            pieces = 1;
            this.setState({
                Width: width,
                Pieces: pieces,
                selected: selected,
            }, () => {
                this.handleQm();
            })
        }
        else if ((parseFloat(width) / pieces) >= 3001 && this.props.wpObject.type.toLowerCase().includes("vordach")) {
            this.handleWidthAgain(width, pieces);
        }
    }

    handleBlur (c,event){
        switch(c){
            case "Deepth":
                var deepth = event.target.value === "" ? 0 : parseFloat(event.target.value) * 1000;
                var selected = this.state.selected;

                selected.Input.deepth = deepth;

        if(parseInt(deepth) < parseInt(this.state.VordachMinDeepth)){
        deepth = this.state.VordachMinDeepth;
        }

        if(parseInt(deepth) > parseInt(this.state.VordachMaxDeepth)){
        deepth = this.state.VordachMaxDeepth;
        }

        this.setState({
            Deepth: deepth,
            selected: selected,
        }, () => {
                this.handleQm();
        })
        break;
            case "Width":
                var width = event.target.value !== "" ? parseFloat(event.target.value) * 1000 : 0;
                var selected = this.state.selected;
                selected.Input.width = width;

        if(parseInt(width) < parseInt(this.state.VordachMinWidth)){
        width = this.state.VordachMinWidth;
        }

                if (parseInt(width) > parseInt(this.state.VordachMaxWidth)) {
                    width = width = this.state.Width;
                }

        this.setState({
            Width: width,
            selected: selected,
            }, () => {
                this.handleQm();
        })
        break;
        }
    }

    handleDeepth = (event) => {

        var deepth = parseFloat(event.target.value)*1000;
        var selected = this.state.selected;

        selected.Input.deepth = deepth;

        this.setState({
            Deepth: deepth,
            selected: selected,
                Module: {}
        }, () => {
                this.handleQm();
        })
    }

    handleQm = () => {
        var qm = (parseFloat(this.state.Width) / 1000) * (parseFloat(this.state.Deepth) / 1000);
        this.setState({
            qm:qm
        }, () => {
                this.selectVordach();
                this.calcPrice();
        })
    }

        handlePieces = (event) => {
            this.setState({
                Pieces: event.target.value,
            })
        }

    calcPriceVP = () => {
        if (this.props.wpObject.type.toLowerCase().includes("solar")) {
            var allGlas = [...this.state.Products.Glas];
            var Glas = {}
            var allVordach = [...this.state.Products.TerUeb];
            var Vordach = {};
            var Unterdachmarkise = [...this.state.available.Unterdachmarkise];
            var Montage = { Price: 0 };
            var width = this.state.Width;
            var deepth = this.state.Deepth;
            var qm = ((parseFloat(width) / 1000) * (parseFloat(deepth) / 1000));
            var Unterkonstruktion = {
                ProductName: "Stahl"
            };

            allGlas.map((item, key) => {
                if (item.GlasType === "Klarglas" && item.CanopyType === "Terrassenüberdachung") {
                    Glas = item;
                }
                else return;
            })


            if (parseFloat(this.state.Deepth) < 5001) {
                Unterkonstruktion.ProductName = "Alu"
                allVordach.map((item, key) => {
                    if (Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) <= parseFloat(item.Max_Width) &&
                        Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))) >= parseFloat(item.Min_Width) &&
                        parseFloat(this.state.Deepth) <= parseFloat(item.Max_Deepth) &&
                        parseFloat(this.state.Deepth) >= parseFloat(item.Min_Deepth) &&
                        item.ProductName.endsWith("Alu") && item.GlasType === "Klarglas" &&
                        item.ProductName.endsWith("Alu")) {

                        Vordach = item;
                    }
                });
            }
            else {
                Vordach = { ...this.state.selected.Vordach }
            }

            Unterdachmarkise = Unterdachmarkise.filter((el) => { return !el.ProductName.toLowerCase().includes("ohne"); });
            Unterdachmarkise = Unterdachmarkise[0];

            var thePrice = parseFloat(Vordach.Price);
            var thePriceB = thePrice;


            var GlasPrice = parseFloat(Glas.Price) + (parseFloat(Glas.Strength) * 2.5 * parseFloat(this.state.selected.Maut.Price)) + parseFloat(this.state.selected.Kanten.Price);
            if (this.state.selected.Unterkonstruktion !== "") {
                if (Unterkonstruktion.ProductName.includes("Stahl") || Unterkonstruktion.ProductName.includes("Edelstahl")) {
                    thePrice = thePrice + GlasPrice
                    thePrice = (thePrice * (qm / parseFloat(this.state.Pieces))) * parseFloat(this.state.Pieces);
                    thePriceB = thePrice
                }
                if (this.state.selected.Farbe !== "" && this.state.selected.Farbe !== undefined) {
                    thePrice = thePrice + parseFloat(this.state.selected.Farbe.Price);
                }
            }
            if (Unterdachmarkise !== undefined) {
                thePrice = thePrice + (parseFloat(Unterdachmarkise.Price));
                thePriceB = thePriceB + (parseFloat(Unterdachmarkise.Price))
               

            if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                Montage.Price = parseFloat(Montage.Price) + ((parseFloat(Unterdachmarkise.Price) * 0.1) * parseFloat(this.state.Pieces))
                }
            }

            if (this.state.selected.Keilfenster !== "") {
                thePrice = thePrice + (parseFloat(this.state.selected.Keilfenster.Price) * parseFloat(this.state.selected.Keilfenster.Amount))
                if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                    Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Keilfenster.Price) * 0.2)
                }
            }


            if (this.state.selected.TechnischeZeichnung !== "") {
                thePrice = thePrice + parseFloat(this.state.selected.TechnischeZeichnung.Price)
            }
            if (this.state.selected.Befestigungsmaterial !== "" && this.state.selected.Aufbau.ProductName !== "Freistehend") {
                var calcedPrice = Math.ceil((parseFloat(this.state.Width) / 700)) * parseFloat(this.state.selected.Befestigungsmaterial.Price);
                thePrice = thePrice + calcedPrice;
            }

            if (this.state.selected.LED !== "") {
                var LEDAmount = this.state.LEDAmount;
                if (LEDAmount === "" || LEDAmount === null || LEDAmount === undefined) {
                    LEDAmount = 1
                }
                thePrice = thePrice + (parseFloat(this.state.selected.LED.Price) * parseFloat(LEDAmount))
                if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage" && !this.state.selected.LED.ProductName.toLowerCase().includes('ohne')) {
                    Montage.Price = parseFloat(Montage.Price) + (parseFloat(LEDAmount) * 10)
                }
            }

            if (this.state.selected.Heizstrahler !== "") {
                var HeizstrahlerAmount = this.state.HeizstrahlerAmount;
                if (HeizstrahlerAmount === "" || HeizstrahlerAmount === null || HeizstrahlerAmount === undefined) {
                    HeizstrahlerAmount = 1
                }
                thePrice = thePrice + (parseFloat(this.state.selected.Heizstrahler.Price) * parseFloat(HeizstrahlerAmount))
            }
            if (this.state.selected.Aufbau !== "") {
                thePrice = thePrice * (parseFloat(this.state.selected.Aufbau.Price) !== 0 ? parseFloat(this.state.selected.Aufbau.Price) : 1)
            }

            if (this.state.selected.Glasschiebeelemente.links !== undefined && this.state.selected.Glasschiebeelemente.links !== "") {
                thePrice = thePrice + parseFloat(this.state.selected.Glasschiebeelemente.links.Price)
                if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                    Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Glasschiebeelemente.links.Price) * 0.2)
                }
            }
            if (this.state.selected.Glasschiebeelemente.rechts !== undefined && this.state.selected.Glasschiebeelemente.rechts !== "") {
                thePrice = thePrice + parseFloat(this.state.selected.Glasschiebeelemente.rechts.Price)
                if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                    Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Glasschiebeelemente.rechts.Price) * 0.2)
                }
            }

            if (this.state.selected.Glasschiebeelemente.vorne !== undefined && this.state.selected.Glasschiebeelemente.vorne !== "") {
                if (this.props.wpObject.type.endsWith("Alu")) {
                    thePrice = thePrice + (parseFloat(this.state.selected.Glasschiebeelemente.vorne.Price) * parseFloat(this.state.Pieces))
                }
                else {
                    thePrice = thePrice + (parseFloat(this.state.selected.Glasschiebeelemente.vorne.Price) * parseFloat(this.state.SubPieces))
                }

                if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                    Montage.Price = parseFloat(Montage.Price) + ((parseFloat(this.state.selected.Glasschiebeelemente.vorne.Price) * 0.2) * parseFloat(this.state.Pieces))
                }
            }

            if (this.state.selected.Senkrechtmarkise.links !== undefined && this.state.selected.Senkrechtmarkise.links !== "") {
                thePrice = thePrice + (parseFloat(this.state.selected.Senkrechtmarkise.links.Price) * parseFloat(this.state.SMSidePieces));
                if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                    let MarkiseMontage = this.getMarkiseMontage("Senkrechtmarkise", "links");
                    Montage.Price = parseFloat(Montage.Price) + parseFloat(MarkiseMontage);
                }
            }
            if (this.state.selected.Senkrechtmarkise.rechts !== undefined && this.state.selected.Senkrechtmarkise.rechts !== "") {
                thePrice = thePrice + (parseFloat(this.state.selected.Senkrechtmarkise.rechts.Price) * parseFloat(this.state.SMSidePieces))
                if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                    let MarkiseMontage = this.getMarkiseMontage("Senkrechtmarkise", "rechts");
                    Montage.Price = parseFloat(Montage.Price) + parseFloat(MarkiseMontage);
                }
            }


            if (this.state.selected.Senkrechtmarkise.vorne !== undefined && this.state.selected.Senkrechtmarkise.vorne !== "") {
                if (this.props.wpObject.type.endsWith("Alu")) {
                    thePrice = thePrice + (parseFloat(this.state.selected.Senkrechtmarkise.vorne.Price) * parseFloat(this.state.SMPieces))
                }
                else {
                    thePrice = thePrice + (parseFloat(this.state.selected.Senkrechtmarkise.vorne.Price) * parseFloat(this.state.SMPieces))
                }

                if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                    let MarkiseMontage = this.getMarkiseMontage("Senkrechtmarkise", "vorne");
                    Montage.Price = parseFloat(Montage.Price) + parseFloat(MarkiseMontage);
                }
            }

            if (Montage !== "" && Montage.ProductName !== "Selbstmontage") {
                thePrice = thePrice + (parseFloat(Montage.Price) * parseFloat(this.state.Pieces))
            }

            var rate = 0
            if (Montage === "") {
                Montage = { Price: 0 };
                rate = ((thePrice - (parseFloat(Montage.Price) * parseFloat(this.state.Pieces))) / 68) * this.state.MwSt;
            }
            else if (Montage !== "") {
                rate = ((thePrice - (parseFloat(Montage.Price) * parseFloat(this.state.Pieces))) / 68) * this.state.MwSt;
            }

            Montage.Price = Montage.Price * parseFloat(this.state.Pieces);

            this.setState({
                MontagePriceVP: Montage,
                PriceVP: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(((thePrice * this.state.MwSt).toFixed(2))).toString(),
                RateVP: ((rate * this.state.MwSt).toFixed(2)).toString().replace(".", ",") + " \u20ac",
                PriceVPBrutto: thePriceB,
            })
        }
        else {
            this.setState({
                MontagePriceVP: 0,
                PriceVP: 0,
                PriceVPBrutto: 0,
                RateVP: 0,
            })
        }
    }

    calcPrice = () => {
        if (this.props.wpObject.type.replace(" Alu", "") !== "Terrassenüberdachung" &&
            this.props.wpObject.type !== "Solar-Terrassenüberdachung" &&
            this.props.wpObject.type !== "Freitragendes Vordach")
        {
            if (this.state.selected.Glas !== "" &&
                this.state.selected.Vordach !== "") {

                this.productPrice(this.state.available.Glas, "Glas")
                this.productPrice(this.state.available.Regenrinne, "Regenrinne")
                this.productPrice(this.state.available.Montage, "Montage")
                
                var round = parseFloat(this.state.Pieces);

                var pieces = parseFloat(this.state.Pieces);
                var width = parseFloat(this.state.Width) / parseFloat(this.state.Pieces);

                
                var deepth = this.state.Deepth;
                var gfp = 1;

                if (gfp === 0 || gfp === undefined) {
                    gfp = 1
                }
            
                var qm = ((parseFloat(width) / 1000) * (parseFloat(deepth) / 1000));
                var qmp = 0;
                var glasAufschlag = 1;

                var weight = (qm * this.state.selected.Glas.Strength) * 2.5

                switch (this.state.selected.Glas.ProductName) {
                    case "Klarglas":
                        glasAufschlag = 1;
                        break;
                    case "Mattglas":
                        glasAufschlag = 1.2;
                        break;
                    case "Farbglas":
                        glasAufschlag = 1.3;
                        break;
                }

                qmp = ((qm * parseFloat(this.state.selected.Glas.Price)) * gfp);



                var kp = (((parseFloat(width) / 1000) * 2) + ((parseFloat(deepth) / 1000) * 2)) * parseFloat(this.state.selected.Kanten.Price)
                var mp = qm * parseFloat(this.state.selected.Vordach.Strength) * 2.5 * parseFloat(this.state.selected.Maut.Price)
                var borp = parseFloat(this.state.selected.Vordach.Fittings) * 2 * parseFloat(this.state.selected.Bohrung.Price)
                var b = parseFloat(this.state.selected.Vordach.Fittings) * parseFloat(this.state.selected.Beschlag.Price)
                var thePrice = qmp + kp + mp + borp + b

                if (this.state.selected.Beschlag !== "") {
                    if (this.state.selected.Beschlag.Farbe !== "" && this.state.selected.Beschlag.Farbe !== undefined) {
                        thePrice = thePrice + parseFloat(this.state.selected.Beschlag.Farbe.Price);
                    }
                }


                if (this.state.selected.Traegerart !== "") {
                    thePrice = thePrice * parseFloat(this.state.selected.Traegerart.Price)
                }

                var thePriceB = thePrice;

                if (this.state.selected.Montage !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.Montage.Price)
                }

                if (this.state.selected.Optik !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.Optik.Price)
                }

                if (this.state.selected.Abdeckung !== "") {
                    thePrice = thePrice + (parseFloat(this.state.selected.Vordach.Fittings) * parseFloat(this.state.selected.Abdeckung.Price))
                }

                if (this.state.selected.TechnischeZeichnung !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.TechnischeZeichnung.Price)
                }
                if (this.state.selected.Befestigungsmaterial !== "") {
                    var amountBefestigung = parseFloat(this.state.selected.Vordach.Fittings) * 2;
                    thePrice = thePrice + (parseFloat(this.state.selected.Vordach.Fittings) * 2 * parseFloat(this.state.selected.Befestigungsmaterial.Price))
                }
                if (this.state.selected.Dachrahmen !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.Dachrahmen.Price)
                }
                if (this.state.selected.Regenrinne !== "") {
                    thePrice = thePrice + (parseFloat(this.state.selected.Regenrinne.Price) * (this.state.Width/1000))
                }

                var Montage = { Price: 0 };
                if (this.state.selected.Montage !== "") {
                    Montage.Price = parseFloat(this.state.selected.Montage.Price);
                }
                var rate = 0
                if (Montage === "") {
                    Montage = { Price: 0 }
                    rate = ((thePrice - parseFloat(Montage.Price)) / 50) * this.state.MwSt;
                }
                else if (Montage !== "") {
                    rate = ((thePrice - parseFloat(Montage.Price)) / 50) * this.state.MwSt;
                }

                Montage.Price = Montage.Price * parseFloat(this.state.Pieces);

                this.setState({
                    Price: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((((thePrice * this.state.MwSt) * parseFloat(pieces)).toFixed(2))).toString(),
                    PriceB: thePriceB,
                    Weight: weight.toFixed(2),
                    Pieces: pieces,
                    MontagePrice: Montage,
                    Rate: ((rate * parseFloat(pieces)).toFixed(2)).toString().replace(".", ",") + " \u20ac",
                    AmountBefestigung: amountBefestigung
                })
            }
        }
        else if (this.props.wpObject.type === "Freitragendes Vordach")
        {
            if (this.state.selected.Vordach !== "") {
                if(this.state.available.Regenrinne.length > 1){
                this.productPrice(this.state.available.Regenrinne, "Regenrinne")
                }
                this.productPrice(this.state.available.Montage, "Montage")

                var round = Math.ceil(parseFloat(this.state.Width) / this.state.VordachMaxWidth);

                var pieces = round;
                var width = parseFloat(this.state.Width) / round;

                //for (var i = 0; i = round; i++) {
                //    if (parseFloat(this.state.Width) > this.state.VordachMaxWidth) {
                //        width = (this.state.Width) / 2;
                //        pieces = pieces + 1;
                //    }
                //}
                var thePrice = parseFloat(this.state.selected.Vordach.Price);
                var deepth = this.state.Deepth;
          
                if (this.state.selected.Beschlag !== "") {
                    thePrice = thePrice * (parseFloat(this.state.selected.Beschlag.Price) >= 1 ? parseFloat(this.state.selected.Beschlag.Price) : 1);
                    if (this.state.selected.Beschlag.Farbe !== "" && this.state.selected.Beschlag.Farbe !== undefined) {
                        thePrice = thePrice + parseFloat(this.state.selected.Beschlag.Farbe.Price);
                    }
                }
                var thePriceB = thePrice;
                if (this.state.selected.Montage !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.Montage.Price)
                }

                if (this.state.selected.Optik !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.Optik.Price)
                }

                if (this.state.selected.TechnischeZeichnung !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.TechnischeZeichnung.Price)
                }

                if (this.state.selected.Befestigungsmaterial !== "") {
                    var amountBefestigung = parseFloat(Math.ceil(parseFloat(this.state.Width) / 300));
                    thePrice = thePrice + (parseFloat(Math.ceil(parseFloat(this.state.Width)/300) * this.state.selected.Befestigungsmaterial.Price))
                }

                if (this.state.selected.Dachrahmen !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.Dachrahmen.Price)
                }
                if (this.state.selected.Optik !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.Optik.Price)
                }

                if (this.state.selected.LED !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.LED.Price)
                }

                if (this.state.selected.Regenrinne !== "") {
                    thePrice = thePrice + (parseFloat(this.state.selected.Regenrinne.Price) * (this.state.Width/1000))
                }

                var Montage = { Price: 0 };
                if (this.state.selected.Montage !== "") {
                    Montage.Price = parseFloat(this.state.selected.Montage.Price);
                }

                var rate = 0

                if (Montage === "") {
                    Montage = { Price: 0 }
                    rate = ((thePrice - parseFloat(Montage.Price)) / 50) * this.state.MwSt;
                }

                else if (Montage !== "") {
                    rate = ((thePrice - parseFloat(Montage.Price)) / 50) * this.state.MwSt;
                }

                Montage.Price = Montage.Price * parseFloat(this.state.Pieces);

                this.setState({
                    Price: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((((thePrice * this.state.MwSt) * parseFloat(pieces)).toFixed(2))).toString(),
                    PriceB: thePriceB,
                    Pieces: pieces,
                    MontagePrice: Montage,
                    Rate: ((rate * parseFloat(pieces)).toFixed(2)).toString().replace(".", ",") + " \u20ac",
                    AmountBefestigung: amountBefestigung
                })
            }
        }
        else {
            var qmAufschlag = 1;
            this.state.QMAufschlag.map((i) => {
                if (parseFloat(i.Max_Width) >= parseFloat(this.state.qm) && parseFloat(i.Min_Width) <= parseFloat(this.state.qm)) {
                qmAufschlag = i.Price;
                this.setState({
                    sqmAufschlag: qmAufschlag
                })
            }
            })
            this.productPrice(this.state.available.Montage, "Montage")

            if (this.state.selected.Vordach !== "" && this.props.wpObject.type.replace(" Alu", "") === "Terrassenüberdachung" || this.state.selected.Vordach !== "" && this.props.wpObject.type === "Solar-Terrassenüberdachung") {
                var width = this.state.Width;
                var deepth = this.state.Deepth;
                var qm = ((parseFloat(width) / 1000) * (parseFloat(deepth) / 1000));
                var thePrice = parseFloat(this.state.selected.Vordach.Price);
                var Montage = { Price: 0 };
                var Kanten = 1;
                this.calcPriceVP();
                if (this.state.selected.Montage !== "") {
                    Montage.Price = parseFloat(this.state.selected.Montage.Price);
                }

                
                if (this.state.selected.Unterkonstruktion !== "") {
                    if (this.state.selected.Glas !== "" && !this.state.selected.Unterkonstruktion.ProductName.includes("Alu") || this.state.selected.Glas !== "" && this.state.selected.Vordach.ProductName.includes("UK") || this.state.selected.Glas !== "" && this.props.wpObject.type.toLowerCase().includes("solar") && !this.state.selected.Unterkonstruktion.ProductName.includes("Alu")) {
                        var GlasPrice = 0;
                        var Module = {...this.state.Module};
                        if (!this.props.wpObject.type.includes("Solar")) {
                            GlasPrice = (qm * parseFloat(this.state.selected.Glas.Price)) + (((qm * parseFloat(this.state.selected.Glas.Strength)) * 2.5) * this.state.selected.Maut.Price) + (2 * ((parseFloat(width) / 1000)) + (2 * ((parseFloat(deepth) / 1000)))) * parseFloat(this.state.selected.Kanten.Price);
                        }
                        else{
                            if(Module.Amount !== undefined){
                                GlasPrice = (Module.Amount.Width * Module.Amount.Deepth) * parseFloat(Module.SinglePrice)
                            }
                            else{
                                GlasPrice = 0;
                            }
                        }
                        if (this.state.selected.Unterkonstruktion.ProductName.includes("Aluminium")) {
                            if (this.state.selected.Aufbau !== "") {
                                thePrice = ((parseFloat(this.state.selected.Vordach.Price) * (parseFloat(this.state.selected.Aufbau.Price) !== 0 ? parseFloat(this.state.selected.Aufbau.Price) : 1)) + GlasPrice) * parseFloat(qmAufschlag);
                            }
                            thePrice = (parseFloat(this.state.selected.Vordach.Price) + GlasPrice) * parseFloat(qmAufschlag);
                        }
                        else {
                            if (this.props.wpObject.type.toLowerCase().includes("solar")) {
                                var thePrice = parseFloat(this.state.selected.Unterkonstruktion.Price);
                                thePrice = (thePrice * (qm / parseFloat(this.state.Pieces))) * parseFloat(this.state.Pieces);
                                if (this.state.selected.Aufbau !== "") {
                                    thePrice = thePrice * (parseFloat(this.state.selected.Aufbau.Price) !== 0 ? parseFloat(this.state.selected.Aufbau.Price) : 1)
                                }
                                thePrice = (thePrice + GlasPrice) * parseFloat(qmAufschlag);
                            }
                            if (!this.props.wpObject.type.toLowerCase().includes("solar")) {
                                GlasPrice = GlasPrice;
                            }
                        }
                    }
                    if (this.state.selected.Unterkonstruktion.ProductName.includes("Stahl") && !this.props.wpObject.type.toLowerCase().includes("solar") || this.state.selected.Unterkonstruktion.ProductName.includes("Edelstahl") && !this.props.wpObject.type.toLowerCase().includes("solar")) {
                        var thePrice = parseFloat(this.state.selected.Unterkonstruktion.Price);
                        if (this.state.selected.Aufbau !== "") {
                            thePrice = thePrice * (parseFloat(this.state.selected.Aufbau.Price) !== 0 ? parseFloat(this.state.selected.Aufbau.Price) : 1)
                        }
                        thePrice = ((thePrice * (qm / parseFloat(this.state.Pieces))) * parseFloat(this.state.Pieces)) + GlasPrice;
                    }
                    if (this.state.selected.Farbe !== "" && this.state.selected.Farbe !== undefined) {
                        thePrice = thePrice + parseFloat(this.state.selected.Farbe.Price);
                    }
                }
                
                if (this.props.wpObject.type.includes("Alu")) {
                    var thePrice = parseFloat(this.state.selected.Vordach.Price) * parseFloat(this.state.Pieces);
                    if (this.state.selected.Aufbau !== "") {
                        thePrice = thePrice * (parseFloat(this.state.selected.Aufbau.Price) !== 0 ? parseFloat(this.state.selected.Aufbau.Price) : 1)
                    }
                }

                var thePriceB = thePrice;

                if (this.state.selected.Unterdachmarkise !== "") {
                    if (this.props.wpObject.type.endsWith("Alu")) {
                        thePrice = thePrice + (parseFloat(this.state.selected.Unterdachmarkise.Price) * parseFloat(this.state.Pieces))
                    }
                    else {
                        thePrice = thePrice + (parseFloat(this.state.selected.Unterdachmarkise.Price) * parseFloat(this.state.SubPieces))
                    }

                    if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                        Montage.Price = parseFloat(Montage.Price) + ((parseFloat(this.state.selected.Unterdachmarkise.Price) * 0.1) * parseFloat(this.state.Pieces))
                    }
                }

                if (this.state.selected.Keilfenster !== "") {
                    thePrice = thePrice + (parseFloat(this.state.selected.Keilfenster.Price) * parseFloat(this.state.selected.Keilfenster.Amount))
                    if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                        Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Keilfenster.Price) * 0.2)
                    }
                }

                
                if (this.state.selected.TechnischeZeichnung !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.TechnischeZeichnung.Price)
                }
                if (this.state.selected.Befestigungsmaterial !== "" && this.state.selected.Aufbau.ProductName !== "Freistehend") {
                    var amountBefestigung = Math.ceil((parseFloat(this.state.Width) / 700));
                    var calcedPrice = Math.ceil((parseFloat(this.state.Width) / 700))*parseFloat(this.state.selected.Befestigungsmaterial.Price);
                    thePrice = thePrice + calcedPrice;
                }
                

                if (this.props.wpObject.type.toLowerCase().includes("solar")) {


                    if (this.state.selected.Ladestation !== "") {
                        thePrice = thePrice + parseFloat(this.state.selected.Ladestation.Price)
                    }
                    if (this.state.selected.Wechselrichter !== "") {
                        thePrice = thePrice + parseFloat(this.state.selected.Wechselrichter.Price)
                    }
                    //if (this.state.selected.StromSpeicher !== "") {
                    //    thePrice = thePrice + parseFloat(this.state.selected.StromSpeicher.Price)
                    //}
                }

                if (this.state.selected.LED !== "") {
                    var LEDAmount = this.state.LEDAmount;
                    if (LEDAmount === "" || LEDAmount === null || LEDAmount === undefined) {
                        LEDAmount = 1
                    }
                    thePrice = thePrice + (parseFloat(this.state.selected.LED.Price) * parseFloat(LEDAmount))
                    if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage" && !this.state.selected.LED.ProductName.toLowerCase().includes('ohne')) {
                        Montage.Price = parseFloat(Montage.Price) + (parseFloat(LEDAmount) * 10)
                    }
                }

                if (this.state.selected.Heizstrahler !== "") {
                    var HeizstrahlerAmount = this.state.HeizstrahlerAmount;
                    if (HeizstrahlerAmount === "" || HeizstrahlerAmount === null || HeizstrahlerAmount === undefined) {
                        HeizstrahlerAmount = 1
                    }
                    thePrice = thePrice + (parseFloat(this.state.selected.Heizstrahler.Price) * parseFloat(HeizstrahlerAmount))
                }

                if (this.state.selected.Glasschiebeelemente.links !== undefined && this.state.selected.Glasschiebeelemente.links !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.Glasschiebeelemente.links.Price)
                    if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                        Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Glasschiebeelemente.links.Price) * 0.2)
                    }
                }
                if (this.state.selected.Glasschiebeelemente.rechts !== undefined && this.state.selected.Glasschiebeelemente.rechts !== "") {
                    thePrice = thePrice + parseFloat(this.state.selected.Glasschiebeelemente.rechts.Price)
                    if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                        Montage.Price = parseFloat(Montage.Price) + (parseFloat(this.state.selected.Glasschiebeelemente.rechts.Price) * 0.2)
                    }
                }


                if (this.state.selected.Glasschiebeelemente.vorne !== undefined && this.state.selected.Glasschiebeelemente.vorne !== "") {
                    if (this.props.wpObject.type.endsWith("Alu")) {
                        thePrice = thePrice + (parseFloat(this.state.selected.Glasschiebeelemente.vorne.Price) * parseFloat(this.state.Pieces))
                    }
                    else {
                        thePrice = thePrice + (parseFloat(this.state.selected.Glasschiebeelemente.vorne.Price) * parseFloat(this.state.SubPieces))
                    }

                    if (this.state.selected.Montage !== "" && this.state.selected.Montage.ProductName !== "Selbstmontage") {
                        Montage.Price = parseFloat(Montage.Price) + ((parseFloat(this.state.selected.Glasschiebeelemente.vorne.Price) * 0.2) * parseFloat(this.state.Pieces))
                    }
                }

                if (Montage !== "" && Montage.ProductName !== "Selbstmontage") {    
                    thePrice = thePrice + (parseFloat(Montage.Price) * parseFloat(this.state.Pieces))
                }

                var rate = 0
                if (Montage === "") {
                    Montage = { Price: 0 };
                    rate = ((thePrice - (parseFloat(Montage.Price) * parseFloat(this.state.Pieces))) / 68) * this.state.MwSt;
                }
                else if (Montage !== "") {
                    rate = ((thePrice - (parseFloat(Montage.Price) * parseFloat(this.state.Pieces))) / 68) * this.state.MwSt;
                }

                Montage.Price = Montage.Price * parseFloat(this.state.Pieces);

                this.setState({
                    MontagePrice: Montage,
                    Price: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(((thePrice * this.state.MwSt).toFixed(2))).toString(),
                    Rate: ((rate * this.state.MwSt).toFixed(2)).toString().replace(".", ",") + " \u20ac",
                    PriceB: thePriceB,
                    AmountBefestigung: amountBefestigung
                })
            }
        }
    }

    openConfig = (c) => {
        switch (c) {
            case 1:
                var Konfiguration = this.state.Konfiguration[0]
                Konfiguration.num = 1;

                this.setState({
                    trigger2: true,
                    confPopUp: Konfiguration,
                })
                break;
            case 2:
                var Konfiguration = this.state.Konfiguration[1]
                Konfiguration.num = 2;

                this.setState({
                    trigger2: true,
                    confPopUp: Konfiguration,
                })
                break;
            case 3:
                var Konfiguration = this.state.Konfiguration[2]
                Konfiguration.num = 3;

                this.setState({
                    trigger2: true,
                    confPopUp: Konfiguration,
                })
                break;
            case 4:
                var Konfiguration = this.state.Konfiguration[0]
                Konfiguration.num = 1;

                this.setState({
                    confPopUp: Konfiguration,
                })
                break;
            case 5:
                var Konfiguration = this.state.Konfiguration[1]
                Konfiguration.num = 2;

                this.setState({
                    confPopUp: Konfiguration,
                })
                break;
            case 6:
                var Konfiguration = this.state.Konfiguration[2]
                Konfiguration.num = 3;

                this.setState({
                    confPopUp: Konfiguration,
                })
                break;
        }
    }

    deUmlaut = (value) => {
        value = value.replace(/ä/g, 'ae');
        value = value.replace(/ö/g, 'oe');
        value = value.replace(/ü/g, 'ue');
        value = value.replace(/ß/g, 'ss');
        value = value.replace(/Ä/g, 'Ae');
        value = value.replace(/Ö/g, 'Oe');
        value = value.replace(/Ü/g, 'Ue');
        return value;
    }

    revDeUmlaut = (value) => {
        value = value.replace(/ae/g, 'ä');
        value = value.replace(/oe/g, 'ö');
        value = value.replace(/ue/g, 'ü');
        value = value.replace(/ss/g, 'ß');
        value = value.replace(/Ae/g, 'Ä');
        value = value.replace(/Oe/g, 'Ö');
        value = value.replace(/Ue/g, 'Ü');
        return value;
    }

    scrollToRef = (ref) => {
        window.scrollTo({ behavior: 'smooth', top: ref.current.offsetTop })
    };

    checkCustomer = () => {

        var Customer = this.state.Customer;

        if (Customer.Mail !== "" || Customer.Phone !== "") {
            Customer.isSet = true;
        }

        this.setState({
            Customer:Customer
        })

    }

    createKonfiguration = () => {

        if (this.state.Konfiguration.length < 3) {

            var request = this.buildRequest("");

            var Konfiguration = this.state.Konfiguration;
            Konfiguration.push(request);

            var length = Konfiguration.length;

            this.setState({
                Konfiguration: Konfiguration,
                confLength: length,
            }, () => {
                    this.setState({
                        submited: false,
                        Width: 1000,
                        Deepth: 800,
                        Pieces: 1,
                        Weight: 0,
                        selected: {
                            Montage: "",
                            TechnischeZeichnung: "",
                            Kanten: "",
                            Maut: "",
                            Bohrung: "",
                            Vordach: "",
                            Glas: "",
                            Beschlag: "",
                            ZubTerUeb: "",
                            ZubVord: "",
                            ZubAlg: "",
                            Befestigungsmaterial: "",
                            Dachrahmen: "",
                            Optik: "",
                            Regenrinne: "",
                            SolarModul: "",
                        },
                        available: {
                            Montage: [],
                            Glas: [],
                            Beschlag: [],
                            ZubTerUeb: [],
                            ZubVord: [],
                            ZubAlg: [],
                            Zubehoer: [],
                            Befestigungsmaterial: [],
                            Dachrahmen: [],
                            Optik: [],
                            Regenrinne: [],
                            Solarmodul: [],
                        },
                        Price: "",
                    }, () => {
                            this.selectVordach();
                    })
            })
        }
        else {
            alert("Sie haben die Maximale Anzahl an Konfigurationenfür eine Anfrage erstellt.")
        }
    }

    buildRequest = (art) => {
        var request

        if (this.props.wpObject.type.includes("vordach") || this.props.wpObject.type.includes("Vordach")) {
            request = {
                Grunddaten: {
                    oBreite: parseFloat(this.state.selected.Input.width) / parseFloat(this.state.Pieces),
                    oTiefe: this.state.selected.Input.deepth,
                    Breite: parseFloat(this.state.Width) / parseFloat(this.state.Pieces),
                    Tiefe: this.state.Deepth,
                    Flaeche: ((this.state.Width / 1000) * (this.state.Deepth / 1000)).toString(),
                    Menge: this.state.Pieces,
                    Gewicht: this.state.Weight,
                    Produkt: this.state.selected.Vordach.CanopyType,
                    Versand: this.state.Shipping
                },
                System: {
                    AnzahlHalterungen: this.state.selected.Vordach.Fittings,
                    Halterung: this.state.selected.Beschlag.ProductName,
                    Traegerart: this.state.selected.Traegerart.ProductName,
                    Farbe: this.state.selected.Farbe.ProductName,
                    Befestigungsmaterial: this.state.selected.Befestigungsmaterial.ProductName,
                    BefestigungsmaterialPrice: parseFloat(this.state.selected.Befestigungsmaterial.Price) * this.state.MwSt,
                    AmountBefestigung: this.state.AmountBefestigung
                },
                Glas: {
                    Glasart: this.state.selected.Glas.ProductName,
                    Staerke: this.state.selected.Glas.Strength,
                    Price: (parseFloat(this.state.selected.Glas.Price) * (parseFloat(this.state.Width) * parseFloat(this.state.Deepth))) * this.state.MwSt
                },
                Zubehoer: {
                    Regenrinne: {
                        Type: "Regenrinne",
                        Name: this.state.selected.Regenrinne.ProductName !== undefined && !this.state.selected.Regenrinne.ProductName.includes("ohne") && !this.state.selected.Regenrinne.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Regenrinne.ProductName,
                        Price: (parseFloat(this.state.selected.Regenrinne.Price) * (this.state.Width / 1000)) * this.state.MwSt,
                    },
                    Seitenteil: {
                        Type: "Seitenteil",
                        Name: this.state.selected.Seitenteil.ProductName !== undefined && !this.state.selected.Seitenteil.ProductName.includes("ohne") && !this.state.selected.Seitenteil.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        Amount: this.state.selected.Seitenteil.Amount,
                        Price: parseFloat(this.state.selected.Seitenteil.Price) * this.state.MwSt,
                    },
                    Abdeckung: {
                        Type: "Abdeckung",
                        Name: this.state.selected.Abdeckung.ProductName !== undefined && !this.state.selected.Abdeckung.ProductName.includes("ohne") && !this.state.selected.Abdeckung.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.selected.Abdeckung.Price) * this.state.MwSt,
                   },
                    TechZeichnung: {
                        Type: "Technische Zeichnung",
                        Name: this.state.selected.TechnischeZeichnung.ProductName !== undefined && !this.state.selected.TechnischeZeichnung.ProductName.includes("ohne") && !this.state.selected.TechnischeZeichnung.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.selected.TechnischeZeichnung.Price) * this.state.MwSt,
                    },
                },
                Service: {
                    Montage: {
                        Type: "Montage",
                        Name: this.state.selected.Montage.ProductName !== undefined && !this.state.selected.Montage.ProductName.includes("Selbstmontage") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.MontagePrice.Price) * this.state.MwSt,
                    },
                },
                Customer: this.state.Customer,
                IMG: this.getProduchtIMG(this.props.wpObject.type.toLowerCase()),
                FileName: md5((this.state.selected.Vordach.ProductName) + ((new Date()).toString())).toString(),
                Preis: this.state.Price,
                PreisB: this.state.PriceB,
                TypeOf: art,
                PDFDATA: this.state.Products.PDFDATA
            }
        }

        if (this.props.wpObject.type.includes("Terrassenüberdachung") && this.props.wpObject.type.includes("Solar")) {

            request = {
                Grunddaten: {
                    oBreite: parseFloat(this.state.selected.Input.width),
                    oTiefe: this.state.selected.Input.deepth,
                    Breite: parseFloat(this.state.Width),
                    Tiefe: this.state.Deepth,
                    Flaeche: ((this.state.Width / 1000) * (this.state.Deepth / 1000)).toString(),
                    Produkt: this.state.selected.SolarType.Id === "CARP" ? "Solar Carport" : this.state.selected.Vordach.CanopyType,
                    Type: this.state.selected.SolarType,
                    Menge: this.state.Pieces,
                    Vergleichsprodukt: {
                        Price: this.state.PriceVP,
                        PriceB: this.state.PriceVPBrutto,
                        Montage: this.state.MontagePriceVP
                    },
                    Versand: this.state.Shipping
                },
                System: {
                    Aufbau: this.state.selected.Aufbau.ProductName,
                    Unterkonstruktion: this.state.selected.Unterkonstruktion.ProductName,
                    Farbe: this.state.selected.Farbe.ProductName,
                    Befestigungsmaterial: this.state.selected.Befestigungsmaterial.ProductName,
                    BefestigungsmaterialPrice: parseFloat(this.state.selected.Befestigungsmaterial.Price) * this.state.MwSt,
                    AmountBefestigung: this.state.AmountBefestigung,
                    Fokus: this.state.selected.SolarModul.ProductDescription
                },
                Glas: {
                    Glasart: this.state.selected.Glas.ProductName,
                },
                Zubehoer: {
                    Unterdachmarkise: {
                        Type: "Unterdachmarkise",
                        Name: this.state.selected.Unterdachmarkise.ProductName && !this.state.selected.Unterdachmarkise.ProductName.includes("ohne") && !this.state.selected.Unterdachmarkise.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Unterdachmarkise.ProductName,
                        Price: parseFloat(this.state.selected.Unterdachmarkise.Price) * this.state.MwSt,
                    },
                    LED: {
                        Type: this.state.selected.LED.ProductType,
                        Name: this.state.selected.LED.ProductName.includes("Ohne") ? "Ohne" : this.state.LEDAmount + " Stück",
                        ProductName: this.state.selected.LED.ProductName,
                        Price: (parseFloat(this.state.selected.LED.Price) * parseFloat(this.state.LEDAmount)) * this.state.MwSt,
                    },
                    GlasschiebeelementeLinks: {
                        Type: "Glasschiebeelement Links",
                        Name: !this.state.selected.Glasschiebeelemente.links.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Glasschiebeelemente.links.ProductName,
                        Price: parseFloat(this.state.selected.Glasschiebeelemente.links.Price) * this.state.MwSt,
                    },
                    GlasschiebeelementeRechts: {
                        Type: "Glasschiebeelement Rechts",
                        Name: !this.state.selected.Glasschiebeelemente.rechts.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Glasschiebeelemente.rechts.ProductName,
                        Price: parseFloat(this.state.selected.Glasschiebeelemente.rechts.Price) * this.state.MwSt,
                    },
                    GlasschiebeelementeVorne: {
                        Type: "Glasschiebeelement Vorne",
                        Name: !this.state.selected.Glasschiebeelemente.vorne.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Glasschiebeelemente.vorne.ProductName,
                        Price: parseFloat(this.state.selected.Glasschiebeelemente.vorne.Price * parseFloat(this.state.SMPieces))  * this.state.MwSt,
                    },
                    SenkrechtmarkiseLinks: {
                        Type: "Senkrechtmarkise Links",
                        Name: !this.state.selected.Senkrechtmarkise.links.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Senkrechtmarkise.links.ProductName,
                        Price: (parseFloat(this.state.selected.Senkrechtmarkise.links.Price) * parseFloat(this.state.SMSidePieces)) * this.state.MwSt,
                    },
                    SenkrechtmarkiseRechts: {
                        Type: "Senkrechtmarkise Rechts",
                        Name: !this.state.selected.Senkrechtmarkise.rechts.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Senkrechtmarkise.rechts.ProductName,
                        Price: (parseFloat(this.state.selected.Senkrechtmarkise.rechts.Price) * parseFloat(this.state.SMSidePieces)) * this.state.MwSt,
                    },
                    SenkrechtmarkiseVorne: {
                        Type: "Senkrechtmarkise Vorne",
                        Name: !this.state.selected.Senkrechtmarkise.vorne.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Senkrechtmarkise.vorne.ProductName,
                        Price: (parseFloat(this.state.selected.Senkrechtmarkise.vorne.Price) * parseFloat(this.state.SMPieces)) * this.state.MwSt,
                    },
                    Heizstrahler: {
                        Type: this.state.selected.Heizstrahler.ProductType,
                        Name: this.state.selected.Heizstrahler !== "" ? this.state.selected.Heizstrahler.ProductName.includes("Ohne") ? "Ohne" : this.state.HeizstrahlerAmount + " Stück" : "Ohne",
                        ProductName: this.state.selected.Heizstrahler.ProductName,
                        Price: parseFloat(this.state.selected.Heizstrahler.Price) * this.state.MwSt,
                    },
                    Stromspeicher: {
                        Type: "Stromspeicher",
                        Name: this.state.selected.StromSpeicher.ProductName && !this.state.selected.StromSpeicher.ProductName.includes("ohne") && !this.state.selected.StromSpeicher.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.StromSpeicher.ProductName,
                        Price: parseFloat(this.state.selected.StromSpeicher.Price) * this.state.MwSt,
                    },
                    Ladestation: {
                        Type: "Ladestation",
                        Name: this.state.selected.Ladestation.ProductName && !this.state.selected.Ladestation.ProductName.includes("ohne") && !this.state.selected.Ladestation.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Ladestation.ProductName,
                        Price: parseFloat(this.state.selected.Ladestation.Price) * this.state.MwSt,
                    },
                    Wechselrichter: {
                        Type: "Wechselrichter",
                        Name: this.state.selected.Wechselrichter.ProductName && !this.state.selected.Wechselrichter.ProductName.includes("ohne") && !this.state.selected.Wechselrichter.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Wechselrichter.ProductName,
                        Price: parseFloat(this.state.selected.Wechselrichter.Price) * this.state.MwSt,
                    },
                    TechZeichnung: {
                        Type: "Technische Zeichnung",
                        Name: this.state.selected.TechnischeZeichnung.ProductName !== undefined && !this.state.selected.TechnischeZeichnung.ProductName.includes("ohne") && !this.state.selected.TechnischeZeichnung.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.TechnischeZeichnung.ProductName,
                        Price: parseFloat(this.state.selected.TechnischeZeichnung.Price) * this.state.MwSt,
                    },
                    Geraeteraum: {
                        Type: "Geräteraum",
                        Name: this.state.selected.Geraeteraum.ProductName !== undefined && !this.state.selected.Geraeteraum.ProductName.includes("ohne") && !this.state.selected.Geraeteraum.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Geraeteraum.ProductName,
                        Price: parseFloat(this.state.selected.Geraeteraum.Price) * this.state.MwSt
                    },

                },
                Service: {
                    Montage: {
                        Type: "Montage",
                        Name: this.state.selected.Montage.ProductName !== undefined && !this.state.selected.Montage.ProductName.includes("Selbstmontage") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.MontagePrice.Price) * this.state.MwSt,
                    },
                },
                Customer: this.state.Customer,
                IMG: this.getProduchtIMG(this.props.wpObject.type.toLowerCase()),
                FileName: md5((this.state.selected.Vordach.ProductName) + ((new Date()).toString())).toString(),
                Preis: this.state.Price,
                PreisB: this.state.PriceB,
                TypeOf: art,
                PDFDATA: this.state.Products.PDFDATA,
                Module: this.state.Module
            }
        }
        if (this.props.wpObject.type.includes("Terrassenüberdachung") && !this.props.wpObject.type.includes("Solar")) {
            request = {
                Grunddaten: {
                    oBreite: parseFloat(this.state.selected.Input.width),
                    oTiefe: this.state.selected.Input.deepth,
                    Breite: parseFloat(this.state.Width),
                    Tiefe: this.state.Deepth,
                    Flaeche: ((this.state.Width / 1000) * (this.state.Deepth / 1000)).toString(),
                    Menge: this.state.Pieces,
                    Produkt: (this.state.selected.Vordach.CanopyType === "Terrassenüberdachung" ? this.state.selected.Vordach.CanopyType + " Stahl" : this.state.selected.Vordach.CanopyType),
                    Versand: this.state.Shipping
                },
                System: {
                    Aufbau: this.state.selected.Aufbau.ProductName,
                    Unterkonstruktion: this.state.selected.Unterkonstruktion.ProductName,
                    Farbe: this.state.selected.Farbe.ProductName,
                    Befestigungsmaterial: this.state.selected.Befestigungsmaterial.ProductName,
                    AmountBefestigung: this.state.AmountBefestigung,
                    BefestigungsmaterialPrice: parseFloat(this.state.selected.Befestigungsmaterial.Price) * this.state.MwSt,
                },
                Glas: {
                    Glasart: this.state.selected.Glas.ProductName,
                },
                Zubehoer: {
                    Unterdachmarkise: {
                        Type: "Unterdachmarkise",
                        Name: this.state.selected.Unterdachmarkise.ProductName && !this.state.selected.Unterdachmarkise.ProductName.includes("ohne") && !this.state.selected.Unterdachmarkise.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.selected.Unterdachmarkise.Price) * this.state.MwSt
                    },
                    LED: {
                        Type: this.state.selected.LED.ProductType,
                        Name: this.state.selected.LED.ProductName.includes("Ohne") ? "Ohne" : this.state.LEDAmount + " Stück",
                        Price: (parseFloat(this.state.selected.LED.Price) * parseFloat(this.state.LEDAmount)) * this.state.MwSt
                    },
                    GlasschiebeelementeLinks: {
                        Type: "Glasschiebeelement Links",
                        Name: !this.state.selected.Glasschiebeelemente.links.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.selected.Glasschiebeelemente.links.Price) * this.state.MwSt
                    },
                    GlasschiebeelementeRechts: {
                        Type: "Glasschiebeelement Rechts",
                        Name: !this.state.selected.Glasschiebeelemente.rechts.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.selected.Glasschiebeelemente.rechts.Price) * this.state.MwSt
                    },
                    GlasschiebeelementeVorne: {
                        Type: "Glasschiebeelement Vorne",
                        Name: !this.state.selected.Glasschiebeelemente.vorne.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.selected.Glasschiebeelemente.vorne.Price) * this.state.MwSt
                    },
                    SenkrechtmarkiseLinks: {
                        Type: "Senkrechtmarkise Links",
                        Name: !this.state.selected.Senkrechtmarkise.links.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Senkrechtmarkise.links.ProductName,
                        Price: (parseFloat(this.state.selected.Senkrechtmarkise.links.Price) * parseFloat(this.state.SMSidePieces)) * this.state.MwSt,
                    },
                    SenkrechtmarkiseRechts: {
                        Type: "Senkrechtmarkise Rechts",
                        Name: !this.state.selected.Senkrechtmarkise.rechts.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Senkrechtmarkise.rechts.ProductName,
                        Price: (parseFloat(this.state.selected.Senkrechtmarkise.rechts.Price) * parseFloat(this.state.SMSidePieces)) * this.state.MwSt,
                    },
                    SenkrechtmarkiseVorne: {
                        Type: "Senkrechtmarkise Vorne",
                        Name: !this.state.selected.Senkrechtmarkise.vorne.ProductName.toLowerCase().includes("ohne") ? "Mit" : "Ohne",
                        ProductName: this.state.selected.Senkrechtmarkise.vorne.ProductName,
                        Price: (parseFloat(this.state.selected.Senkrechtmarkise.vorne.Price) * parseFloat(this.state.SMPieces)) * this.state.MwSt,
                    },
                    Keilfenster: {
                        Type: "Keilfenster",
                        Name: this.state.selected.Keilfenster.Direction === undefined ? "Ohne" : this.state.selected.Keilfenster.Direction === "Beide" ? this.state.selected.Keilfenster.Direction + "Seiten" : this.state.selected.Keilfenster.Direction,
                        Price: parseFloat(this.state.selected.Keilfenster.Price) * this.state.MwSt
                    },
                    Heizstrahler: {
                        Type: this.state.selected.Heizstrahler.ProductType,
                        Name: this.state.selected.Heizstrahler !== "" ? this.state.selected.Heizstrahler.ProductName.includes("Ohne") ? "Ohne" : this.state.HeizstrahlerAmount + " Stück" : "Ohne",
                        Price: parseFloat(this.state.selected.Heizstrahler.Price) * this.state.MwSt
                    },
                    TechZeichnung: {
                        Type: "Technische Zeichnung",
                        Name: this.state.selected.TechnischeZeichnung.ProductName !== undefined && !this.state.selected.TechnischeZeichnung.ProductName.includes("ohne") && !this.state.selected.TechnischeZeichnung.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.selected.TechnischeZeichnung.Price) * this.state.MwSt
                    },
                    Geraeteraum: {
                        Type: "Geräteraum",
                        Name: this.state.selected.Geraeteraum.ProductName !== undefined && !this.state.selected.Geraeteraum.ProductName.includes("ohne") && !this.state.selected.Geraeteraum.ProductName.includes("Ohne") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.selected.Geraeteraum.Price) * this.state.MwSt
                    },

                },
                Service: {
                    Montage: {
                        Type: "Montage",
                        Name: this.state.selected.Montage.ProductName !== undefined && !this.state.selected.Montage.ProductName.includes("Selbstmontage") ? "Mit" : "Ohne",
                        Price: parseFloat(this.state.MontagePrice.Price) * this.state.MwSt,
                    },
                },
                Customer: this.state.Customer,
                IMG: this.getProduchtIMG(this.props.wpObject.type.toLowerCase()),
                FileName: md5((this.state.selected.Vordach.ProductName) + ((new Date()).toString())).toString(),
                Preis: this.state.Price,
                PreisB: this.state.PriceB,
                TypeOf: art,
                PDFDATA: this.state.Products.PDFDATA,
            }
        }

        return request;

    }

    callAngebotApi = (request) => {
        if (this.state.downloadLink === "" || this.state.Customer.isSet) {
            this.fetchWP.post('shortcode', request)
                .then((json) => {
                    this.setState({
                        downloadLink: json.dLink,
                        submited: json.submited,

                    }, () => {
                        if (this.state.downloadLink !== "") {
                            window.open(this.state.downloadLink, "_blank");
                        }
                    });
                })
        }
    }

    setGSE = async (width, deepth, vdType) => {
        var OGSE = [...this.state.Products.Glasschiebeelemente];
        var KF = [...this.state.Products.Keilfenster];
        var GSE = {};
        var selected = this.state.selected;

        OGSE.map((item,key)=>{
            if (deepth <= parseFloat(item.Max_Deepth) &&
                deepth >= parseFloat(item.Min_Deepth)) {
                GSE.links = { ...item };
                GSE.rechts = { ...item };
            }
            if ((Math.ceil((parseFloat(width) / parseFloat(this.state.Pieces)))) <= parseFloat(item.Max_Deepth) &&
                (Math.ceil((parseFloat(width) / parseFloat(this.state.Pieces)))) >= parseFloat(item.Min_Deepth)) {
                GSE.vorne = { ...item };

            }
        })

        OGSE.map((item, key) => {
            if (deepth <= parseFloat(item.Max_Deepth) &&
                deepth >= parseFloat(item.Min_Deepth)) {
                selected.Keilfenster = item;
            }
        })

        GSE.vorne.Position = "Vorne";
        GSE.links.Position = "Links";
        GSE.rechts.Position = "Rechts";
        GSE.vorne.Id = GSE.vorne.Id + "V";
        GSE.links.Id = GSE.links.Id + "L";
        GSE.rechts.Id = GSE.rechts.Id + "R";


        this.setState({
            GSE: GSE,
            GSL: GSE.links,
            GSR: GSE.rechts,
            GSV: GSE.vorne,
            selected: selected
        })

    }

    setSM = async (width, deepth, vdType) => {
        var OSM = [...this.state.Products.Senkrechtmarkise];
        var SM = {};


        OSM.map((item, key) => {
            if ((Math.ceil((parseFloat(deepth) / parseFloat(this.state.SMSidePieces)))) <= parseFloat(item.Max_Width) &&
                (Math.ceil((parseFloat(deepth) / parseFloat(this.state.SMSidePieces)))) >= parseFloat(item.Min_Width)) {
                SM.links = { ...item };
                SM.rechts = { ...item };

            }
            if ((Math.ceil((parseFloat(width) / parseFloat(this.state.SMPieces)))) <= parseFloat(item.Max_Width) &&
                (Math.ceil((parseFloat(width) / parseFloat(this.state.SMPieces)))) >= parseFloat(item.Min_Width)) {
                SM.vorne = { ...item };

            }

        })



        SM.vorne.Position = "Vorne";
        SM.links.Position = "Links";
        SM.rechts.Position = "Rechts";
        SM.vorne.Id = SM.vorne.Id + "V";
        SM.links.Id = SM.links.Id + "L";
        SM.rechts.Id = SM.rechts.Id + "R";
        
        this.setState({
            SM: SM,
            SML: SM.links,
            SMR: SM.rechts,
            SMV: SM.vorne
        })

    }

    selectedGSE = (value, vdType) => {
        var selected = 0;

        if (parseFloat(value) < 1) {
            selected = "";
        }
        else {
            selected = this.mapItem(this.state.Products.Glasschiebeelemente, "", false, (parseFloat(value)), false, true);
            selected = selected.filter((el) => { return el.ProductName.toLowerCase() != "ohne glasschiebeelemente"; });
            selected = selected[0];


        }
        return selected
    }

    selectedSM = (value, vdType) => {
        var selected = 0;

        if (parseFloat(value) < 1) {
            selected = "";
        }
        else {
            selected = this.mapItem(this.state.Products.Senkrechtmarkise, "", false, (parseFloat(value)), false, true);
            selected = selected.filter((el) => { return el.ProductName.toLowerCase() != "ohne senkrechtmarkise"; });
            selected = selected[0];

        }
        return selected
    }

    reduceToTen = (item) => {
        if (parseFloat(item) > 10) {
            item = 10
        }
        return item
    }

    handleChange = (e, c) => {

        var Customer = this.state.Customer

        switch (c) {
            case "FirstName":
                Customer.FirstName = e.target.value
                break;

            case "LastName":
                Customer.LastName = e.target.value
                break;

            case "Street":
                Customer.Street = e.target.value
                break;

            case "StreetNr":
                Customer.StreetNr = e.target.value
                break;

            case "Mail":
                Customer.Mail = e.target.value
                break;

            case "Phone":
                Customer.Phone = e.target.value
                break;

            case "Zip":
                Customer.Zip = e.target.value
                break;
            case "Anrede":
                Customer.Anrede = e
                break;
        }

        this.setState({
            Customer: Customer
        })

        var result;
        var vdType = this.props.wpObject.type;
        var selected = this.state.selected;
        var GlasschiebeelementAmount = this.state.GlasschiebeelementAmount;
        var GlasschiebeelementAmountLeft = this.state.GlasschiebeelementAmountLeft;
        var GlasschiebeelementAmountRight = this.state.GlasschiebeelementAmountRight;
        var HeizstrahlerAmount = this.state.HeizstrahlerAmount;
        var LEDAmount = this.state.LEDAmount;
        var KFL = this.state.KFL;
        var KFR = this.state.KFR;
        var KFB = this.state.KFB;
        var GSL = this.state.GSL;
        var GSR = this.state.GSR;
        var GSV = this.state.GSV;

        if (c.substr(0, 2) === "GS") {
            if (selected.Glasschiebeelemente === "" || selected.Glasschiebeelemente.ProductName === "ohne Glasschiebeelemente") {
                selected.Glasschiebeelemente = {};
            }
        }

        switch (c) {
            case "GlasschiebeelementAmountLeft":
                GlasschiebeelementAmountLeft = this.reduceToTen(e.target.value);
                selected.Glasschiebeelemente.links = this.selectedGSE(e.target.value, vdType);
                break;
            case "GlasschiebeelementAmountRight":
                GlasschiebeelementAmountRight = this.reduceToTen(e.target.value);
                selected.Glasschiebeelemente.rechts = this.selectedGSE(e.target.value, vdType);


                break;
            case "GlasschiebeelementAmountFront":
                GlasschiebeelementAmount = this.reduceToTen(e.target.value);
                selected.Glasschiebeelemente.vorne = this.selectedGSE(e.target.value, vdType);
                break;

            case "GSLinks":
                selected.Glasschiebeelemente.links = this.selectedGSE(this.state.Deepth, vdType);
                GSL = this.state.GSL === true ? false : true;
                GSR = this.state.GSR
                GSV = this.state.GSV

                if (!GSL) {
                    selected.Glasschiebeelemente.links = "";
                }

                break;

            case "GSRechts":
                selected.Glasschiebeelemente.rechts = this.selectedGSE(this.state.Deepth, vdType);
                GSR = this.state.GSR === true ? false : true;
                GSL = this.state.GSL
                GSV = this.state.GSV

                if (!GSR) {
                    selected.Glasschiebeelemente.rechts = "";
                }

                break;
            case "GSVorne":
                if (this.props.wpObject.type.endsWith("Alu")) {
                    selected.Glasschiebeelemente.vorne = this.selectedGSE(Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.Pieces))), vdType);
                }
                else {
                    selected.Glasschiebeelemente.vorne = this.selectedGSE(Math.ceil((parseFloat(this.state.Width) / parseFloat(this.state.SubPieces))), vdType);
                }

                GSV = this.state.GSV === true ? false : true;
                GSR = this.state.GSR
                GSL = this.state.GSL

                if (!GSV) {
                    selected.Glasschiebeelemente.vorne = "";
                }

                break;

            case "KeilfensterLinks":
                selected.Keilfenster = this.state.available.Keilfenster[1];
                selected.Keilfenster.Amount = 1;
                KFL = this.state.KFL ? false : true;
                KFB = false;
                KFR = false;
                selected.Keilfenster.Direction = "Links";
                break;
            case "KeilfensterRechts":
                selected.Keilfenster = this.state.available.Keilfenster[1];
                selected.Keilfenster.Amount = 1;
                KFR = this.state.KFR ? false : true;
                KFB = false;
                KFL = false;
                selected.Keilfenster.Direction = "Rechts";
                break;
            case "KeilfensterBeide":
                selected.Keilfenster = this.state.available.Keilfenster[1];
                selected.Keilfenster.Amount = 2;
                KFL = false;
                KFR = false;
                KFB = this.state.KFB ? false : true;
                selected.Keilfenster.Direction = "Beide";
                break;

            case "HeizstrahlerAmount":
                HeizstrahlerAmount = e.target.value;
                selected.Heizstrahler = this.mapItem(this.state.available.Heizstrahler, "");
                selected.Heizstrahler = selected.Heizstrahler.filter((el) => { return el.ProductName != "Ohne Heizstrahler"; });
                selected.Heizstrahler = selected.Heizstrahler[0];

                this.setState({
                    HeizstrahlerAmount: HeizstrahlerAmount,
                    selected: selected
                }, () => {
                        this.calcPrice();
                })
                break;

            case "LEDAmount":
                LEDAmount = e.target.value;
                selected.LED = this.mapItem(this.state.available.LED, "");
                selected.LED = selected.LED.filter((el) => { return el.ProductName != "Ohne LED Beleuchtung"; });
                selected.LED = selected.LED[0];

                this.setState({
                    LEDAmount: LEDAmount,
                    selected: selected
                }, () => {
                    this.calcPrice();
                })
                break;
        }

        if (c.includes("Keilfenster")) {

            if (!KFL && !KFR && !KFB) {
                selected.Keilfenster = "";
            }

            this.setState({
                KFL: KFL,
                KFR: KFR,
                KFB: KFB,
                selected: selected
            }, () => {

                    var isSelected = false;

                    if (KFL || KFR || KFB) {
                        isSelected = true;
                    }

                    this.unselectItem(this.state.available.Keilfenster[0]);
                    if (this.state.available.Keilfenster[1] !== "" &&
                        this.state.available.Keilfenster[1] !== undefined &&
                        isSelected
                    ) {

                        if (document.getElementById(this.state.available.Keilfenster[1].Id)) {
                            document.getElementById(this.state.available.Keilfenster[1].Id).style.display = 'block';
                        }
                    }
                this.calcPrice();
            })
        }

        if (c.substr(0, 2) === "GS") {
            this.setState({
                GSL: GSL,
                GSR: GSR,
                GSV: GSV,
            selected:selected
            }, () => {

                    var isSelected = false;

                    if (GSL || GSR || GSV) {
                        isSelected = true;
                    }

                    if (this.state.available.Glasschiebeelemente[1] !== "" &&
                        this.state.available.Glasschiebeelemente[1] !== undefined &&
                        isSelected
                    ) {

                        if (document.getElementById(this.state.available.Glasschiebeelemente[1].Id)) {
                            document.getElementById(this.state.available.Glasschiebeelemente[1].Id).style.display = 'block';
                        }
                    }

                this.calcPrice();
        })
        }

    }

    resetSize = (x, y, z, deepth = false, dividerB, dividerT) => {
                    
        var xWidth = ((x * dividerB) + z);
    if (deepth) {
        var xDeepth = y;
    }
    else {
        var xDeepth = ((y * dividerT));
    }
                    
                    var result = {
                        width: xWidth,
                        deepth: xDeepth
                    }

                    return (result);
                    
}

    solarModuleDimensions = () => {

        var width = parseFloat(this.state.Width)
        var deepth = parseFloat(this.state.Deepth)

        var dividerB = this.state.selected.SolarModul.ProductDescription.toLowerCase().includes("lichtdurch") ? 990 : 725;
        var dividerT = this.state.selected.SolarModul.ProductDescription.toLowerCase().includes("lichtdurch") ? 1605 : 1555;
        var minus = this.state.selected.SolarModul.ProductDescription.toLowerCase().includes("lichtdurch") ? 80 : 60;


        var qm = parseFloat(width) * parseFloat(deepth);
        var Module = { ...this.state.Module }

        if (this.props.wpObject.type.toLowerCase().includes('solar')) {
            var solarModule = [...this.state.Products.SolarModule]
            Module.SinglePrice = parseFloat(this.state.selected.SolarModul.Price);
            Module.Leistung = parseFloat(this.state.selected.SolarModul.Strength);
            Module.Aufschlag = parseFloat(this.state.selected.SolarModul.Amount);

            var rS;


            if (parseFloat(this.state.Deepth) < 5001) {
                if (Module.Amount === undefined) {
                    Module.Amount = {};
                    Module.Amount.Width = (Math.round((parseFloat(this.state.Width) - minus) / dividerB));

                    var up = false;
                    if (parseFloat(((parseFloat(this.state.Deepth) / dividerT) % 1)) < 0.8) {
                        Module.Amount.Deepth = Math.floor(parseFloat(this.state.Deepth) / dividerT);
                    }
                    else {
                        Module.Amount.Deepth = Math.ceil(parseFloat(this.state.Deepth) / dividerT);
                        up = true;
                    }

                    Module.Amount.Total = Module.Amount.Width * Module.Amount.Deepth;
                    Module.TotalPower = (Module.Leistung * Module.Amount.Total) / 1000;


                    this.setState({
                        Module: Module,
                    }, async () => {
                        if (up) {
                            rS = await this.resetSize(Module.Amount.Width, Module.Amount.Deepth, minus, false, dividerB, dividerT);
                        }
                        else {
                            rS = await this.resetSize(Module.Amount.Width, parseFloat(this.state.Deepth), minus, true, dividerB, dividerT);
                        }


                        this.setState({
                            Width: rS.width,
                            Deepth: rS.deepth
                        }, () => {
                            var rSqm = rS.width * rS.deepth;
                            if (rSqm !== qm) {
                                return this.solarModuleDimensions();
                            }
                        })
                    })
                }

            }
            else {
                if (Module.Amount === undefined) {
                    Module.Amount = {};
                    Module.Amount.Width = (Math.round((parseFloat(this.state.Width) - minus) / dividerB));
                    var up = false;

                    if (((this.state.Deepth / dividerT) % 1) < 0.8) {
                        Module.Amount.Deepth = Math.floor(this.state.Deepth / dividerT);
                    }
                    else {
                        Module.Amount.Deepth = Math.ceil(this.state.Deepth / dividerT);
                        up = true;
                    }
                    Module.Amount.Total = Module.Amount.Width * Module.Amount.Deepth;
                    Module.TotalPower = (Module.Leistung * Module.Amount.Total) / 1000;

                    this.setState({
                        Module: Module,
                        SMSYR: false
                    }, async () => {

                        if (up) {
                            rS = await this.resetSize(Module.Amount.Width, Module.Amount.Deepth, minus, false, dividerB, dividerT);
                        }
                        else {
                            rS = await this.resetSize(Module.Amount.Width, parseFloat(this.state.Deepth), minus, true, dividerB, dividerT);
                        }

                        this.setState({
                            Width: rS.width,
                            Deepth: rS.deepth
                        }, () => {
                            var rSqm = rS.width * rS.deepth;
                            if (rSqm !== qm) {
                                return this.solarModuleDimensions();
                            }
                        })
                    })
                }

            }
        }


        this.setState({
            SNDB: false,
            Sync: true,
            SMSY: true,
        }, () => {
            if (this.props.wpObject.type.toLowerCase().includes("terrasse")) {
                if (parseFloat(this.state.Width) < parseFloat(this.state.VordachMinWidth)) {
                    width = parseFloat(this.state.VordachMinWidth);
                }
                if (parseFloat(this.state.Deepth) < parseFloat(this.state.VordachMinDeepth)) {
                    deepth = parseFloat(this.state.VordachMinDeepth)
                }
                if (parseFloat(this.state.Deepth) > parseFloat(this.state.VordachMaxDeepth)) {
                    deepth = parseFloat(this.state.VordachMaxDeepth);
                }

                this.setState({
                    Width: width,
                    Deepth: deepth
                }, () => {

                    this.selectVordach();
                    setTimeout(() => {
                        this.setGSE(this.state.Width, this.state.Deepth, this.props.wpObject.type)

                    }, 250)
                })
            }


        })
    }


    SenkrechtmarkisePieces = (width = false, deepth = false) => {
        var SMSidePieces = this.state.SMSidePieces;
        var SMPieces = this.state.SMSidePieces;

        if (!SMPieces) {
            SMPieces = 1;
        }
        if (!SMSidePieces) {
            SMSidePieces = 1;
        }

        if (width) {
            if (width > 5000) {
                SMPieces = Math.ceil(parseFloat(width) / 5000);
            }
        }
        if (deepth) {
            if (deepth > 5000) {
                SMSidePieces = Math.ceil(parseFloat(deepth) / 5000);
            }
        }

        this.setState({
            SMSidePieces: SMSidePieces,
            SMPieces: SMPieces
        });

    }

    checkDimensions = () => {

        var width = this.state.Width
        var deepth = this.state.Deepth
        
        if (this.state.Width !== "" && this.state.Deepth !== "") {
            this.SenkrechtmarkisePieces(width, deepth);
            this.setState({
                Sync: false,
                selectedCheapest: false
            }, () => {
                this.setState({
                    SNDB: false,
                    Sync: true
                }, () => {
                    if (parseFloat(this.state.Deepth) > parseFloat(this.state.VordachMaxDeepth)) {
                        deepth = parseFloat(this.state.VordachMaxDeepth);
                    }
                    if (parseFloat(this.state.Width) < parseFloat(this.state.VordachMinWidth)) {
                        width = parseFloat(this.state.VordachMinWidth);
                    }
                    if (parseFloat(this.state.Deepth) < parseFloat(this.state.VordachMinDeepth)) {
                        deepth = parseFloat(this.state.VordachMinDeepth);
                    }
                    this.setState({
                        Width: width,
                        Deepth: deepth
                    }, () => {
                        this.selectVordach();
                        setTimeout(() => {
                            this.setGSE(this.state.Width, this.state.Deepth, this.props.wpObject.type)
                        }, 250)
                    })
                })
            })
        }
    }

    changePage = (e, item) => {
        this.setState({
            ClickFunnelPage: "ClickFunnelPage leave",
        }, () => {
            setTimeout(() => {
                this.setState({
                    ClickFunnelPage: "ClickFunnelPage",
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }, 250)
                })
            }, 250)
        })
    }

    selectClickItem = (e, item) => {

        var Clicked = this.state.Clicked;
        Clicked[item.ProductType] = item.Id

        this.select(item)
        this.setState({
            ClickFunnelPage: "ClickFunnelPage leave",
            Clicked: Clicked
        }, () => {
                setTimeout(() => {
                    this.setState({
                        ClickFunnelPage: "ClickFunnelPage",
                        Clicked: Clicked
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                CFD: "clicked",
                                CFSteps: this.state.CFSteps + 1
                            })
                        }, 250)
                    })
                }, 250)})
    }

    selectMultiClickItem = (e, item) => {

        var Clicked = this.state.Clicked;
        Clicked[item.ProductType] = item.Id

        this.select(item)
        this.setState({
            Clicked: Clicked
        }, () => {
            setTimeout(() => {
                this.setState({
                    Clicked: Clicked,
                    SNB: true
                })
            }, 250)
        })
    }

    getProduchtIMG = (prod) => {
        var IMG = "";
        if (this.deUmlaut(prod) === "terrassenueberdachung") {
            this.state.Products.IMG.map((item, key) => {
                if (item.ProductName.toLowerCase() === (this.deUmlaut(prod) + " stahl").toLowerCase()) {
                    IMG = item.IMG
                }
            })
        }
        else if (this.deUmlaut(prod).includes("solar")) {
            this.state.Products.IMG.map((item, key) => {
                if (this.state.selected.SolarType === "Terrassendach") {
                    if (item.ProductName.toLowerCase().includes("solar")) {
                        if (this.state.selected.Unterkonstruktion.ProductName) {
                            if (item.ProductName.toLowerCase().includes(this.state.selected.Unterkonstruktion.ProductName.toLowerCase())) {
                                IMG = item.IMG
                            }
                            else {
                                IMG = item.IMG
                            }
                        }
                        else {
                            IMG = item.IMG
                        }
                    }
                }
                else {
                    if (item.ProductName.toLowerCase().includes("carport")) {
                        if (this.state.selected.Unterkonstruktion.ProductName) {
                            if (item.ProductName.toLowerCase().includes(this.state.selected.Unterkonstruktion.ProductName.toLowerCase())) {
                                IMG = item.IMG
                            }
                            else {
                                IMG = item.IMG
                            }
                        }
                        else {
                            IMG = item.IMG
                        }

                    }
                }
            })
        }
        else {
            this.state.Products.IMG.map((item, key) => {
                if (item.ProductName.toLowerCase() === this.deUmlaut(prod)) {
                    IMG = item.IMG
                }
            })
        }
        return IMG;
    }

    createAngebot = (art) => {

        var request = "";

        switch (art) {
            case "anfrage":
                this.checkCustomer();
                request = this.buildRequest(art);
                this.callAngebotApi(request);
                break;

            case "download":
                if (this.state.downloadLink !== "") {
                    window.open(this.state.downloadLink, "_blank");
                }
                else {
                    request = this.buildRequest(art);
                    this.callAngebotApi(request);
                }
                break;
            case "multiAnfrage":
                this.checkCustomer();
                for (var i = 0; i != this.state.Konfiguration.length; i++) {
                    request = this.state.Konfiguration[i];
                    request.TypeOf = "anfrage";
                    request.Multi = i + 1;
                    this.callAngebotApi(request);
                }
                break;
            case "multiDownload":
                this.setState({
                    downloadLink: ""
                }, () => {
                    for (var i = 0; i != this.state.Konfiguration.length; i++) {
                        request = this.state.Konfiguration[i];
                        request.TypeOf = "download";
                        this.callAngebotApi(request);
                    }
                });
                break;
        }
    }

    selectClickItemBat = (c) => {
        var selected = this.state.selected;
        var clicked = this.state.Clicked;

        switch (c) {
            case 1:
                this.state.Products.StromSpeicher.map((item, key) => {
                    if (parseFloat(this.state.Module.TotalPower) >= parseFloat(item.Min_Width) && parseFloat(this.state.Module.TotalPower) <= parseFloat(item.Max_Width)) {
                        selected.StromSpeicher = item;
                        clicked.Battery = "BAT1";
                        this.setState({
                            selected: selected,
                            Clicked: clicked
                        }, () => {
                                this.calcPrice();
                            this.setState({
                                CFSteps: this.state.CFSteps + 1
                            })
                        })
                    }
                })
                break;
            case 2:
                this.state.Products.StromSpeicher.map((item, key) => {
                    if (item.ProductName.toLowerCase().includes("ohne")) {
                        selected.StromSpeicher = item;
                        clicked.Battery = "BAT2";
                        this.setState({
                            selected: selected,
                            Clicked: clicked
                        }, () => {
                                this.calcPrice();
                            this.setState({
                                CFSteps: this.state.CFSteps + 1
                            })
                        })
                    }
                })
                break;
            case 3:
                this.state.Products.StromSpeicher.map((item, key) => {
                    if (parseFloat(this.state.Module.TotalPower) >= parseFloat(item.Min_Width) && parseFloat(this.state.Module.TotalPower) <= parseFloat(item.Max_Width)) {
                        selected.StromSpeicher = item;

                        selected.StromSpeicher.ProductName = "Eigener"
                        selected.StromSpeicher.Price = "0"
                        clicked.Battery = "BAT3";
                        this.setState({
                            selected: selected,
                            Clicked: clicked
                        }, () => {
                                this.calcPrice();
                            this.setState({
                                CFSteps: this.state.CFSteps + 1
                            })
                        })
                    }
                })
                break;
        }
    }

    getExtension = (extension, click, isColor = false, isGSE = false, isSM = false, isSenkM = false) => {
        if (extension) {

            if (isColor) {
                if (this.state.selected.Beschlag !== "") {
                    if (this.state.selected.Beschlag.ProductName.toLowerCase().includes("pulver")) {
                        var filtered = this.state.selected.Beschlag.Farben.filter((el) => {
                            return el != null;
                        });

                        return filtered.map((Farbe, key) => {
                            return (
                                <div id={click} className="ClickFunnelItem" onClick={(e) => {
                                    var prevPage = this.state.prevPage;
                                    prevPage.push(this.state.CFSteps);
                                    this.setState({
                                        prevPage: prevPage
                                    }, () => {
                                        this.selectClickItem(e, Farbe)
                                    })
                                }}>
                                    <span className="Check" style={this.state.Clicked[Farbe.ProductType] === Farbe.Id ? { display: "block" } : { display: "none" }}>
                                        <FontAwesomeIcon icon={faCheckCircle} />
                                    </span>
                                    <img src={Farbe.IMG ? Farbe.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={Farbe.ProductName} />
                                    <h3>{Farbe.ProductType === "Beschlag" ? this.revDeUmlaut(Farbe.ProductName) : Farbe.ProductName}</h3>
                                </div>
                            );
                        })
                    }
                }
                else if (this.state.selected.Unterkonstruktion !== "") {
                    if (this.state.selected.Unterkonstruktion.ProductName.toLowerCase().includes("pulver") || this.state.selected.Unterkonstruktion.ProductName.toLowerCase().includes("alu")) {
                        var filtered = this.state.selected.Unterkonstruktion.Farben.filter((el) => {
                            return el != null;
                        });

                        return filtered.map((Farbe, key) => {
                            return (
                                <div id={click} className="ClickFunnelItem" onClick={(e) => {
                                    var prevPage = this.state.prevPage;
                                    prevPage.push(this.state.CFSteps);
                                    this.setState({
                                        prevPage: prevPage
                                    }, () => {
                                        this.selectClickItem(e, Farbe)
                                    })
                                }}>
                                    <span className="Check" style={this.state.Clicked[Farbe.ProductType] === Farbe.Id ? { display: "block" } : { display: "none" }}>
                                        <FontAwesomeIcon icon={faCheckCircle} />
                                    </span>
                                    <img src={Farbe.IMG ? Farbe.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={Farbe.ProductName} />
                                    <h3>{Farbe.ProductType === "Beschlag" ? this.revDeUmlaut(Farbe.ProductName) : Farbe.ProductName}</h3>
                                </div>
                            );
                        })
                    }
                }
            }
            else if (isGSE) {

                var vdType = this.props.wpObject.type;

                var filtered = extension.filter((el) => {
                    return el != null;
                });

                var filtered2 = filtered.filter((el) => {
                    return el.ProductName.toLowerCase().includes('ohne');
                });

                if (filtered2[0] !== undefined) {
                    filtered2[0].Position = "Ohne";
                }

                if (this.state.GSV !== undefined && this.state.GSV !== "" && this.state.GSV !== false) {
                    filtered2.push(this.state.GSV);
                }

                if (this.state.GSL !== undefined && this.state.GSL !== "" && this.state.GSL !== false) {
                    filtered2.push(this.state.GSL);
                }

                if (this.state.GSR !== undefined && this.state.GSR !== "" && this.state.GSR !== false) {
                    filtered2.push(this.state.GSR);
                }

                return filtered2.map((item, key) => {
                    return (
                        <div id={click} className="ClickFunnelItem" onClick={(e) => {
                            var prevPage = this.state.prevPage;
                            prevPage.push(this.state.CFSteps);
                            this.setState({
                                prevPage: prevPage
                            }, () => {
                                item.Position === "Ohne" ? this.selectClickItem(e, item) : this.selectMultiClickItem(e, item)
                            })
                            }}>
                            <span className="Check" style={item.Position === "Ohne" ? this.state.selected.Glasschiebeelemente.vorne.Position === "Ohne" && this.state.selected.Glasschiebeelemente.links.Position === "Ohne" && this.state.selected.Glasschiebeelemente.rechts.Position === "Ohne" && this.state.Clicked.Glasschiebeelemente !== 'notClicked' ? { display: "block" } : { display: "none" } : this.state.selected.Glasschiebeelemente[item.Position.toLowerCase()] ? this.state.selected.Glasschiebeelemente[item.Position.toLowerCase()].Id === item.Id ? { display: "block" } : { display: "none" } : { display: "none" }}>
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </span>
                            <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName} />
                            <h3>{item.ProductType === "Beschlag" ? this.revDeUmlaut(item.Position) : item.Position}</h3>
                        </div>
                    );
                })
            }
            else if(isSM){

                var filtered = extension.filter((el) => {
                    return el != null;
                });


                return filtered.map((item, key) => {
                    return (
                        <div id={click} className="ClickFunnelItem" onClick={(e) => {
                            var prevPage = this.state.prevPage;
                            prevPage.push(this.state.CFSteps);
                            this.setState({
                                prevPage: prevPage
                            }, () => { this.selectClickItem(e, item) })
                        }}>
                            <span className="Check" style={this.state.Clicked[item.ProductType] === item.Id ? { display: "block" } : { display: "none" }}>
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </span>
                            <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName} />
                            <h3>{item.ProductType === "Beschlag" || item.ProductType === "Traegerart" && item.ProductName !== "Mauerwerk" ? this.revDeUmlaut(item.ProductName) : item.ProductDescription}</h3>
                        </div>
                    );
                })
            }
            else if (isSenkM) {

                var vdType = this.props.wpObject.type;

                    var filtered = extension.filter((el) => {
                        return el != null;
                    });

                    var filtered2 = filtered.filter((el) => {
                        return el.ProductName.toLowerCase().includes('ohne');
                    });

                    if (filtered2[0] !== undefined) {
                        filtered2[0].Position = "Ohne";
                    }

                    if (this.state.SMV !== undefined && this.state.SMV !== "" && this.state.SMV !== false) {
                        filtered2.push(this.state.SMV);
                    }

                    if (this.state.SML !== undefined && this.state.SML !== "" && this.state.SML !== false) {
                        filtered2.push(this.state.SML);
                    }

                    if (this.state.SMR !== undefined && this.state.SMR !== "" && this.state.SMR !== false) {
                        filtered2.push(this.state.SMR);
                    }

                    return filtered2.map((item, key) => {
                        return (
                            <div id={click} className="ClickFunnelItem" onClick={(e) => {
                                var prevPage = this.state.prevPage;
                                prevPage.push(this.state.CFSteps);
                                this.setState({
                                    prevPage: prevPage
                                }, () => {
                                    item.Position === "Ohne" ? this.selectClickItem(e, item) : this.selectMultiClickItem(e, item)
                                })
                            }}>
                                <span className="Check" style={item.Position === "Ohne" ? this.state.selected.Senkrechtmarkise.vorne.Position === "Ohne" && this.state.selected.Senkrechtmarkise.links.Position === "Ohne" && this.state.selected.Senkrechtmarkise.rechts.Position === "Ohne" && this.state.Clicked.Senkrechtmarkise !== 'notClicked' ? { display: "block" } : { display: "none" } : this.state.selected.Senkrechtmarkise[item.Position.toLowerCase()] ? this.state.selected.Senkrechtmarkise[item.Position.toLowerCase()].Id === item.Id ? { display: "block" } : { display: "none" } : { display: "none" }}>
                                    <FontAwesomeIcon icon={faCheckCircle} />
                                </span>
                                <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName} />
                                <h3>{item.ProductType === "Beschlag" ? this.revDeUmlaut(item.Position) : item.Position}</h3>
                            </div>
                        );
                    })
            }
            else {

                var filtered = extension.filter((el) => {
                    return el != null;
                });


                return filtered.map((item, key) => {
                    return (
                        <div id={click} className="ClickFunnelItem" onClick={(e) => {
                            var prevPage = this.state.prevPage;
                            prevPage.push(this.state.CFSteps);
                            this.setState({
                                prevPage: prevPage
                            }, () => { this.selectClickItem(e, item) })
                        }}>
                            <span className="Check" style={this.state.Clicked[item.ProductType] === item.Id ? { display: "block" } : { display: "none" }}>
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </span>
                            <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName} />
                            <h3>{item.ProductType === "Beschlag" || item.ProductType === "Traegerart" || item.ProductType === "Befestigungsmaterial" && item.ProductName !== "Mauerwerk" ? this.revDeUmlaut(item.ProductName) : item.ProductName}</h3>
                        </div>
                    );
                })
            }
        }
    }

    async getSMESize(size, pieces) {
        //return new Promise (async(resolve) =>{
        //    var newSize;
        //    var newPieces

        //    if (size > 5000) {
        //        newSize = Math.ceil(size / 2);
        //        newPieces = pieces + 1;
        //        resolve(await this.getSMESize(newSize, newPieces));
        //    }
        //    if (size < 5000) {
        //        var data = { Size: size, Pieces: pieces };
        //        resolve(data);
        //    }
        //})

        var newSize;
        var newPieces;
        var data;

        if (parseFloat(size) >= 5001 ) {
            newSize = Math.ceil(size / 2);
            newPieces = pieces + 1;
            data = await this.getSMESize(newSize, newPieces);
        }
        else {
            data = { Size: size, Pieces: pieces };
        }

        return data;

    }


    async getSME() {
        var SenkMarkise = this.state.Products.Senkrechtmarkise;
        var SMV
        var SML
        var SMR

        var widthObj = await this.getSMESize(this.state.Width, 1);
        var deepthObj = await this.getSMESize(this.state.Deepth, 1);


        SenkMarkise.map((item, key) => {
            console.log("item", item);
            
            console.log("Width", widthObj);
            console.log("Deepth", deepthObj);


            if (parseFloat(item.Min_Width) <= widthObj.Size && parseFloat(item.Max_Width) >= widthObj.Size) {
                SMV = { ...item };
                SMV.Id += "V";
                SMV.Position = "Vorne";
                this.setState({
                    SMPieces: widthObj.Pieces
                })
            }
            if (parseFloat(item.Min_Width) <= deepthObj.Size && parseFloat(item.Max_Width) >= deepthObj.Size) {
                SML = { ...item };
                SMR = { ...item };
                SML.Id += "L";
                SML.Position = "Links";
                SMR.Id += "R";
                SMR.Position = "Rechts";
                this.setState({
                    SMSidePieces: deepthObj.Pieces
                })
            }

        })

        console.log("SML", SML)
        console.log("SMR", SMR)
        console.log("SMV", SMV)

        this.setState({
            SMV: SMV,
            SML: SML,
            SMR: SMR
        })
    }

    render() {

        const CPMass = this.state.Width > 0 && this.state.Deepth > 0 ? { color: "#ef9839" } : { color: "#666" };
        const CPGlas = this.state.selected.Glas !== "" ? { color: "#ef9839" } : { color: "#666" };
        const CPGlas2 = this.state.selected.Glas !== "" ? { color: "#ef9839" } : { color: "#666" };
        const CPBM = this.state.selected.Befestigungsmaterial !== "" && this.state.selected.Beschlag !== "" ? { color: "#ef9839" } : { color: "#666" };
        const CPBM2 = this.state.selected.Befestigungsmaterial !== "" ? { color: "#ef9839" } : { color: "#666" };
        const CPAufbau = this.state.selected.Aufbau !== "" && this.state.selected.Unterkonstruktion !== "" || this.state.selected.Aufbau !== "" && this.props.wpObject.type.includes(" Alu") ? { color: "#ef9839" } : { color: "#666" };
        const CPExt = this.state.selected.ZubTerUeb !== "" ||
            this.state.selected.ZubVord !== "" ||
            this.state.selected.ZubAlg !== "" ||
            this.state.selected.Dachrahmen !== "" ||
            this.state.selected.Optik !== "" ||
            this.state.selected.Unterdachmarkise !== "" ||
            this.state.selected.LED !== "" ||
            this.state.selected.Heizstrahler !== "" ||
            this.state.selected.Regenrinne !== "" ? { color: "#ef9839" } : { color: "#666" };
        const CPMont = this.state.selected.Montage !== "" ? { color: "#ef9839" } : { color: "#666" };

        const getColors = (item) => {
            var filtered = item.Farben.filter((el) => {
                return el != null;
            });

            var manualColor = {
                Amount: "0",
                CalcPrice: "0",
                CanopyType: "Aluminium",
                Fittings: "0",
                GlasType: "",
                IMG: "",
                Id: "mC01",
                Max_Deepth: "0",
                Max_Width: "0",
                Min_Deepth: "0",
                Min_Width: "0",
                Price: "0",
                ProductDescription: "",
                ProductName: "RAL ",
                ProductType: "Farbe",
                Strength: "0",
                Weight: null
            };

            if (!this.props.wpObject.type.toLowerCase().includes("alu") && !this.props.wpObject.type.toLowerCase().includes("vordach")) {
                manualColor.CanopyType = "Stahl verzinkt und gepulvert";
            }
            if (this.props.wpObject.type.toLowerCase().includes("vordach")) {
                manualColor.CanopyType = "pulverbeschichtet";
            }

            filtered.push(manualColor);

            

            return filtered.map((Farbe, key) => {
                var IMG = Farbe.IMG ? Farbe.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png";
                if (Farbe.Id !== "mC01") {
                    return (
                        <div className="Farbe" id={Farbe.Id} style={{ backgroundImage: "url(" + IMG + ")" }} onClick={() => this.selectColor(Farbe)}>
                            <span>{Farbe.ProductName}</span>
                        </div>
                    );
                }
                else {
                    return (
                        <div className="Farbe" id={Farbe.Id} style={{ background: "white" }} onClick={() => this.selectColor(Farbe)}>
                            <p>RAL </p><input onChange={(e) => {
                                Farbe.ProductName = Farbe.ProductName + e.target.value;
                                this.selectColor(Farbe)
                            }} />
                        </div>
                    );
                }
            })
        }

        const Extensions = (extension) => {
            if (extension) {

                var filtered = extension.filter((el) => {
                    return el != null;
                });

                return filtered.map((item, key) =>
                    item.ProductType !== "LED" && item.ProductType !== "Heizstrahler" &&
                    item.ProductType !== "Glasschiebeelemente" &&
                    item.ProductType !== "Keilfenster" &&
                    item.ProductName.replace("Daem", "Däm") !== "Aluminium" &&
                    item.ProductType !== "Traegerart" &&
                    item.ProductName.replace("Daem", "Däm") !== "Stahl verzinkt und gepulvert" &&
                    !item.ProductName.replace("Daem", "Däm").includes("pulverbeschichtet") &&
                    !item.ProductName.replace("Daem", "Däm").includes("gepulvert") &&
                    !item.ProductName.replace("Daem", "Däm").includes("Pulverbeschichtung") ?
                    <div id={item.Id} className="Extension" onClick={() => this.select(item)}>
                        <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName.replace("Daem", "Däm")} />
                            <h3>{item.ProductName.replace("Daem", "Däm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm", "Wärmedämm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm","Wärmedämm")}</h3>
                       
                            <FontAwesomeIcon style={item.ProductDescription ? { display: "block" } : { display: "none" }} icon={faInfoCircle} />
                        <p className="description">{item.ProductDescription}</p>
                        <h4>AUSWÄHLEN</h4>
                        </div> :
                        item.ProductType === "Keilfenster" && !item.ProductName.replace("Daem", "Däm").includes("ohne") && !item.ProductName.replace("Daem", "Däm").includes("Ohne") ?
                            <div id={item.Id} className="Extension" onClick={() => this.select(item)}>
                                <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName.replace("Daem", "Däm")} />
                                <h3>{item.ProductName.replace("Daem", "Däm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm", "Wärmedämm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm", "Wärmedämm")}</h3>
                                <div className="checkKF">
                                <p>Links</p>
                                <input type="checkbox" checked={this.state.KFL} onChange={(e) => this.handleChange(e, "KeilfensterLinks")} />
                                </div>
                                <div className="checkKF">
                                    <p>Beide Seiten</p>
                                <input type="checkbox" checked={this.state.KFB} onChange={(e) => this.handleChange(e, "KeilfensterBeide")} />
                                </div>
                                <div className="checkKF">
                                    <p>Rechts</p>
                                <input type="checkbox" checked={this.state.KFR} onChange={(e) => this.handleChange(e, "KeilfensterRechts")} />
                                </div>
                                    <FontAwesomeIcon style={item.ProductDescription ? { display: "block" } : { display: "none" }} icon={faInfoCircle} />
                                <p className="description">{item.ProductDescription}</p>
                                <h4>AUSWÄHLEN</h4>
                            </div>
                            :
                            item.ProductName.replace("Daem", "Däm") === "Aluminium" || item.ProductName.replace("Daem", "Däm") === "Stahl verzinkt und gepulvert" || item.ProductName.replace("Daem", "Däm").includes("pulverbeschichtet") || item.ProductName.replace("Daem", "Däm").includes("gepulvert") || item.ProductName.replace("Daem", "Däm").includes("Pulverbeschichtung") ?
            <div id={item.Id} className="Extension" onClick={() => this.select(item)}>
                <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName.replace("Daem", "Däm")} />
                <h3>{item.ProductName.replace("Daem", "Däm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm", "Wärmedämm")}</h3>
                                    <div className="Farben">
                {getColors(item)}
                </div>
                <FontAwesomeIcon style={item.ProductDescription ? { display: "block" } : { display: "none" }} icon={faInfoCircle} />
                <p className="description">{item.ProductDescription}</p>
                <h4>AUSWÄHLEN</h4>
            </div>
            :
                                item.ProductType === "Heizstrahler" && !item.ProductName.replace("Daem", "Däm").includes("ohne") && !item.ProductName.replace("Daem", "Däm").includes("Ohne") ?
                            <div id={item.Id} className="Extension" onClick={() => this.select(item)}>
                                <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName.replace("Daem", "Däm")} />
                                        <h3>{item.ProductName.replace("Daem", "Däm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm", "Wärmedämm")}</h3>
                                <p>Menge</p>
                                <input value={this.state.HeizstrahlerAmount} onChange={(e) => this.handleChange(e, "HeizstrahlerAmount")} />
                                <FontAwesomeIcon style={item.ProductDescription ? { display: "block" } : { display: "none" }} icon={faInfoCircle} />
                                <p className="description">{item.ProductDescription}</p>
                                <h4>AUSWÄHLEN</h4>
                            </div>
                            :
                        item.ProductType === "Glasschiebeelemente" &&  !item.ProductName.replace("Daem", "Däm").includes("ohne")&&  !item.ProductName.replace("Daem", "Däm").includes("Ohne")?
                        <div id={item.Id} className="Extension" onClick={() => this.select(item)}>
                            <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName.replace("Daem", "Däm")} />
                            <h3>{item.ProductName.replace("Daem", "Däm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm", "Wärmedämm")}</h3>
                                           <div className="checkKF">
                                                <p>Links</p>
                                                <input type="checkbox" checked={this.state.GSL === true ? true:false} onChange={(e) => this.handleChange(e, "GSLinks")} />
                                            </div>
                                            <div className="checkKF">
                                                <p>Vorne</p>
                                                <input type="checkbox" checked={this.state.GSV === true ? true : false} onChange={(e) => this.handleChange(e, "GSVorne")} />
                                            </div>
                                            <div className="checkKF">
                                                <p>Rechts</p>
                                                <input type="checkbox" checked={this.state.GSR === true ? true : false} onChange={(e) => this.handleChange(e, "GSRechts")} />
                                            </div>
                                            <FontAwesomeIcon style={item.ProductDescription ? { display: "block" } : { display: "none" }} icon={faInfoCircle} />
                            <p className="description">{item.ProductDescription}</p>
                            <h4>AUSWÄHLEN</h4>
                            </div>
                            :
                        item.ProductType === "Glasschiebeelemente" &&  item.ProductName.replace("Daem", "Däm").includes("ohne") ||  item.ProductName.replace("Daem", "Däm").includes("Ohne")?
                        <div id={item.Id} className="Extension" onClick={() => this.select(item)}>
                            <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName.replace("Daem", "Däm")} />
                            <h3>{item.ProductName.replace("Daem", "Däm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm", "Wärmedämm")}</h3>
                                                <FontAwesomeIcon style={item.ProductDescription ? { display: "block" } : { display: "none" }} icon={faInfoCircle} />
                            <p className="description">{item.ProductDescription}</p>
                            <h4>AUSWÄHLEN</h4>
                            </div>
                                            :
                                            item.ProductType === "LED" && !item.ProductName.replace("Daem", "Däm").includes("ohne") && !item.ProductName.replace("Daem", "Däm").includes("Ohne") && this.props.wpObject.type !== "Freitragendes Vordach" ?
                            <div id={item.Id} className="Extension" onClick={() => this.select(item)}>
                                <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName.replace("Daem", "Däm")} />
                                                    <h3>{item.ProductName.replace("Daem", "Däm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm", "Wärmedämm")}</h3>
                                                     <p>Menge</p>
                                <input value={this.state.LEDAmount} onChange={(e) => this.handleChange(e, "LEDAmount")} />
                                <FontAwesomeIcon style={item.ProductDescription ? { display: "block" } : { display: "none" }} icon={faInfoCircle} />
                                <p className="description">{item.ProductDescription}</p>
                                <h4>AUSWÄHLEN</h4>
                                                </div>
                                                : item.ProductType === "Traegerart" ?
        <div id={item.Id} className="Extension" onClick={() => this.select(item)}>
            <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName.replace("Daem", "Däm")} />
            <h3>{item.ProductName.replace("Daem", "Däm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm", "Wärmedämm")}</h3>
            <FontAwesomeIcon style={item.ProductDescription ? { display: "block" } : { display: "none" }} icon={faInfoCircle} />
            <p className="description">{item.ProductDescription}</p>
            <h4>AUSWÄHLEN</h4>
        </div>:
                                                <div id={item.Id} className="Extension" onClick={() => this.select(item)}>
                                                    <img src={item.IMG ? item.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt={item.ProductName.replace("Daem", "Däm")} />
                                                    <h3>{item.ProductName.replace("Daem", "Däm").replace("Traeger", "Träger").replace("traeger", "träger").replace("ueber", "über").replace("Waermedaemm", "Wärmedämm")}</h3>
                                                    <FontAwesomeIcon style={item.ProductDescription ? { display: "block" } : { display: "none" }} icon={faInfoCircle} />
                                                    <p className="description">{item.ProductDescription}</p>
                                                    <h4>AUSWÄHLEN</h4>
                                                </div>


                        
                );
            }
        }

        const InfoBox =
            this.props.wpObject.type.replace(" Alu", "") !== "Terrassenüberdachung" && this.props.wpObject.type !== "Solar-Terrassenüberdachung" ?
            <div>
                    <p>Ihr gewähltes Produkt:</p>
                    <h1>{this.props.wpObject.type === "Terrassenüberdachung" ? this.props.wpObject.type + " Stahl" : this.props.wpObject.type}</h1>
                <h4>Fortschritt</h4>
                <div className="CheckPoint" style={CPMass}>
                        <FontAwesomeIcon icon={this.state.Width > 0 && this.state.Deepth > 0 ? faCheckCircle : faCircle} /><h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refMaße)}>Abmessungen</h5>
                </div>
                <div className="CheckPoint" style={this.props.wpObject.type !== "Freitragendes Vordach" ? CPGlas : {display : "none"}}>
                        <FontAwesomeIcon icon={this.state.selected.Glas !== "" ? faCheckCircle : faCircle} /><h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refGlas)}>Verglasung</h5>
                </div>
                <div className="CheckPoint" style={CPBM}>
                    <FontAwesomeIcon icon={this.state.selected.Befestigungsmaterial !== "" && this.state.selected.Beschlag !== "" ? faCheckCircle : faCircle} /><h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refBefestigung)}>Befestigung</h5>
                </div>
                <div className="CheckPoint" style={CPExt}>
                    <FontAwesomeIcon icon={this.state.selected.ZubTerUeb !== "" ||
                        this.state.selected.ZubVord !== "" ||
                        this.state.selected.ZubAlg !== "" ||
                        this.state.selected.Dachrahmen !== "" ||
                        this.state.selected.Optik !== "" ||
                        this.state.selected.Regenrinne !== "" ?
                            faCheckCircle : faCircle} /> <h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refZubehoer)}>Ausstattung</h5>
                </div>
                <div className="CheckPoint" style={CPMont}>
                    <FontAwesomeIcon icon={this.state.selected.Montage !== "" ? faCheckCircle : faCircle} /><h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refMontage)}>Montage</h5>
                </div>
                    <h3 className="Price">{this.state.Price}</h3><h6 className="BuyInfo"> inkl MwSt.</h6>
                    <div className="createAngebot">
                <FontAwesomeIcon icon={faEnvelopeOpenText} /><button onClick={() => { this.setState({ trigger: true }) }}>Angebot erhalten!</button>
                        <div style={{ display: "none" }}>
                        <FontAwesomeIcon icon={faPlusSquare} /><button onClick={() => this.createKonfiguration()}>Angebot hinzufügen</button>
                </div>
                <div className="Configurtions">
                    <span className="configH" style={this.state.confLength >= 1 ? { color: "black" } : { color: "white" }}>Ihre Konfigurationen</span>
                    <span className="configNr" onClick={() => { this.openConfig(1) }} style={this.state.confLength >= 1 ? { color: "#ef9839", cursor: "pointer" } : { color: "white" }}>1</span>
                    <span className="configNr" onClick={() => { this.openConfig(2) }} style={this.state.confLength >= 2 ? { color: "#ef9839", cursor: "pointer" } : { color: "white" }}>2</span>
                    <span className="configNr" onClick={() => { this.openConfig(3) }} style={this.state.confLength >= 3 ? { color: "#ef9839", cursor: "pointer" } : { color: "white" }}>3</span>
                </div>
                    </div></div> :
                <div>
                    <p>Ihr gewähltes Produkt:</p>
                    <h1>{this.props.wpObject.type === "Terrassenüberdachung" ? this.props.wpObject.type + " Stahl" : this.props.wpObject.type === "Solar-Terrassenüberdachung" ? "Solar Terrassenüberdachung" : this.props.wpObject.type}</h1>
                    <h4>Fortschritt</h4>
                    <div className="CheckPoint" style={CPMass}>
                        <FontAwesomeIcon icon={this.state.Width > 0 && this.state.Deepth > 0 ? faCheckCircle : faCircle} /><h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refMaße)}>Abmessungen</h5>
                    </div>
                    <div className="CheckPoint" style={CPAufbau}>
                        <FontAwesomeIcon icon={this.state.selected.Aufbau !== "" && this.state.selected.Unterkonstruktion !== "" ? faCheckCircle : faCircle} /><h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refAufbau)}>Aufbau</h5>
                    </div>
                    <div className="CheckPoint" style={CPGlas2}>
                        <FontAwesomeIcon icon={this.state.selected.Glas !== "" ? faCheckCircle : faCircle} /><h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refGlas)}>Verglasung</h5>
                    </div>
                    <div className="CheckPoint" style={CPBM2}>
                        <FontAwesomeIcon icon={this.state.selected.Befestigungsmaterial !== "" ? faCheckCircle : faCircle} /><h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refBefestigung)}>Befestigung</h5>
                    </div>
                    <div className="CheckPoint" style={CPExt}>
                        <FontAwesomeIcon icon={this.state.selected.ZubTerUeb !== "" ||
                            this.state.selected.ZubVord !== "" ||
                            this.state.selected.ZubAlg !== "" ||
                            this.state.selected.Unterdachmarkise !== "" ||
                            this.state.selected.LED !== "" ||
                            this.state.selected.Heizstrahler !== "" ?
                            faCheckCircle : faCircle} /> <h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refZubehoer)}>Ausstattung</h5>
                    </div>
                    <div className="CheckPoint" style={CPMont}>
                        <FontAwesomeIcon icon={this.state.selected.Montage !== "" ? faCheckCircle : faCircle} /><h5 style={{ cursor: "pointer" }} onClick={() => this.scrollToRef(this.refMontage)}>Montage</h5>
                    </div>
                    <h3 className="Price">{this.state.Price}</h3><h6 className="BuyInfo"> inkl MwSt.</h6>
                    <div className="createAngebot">
                        <FontAwesomeIcon icon={faEnvelopeOpenText} /><button onClick={() => { this.setState({ trigger: true }) }}>Angebot erhalten!</button>
                        <div style={{ display: "none" }}>
                        <FontAwesomeIcon icon={faPlusSquare} /><button onClick={() => this.createKonfiguration()}>Angebot hinzufügen</button>
                    </div>
                    <div className="Configurtions">
                        <span className="configH" style={this.state.confLength >= 1 ? { color: "black" } : { color: "white" }}>Ihre Konfigurationen</span>
                        <span className="configNr" onClick={() => { this.openConfig(1) }} style={this.state.confLength >= 1 ? { color: "#ef9839", cursor: "pointer" } : { color: "white" }}>1</span>
                        <span className="configNr" onClick={() => { this.openConfig(2) }} style={this.state.confLength >= 2 ? { color: "#ef9839", cursor: "pointer" } : { color: "white" }}>2</span>
                        <span className="configNr" onClick={() => { this.openConfig(3) }} style={this.state.confLength >= 3 ? { color: "#ef9839", cursor: "pointer" } : { color: "white" }}>3</span>
                        </div></div>
                </div>

        const DetailInput =
            <div className="DetailInput">
                <img src={this.getProduchtIMG(this.props.wpObject.type.toLowerCase())} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} alt="Vordachkonfigurator" />
                <div className="Inner">
                    <h3>Bemaßung</h3>
                    <div className="Width">
                        <label>Breite in m</label>
                        <input type="number" value={parseFloat(this.state.Width) / 1000} onChange={this.handleWidth} onBlur={e => this.handleBlur("Width",e)}></input>
                        <p>Minimale Breite: <b>{parseFloat(this.state.VordachMinWidth) / 1000 + "m"}</b></p>
                    </div>
                    <div className="Deepth">
                        <label>Tiefe in m</label>
                        <input type="number" value={parseFloat(this.state.Deepth) / 1000} onChange={this.handleDeepth} onBlur={e => this.handleBlur("Deepth",e)}></input>
                        <p>Minimale Tiefe: <b>{parseFloat(this.state.VordachMinDeepth) / 1000 + "m"}</b></p>
                        <p>Maximale Tiefe: <b>{parseFloat(this.state.VordachMaxDeepth) / 1000 + "m"}</b></p>
                    </div>
                </div>
            </div>

        const renderPage = () => {
            switch (this.state.CFSteps) {
                case 0:
                    if (this.props.wpObject.type.toLowerCase().includes("solar")) {
                        return ClickFunnelCarPortTerrasse();
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 1:
                    return ClickFunnelDimensions();
                    break;
                case 2:
                    if (this.state.available.Aufbau.length > 0) {
                        return ClickFunnelAufbau()
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 3:
                    if (this.state.available.Glas.length > 0 && !this.props.wpObject.type.toLowerCase().includes("solar")) {
                        return ClickFunnelGlasart();
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 4:
                    if (this.state.available.Beschlag.length > 0 && !this.props.wpObject.type.toLowerCase().includes("zugstang")) {
                        return ClickFunnelTraeger();
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 5:
                    if (this.props.wpObject.type.toLowerCase().includes("solar")) {
                        if (this.state.Module.Amount !== undefined) {
                            this.setState({
                                Module: {},
                                SMSY: undefined
                            }, () => {
                                var Module = [...this.state.Products.SolarModule]
                                var availableModule = [];
                                Module.map((item, key) => {
                                    if (item.ProductName === "Solarmodul") {
                                        availableModule.push(item);
                                    }
                                })
                                if (availableModule.length > 0) {
                                    return ClickFunnelSolarModul(availableModule);
                                }
                                else {
                                    this.setState({
                                        CFSteps: this.state.CFSteps + 1
                                    })
                                }
                            })
                        }
                        else {
                            var Module = [...this.state.Products.SolarModule]
                            var availableModule = [];
                            Module.map((item, key) => {
                                if (item.ProductName === "Solarmodul") {
                                    availableModule.push(item);
                                }
                            })
                            if (availableModule.length > 0) {
                                return ClickFunnelSolarModul(availableModule);
                            }
                            else {
                                this.setState({
                                    CFSteps: this.state.CFSteps + 1
                                })
                            }
                        }
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }

                    break;
                case 6:
                    if (this.state.available.Unterkonstruktion.length > 0 && !this.props.wpObject.type.toLowerCase().includes("alu")) {
                        return ClickFunnelUnterkonstruktion();
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 7:
                    if (this.state.selected.SolarModul !== "" && this.state.SMSY === undefined ) {
                        this.solarModuleDimensions();
                    }
                    if (this.state.selected.Beschlag !== "") {
                        if (this.state.selected.Beschlag.ProductName.toLowerCase().includes("pulver")) {
                            return ClickFunnelColor();
                        }
                        else {
                            this.setState({
                                CFSteps: this.state.CFSteps + 1
                            })
                        }
                    }
                    else if (this.state.selected.Unterkonstruktion !== "") {
                        if (this.state.selected.Unterkonstruktion.ProductName.toLowerCase().includes("pulver") || this.state.selected.Unterkonstruktion.ProductName.toLowerCase().includes("alu")) {
                            return ClickFunnelColor();
                        }
                        else {
                            this.setState({
                                CFSteps: this.state.CFSteps + 1
                            })
                        }
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 8:
                    if (this.props.wpObject.type.toLowerCase().includes("solar")) {
                        var selected = this.state.selected;
                        this.state.Products.Wechselrichter.map((item, key) => {
                            if (parseFloat(this.state.Module.TotalPower) >= parseFloat(item.Min_Width) && parseFloat(this.state.Module.TotalPower) <= parseFloat(item.Max_Width)) {
                                selected.Wechselrichter = item;
                                this.setState({
                                    selected: selected,
                                })
                            }
                        });
                    }
                    if (this.state.available.Traegerart.length > 0) {
                        return ClickFunnelTraegerForm();
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 9:
                    if (this.state.available.Regenrinne.length > 0) {
                        return ClickFunnelRegenrinne();
                    }
                    else {
                        this.getSME();
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 10:
                    if (this.state.available.LED.length > 0 && !this.props.wpObject.type.toLowerCase().includes("freitra")) {
                        return ClickFunnelLED();
                    }
                    else {
                        this.getSME();
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 11:
                    if (this.state.available.Unterdachmarkise.length > 0 && !this.props.wpObject.type.toLowerCase().includes("solar")) {
                        return ClickFunnelMarkise();
                    }
                    else {
                        this.getSME();
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 12:
                    if (this.state.available.Senkrechtmarkise.length > 0 && this.state.selected.SolarType.Id !== "CARP") {
                        return ClickFunnelSenkMarkise();
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                    
                case 13:
                    if (this.state.selected.SolarType !== undefined) {
                        if (this.state.selected.SolarType.Id !== "CARP") {
                            if (this.state.available.Glasschiebeelemente.length > 0) {
                                return ClickFunnelGlasschiebeElement();
                            }
                            else {
                                this.setState({
                                    CFSteps: this.state.CFSteps + 1
                                })
                            }
                        }
                        else {
                            if (this.state.available.Seitenelemente.length > 0) {
                                return ClickFunnelSeitenElement();
                            }
                            else {
                                this.setState({
                                    CFSteps: this.state.CFSteps + 1
                                })
                            }
                        }
                    }
                    else {
                        if (this.state.available.Glasschiebeelemente.length > 0) {
                            return ClickFunnelGlasschiebeElement();
                        }
                        else {
                            this.setState({
                                CFSteps: this.state.CFSteps + 1
                            })
                        }
                    }
                    break;
                case 14:
                    if (this.state.available.Geraeteraum.length > 0) {
                        return ClickFunnelGeraeteraum();
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 15:
                    if (this.state.available.Befestigungsmaterial.length > 0) {
                        return ClickFunnelBefestigungsmaterial()
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 16:
                    if (this.state.available.Montage.length > 0) {
                        return ClickFunnelMontage();
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 17:
                    if (this.state.available.StromSpeicher.length > 0) {
                        return ClickFunnelBatterie();
                    }
                    else {
                        this.setState({
                            CFSteps: this.state.CFSteps + 1
                        })
                    }
                    break;
                case 18:
                    return ContactFormular();
                    break;
                case 19:
                    return Congratulation();
                    break;
                    
                default:
                    if (this.state.CFSteps > 19) {
                        return Congratulation();
                    }
                    else {

                        return (ClickFunnelDimensions())
                    }
                    break;
            }
            
        }

        const ClickFunnelDimensions = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Wie groß soll die Überdachung werden?</h3>
                <div className="ClickFunnelContainer">
                    <div id={this.state.Clicked.Dimension} className="ClickFunnelItem Dimension" onClick={(e) => {
                        var prevPage = this.state.prevPage;
                        prevPage.push(this.state.CFSteps);
                        this.setState({
                            prevPage: prevPage
                        }, () => { this.checkDimensions })}}>
                        <span className="Check" style={this.state.Clicked.Dimension === true ? { display: "block" } : { display: "none" }}>
                    <FontAwesomeIcon icon={faCheckCircle} />
                </span>
                        <img src={this.getProduchtIMG(this.props.wpObject.type.toLowerCase())} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} />
                    <div className="Width">
                        <label>Breite in m</label>
                            <input type="number" value={parseFloat(this.state.Width) / 1000} onChange={this.handleWidth} onBlur={this.checkDimensions}></input>
                            <p>Minimale Breite: <b>{parseFloat(this.state.VordachMinWidth)/1000}</b></p>
                    </div>
                    <div className="Deepth">
                        <label>Tiefe in m</label>
                            <input type="number" value={parseFloat(this.state.Deepth)/1000} onChange={this.handleDeepth} onBlur={this.checkDimensions}></input>
                            <p>Minimale Tiefe: <b>{parseFloat(this.state.VordachMinDeepth)/1000}</b></p>
                            <p>Maximale Tiefe: <b>{parseFloat(this.state.VordachMaxDeepth)/1000}</b></p>
                        </div>
                    </div>
                </div>
                <button className="nextButton" onClick={() => {
                    if (this.state.Width !== "" && this.state.Deepth !== "") {
                        this.changePage()
                    }
                    else {
                        alert("Bitte Maße eingeben!")
                    }
                }}>{this.state.Sync === false ? <CircularProgress /> : "Weiter"}</button>

                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
                </div>

        const ClickFunnelGlasart = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Welche Glasart hätten Sie gerne?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Glas, this.state.Clicked.Glas)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelTraeger = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Welche Oberfläche hätten Sie gerne?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Beschlag, this.state.Clicked.Beschlag)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelBefestigungsmaterial = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Welches Befestigungsmaterial hätten Sie gerne?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Befestigungsmaterial, this.state.Clicked.Befestigungsmaterial)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelUnterkonstruktion = () => {
            var UK = [...this.state.available.Unterkonstruktion];
            if (this.state.selected.SolarModul !== "") {
            if (this.state.selected.SolarModul.ProductDescription.toLowerCase().includes("lichtdurch")) {
                var Unterkonstruktion1 = this.mapItem(this.state.Products.Unterkonstruktion, "Alu", false, false, false, false, "color");
                var Unterkonstruktion2 = this.mapItem(this.state.Products.Unterkonstruktion, "Solar", false, false, false, false, "color");
                UK = Unterkonstruktion1.concat(Unterkonstruktion2);
                UK = UK.filter((obj) => {
                    return !obj.ProductName.toLowerCase().includes('alu');
                });
            }
            else {
                var Unterkonstruktion1 = this.mapItem(this.state.Products.Unterkonstruktion, "Alu", false, false, false, false, "color");
                var Unterkonstruktion2 = this.mapItem(this.state.Products.Unterkonstruktion, "Solar", false, false, false, false, "color");
                UK = Unterkonstruktion1.concat(Unterkonstruktion2);
                if (parseFloat(this.state.Deepth) > 5001) {
                    UK = UK.filter((obj) => {
                        return !obj.ProductName.toLowerCase().includes('alu');
                    });
                }
                }
            }
                return (<div className={this.state.ClickFunnelPage}>
                <h3>Welche Unterkonstruktion bevorzugen Sie?</h3>
                <div className="ClickFunnelContainer">
                        {this.getExtension(UK, this.state.Clicked.Unterkonstruktion)}
                    </div>
                    <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                        var prevPage = this.state.prevPage;
                        if (prevPage.length > 1) {
                            prevPage.pop();
                        }
                        this.setState({
                            CFSteps: prevPage[prevPage.length - 1],
                            prevPage: prevPage
                        })
                    }}>Zurück</button>
            </div>)
        }

        const ClickFunnelColor = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>{this.state.selected.Beschlag !== "" ? "Welche Farbe sollen die Träger haben?" : "Welche Farbe soll die Überdachung haben?"}</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Beschlag, this.state.Clicked.Color, true)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelAufbau = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Wie soll die Überdachung konstruiert werden?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Aufbau, this.state.Clicked.Aufbau)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelMarkise = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Möchten Sie eine Beschattung haben?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Unterdachmarkise, this.state.Clicked.Unterdachmarkise)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelSenkMarkise = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Möchten Sie eine Beschattung haben?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Senkrechtmarkise, this.state.Clicked.Senkrechtmarkise,false,false,false,true)}
                </div>
                <button className="nextButton" style={this.state.SNB ? { display: "block" } : { display: "none" }} onClick={() => { this.changePage() }}>Weiter</button>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none" }} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelGeraeteraum = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Hätten Sie gerne einen Geräteraum?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Geraeteraum, this.state.Clicked.Geraeteraum, false, true)}
                </div>
                <button className="nextButton" style={this.state.SNB ? { display: "block" } : { display: "none" }} onClick={() => { this.changePage() }}>Weiter</button>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelGlasschiebeElement = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Möchten Sie Schiebeelemente haben?</h3>
                <h5>Mehrfachauswahl möglich</h5>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Glasschiebeelemente, this.state.Clicked.Glasschiebeelemente, false,true)}
                </div>
                <button className="nextButton" style={this.state.SNB ? { display: "block" } : { display: "none" }} onClick={() => { this.changePage() }}>Weiter</button>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelSeitenElement = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Möchten Sie Seitenelemente haben?</h3>
                <h5>Mehrfachauswahl möglich</h5>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Seitenelemente, this.state.Clicked.Seitenelemente, false, true)}
                </div>
                <button className="nextButton" style={this.state.SNB ? { display: "block" } : { display: "none" }} onClick={() => { this.changePage() }}>Weiter</button>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelLED = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Möchten Sie eine Beleuchtung haben? </h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.LED, this.state.Clicked.LED)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>


        const ClickFunnelTraegerForm = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Wie soll die Form der Träger sein?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Traegerart, this.state.Clicked.Traegerart)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelRegenrinne = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Hätten Sie gerne eine Regenrinne?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Regenrinne, this.state.Clicked.Regenrinne)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelCarPortTerrasse = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Was für ein Produkt hätten Sie gerne?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.SolarType, this.state.Clicked.SolarType)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelBatterie = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Hätten Sie gerne einen Stromspeicher?</h3>
                <div className="ClickFunnelContainer">
                    <div id="BAT1" className="ClickFunnelItem" onClick={(e) => {
                        var prevPage = this.state.prevPage;
                        prevPage.push(this.state.CFSteps);
                        this.setState({
                            prevPage: prevPage
                        }, () => { this.selectClickItemBat(1) })
                    }}>
                            <span className="Check" style={this.state.Clicked.Battery === "BAT1" ? { display: "block" } : { display: "none" }}>
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </span>
                        <img src={window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/StromSpeicher1.jpg"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} />
                            <h3>Ja</h3>
                        </div>
                    <div id="BAT2" className="ClickFunnelItem" onClick={(e) => {
                        var prevPage = this.state.prevPage;
                        prevPage.push(this.state.CFSteps);
                        this.setState({
                            prevPage: prevPage
                        }, () => { this.selectClickItemBat(2) })
                    }}>
                            <span className="Check" style={this.state.Clicked.Battery === "BAT2" ? { display: "block" } : { display: "none" }}>
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </span>
                        <img src={window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/StromSpeicher2.jpg"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} />
                            <h3>Nein</h3>
                        </div>
                    <div id="BAT3" className="ClickFunnelItem" onClick={(e) => {
                        var prevPage = this.state.prevPage;
                        prevPage.push(this.state.CFSteps);
                        this.setState({
                            prevPage: prevPage
                        }, () => { this.selectClickItemBat(3) })
                    }}>
                            <span className="Check" style={this.state.Clicked.Battery === "BAT3" ? { display: "block" } : { display: "none" }}>
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </span>
                        <img src={window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/StromSpeicher3.jpg"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }} />
                            <h3>Speicher vorhanden</h3>
                        </div>
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>


        const ClickFunnelSolarModul = (Module) =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Worauf legen Sie bei Ihrer Überdachung mehr Wert?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(Module, this.state.Clicked.Montage,false,false,true)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const ClickFunnelMontage = () =>
            <div className={this.state.ClickFunnelPage}>
                <h3>Wie sollen wir liefern?</h3>
                <div className="ClickFunnelContainer">
                    {this.getExtension(this.state.available.Montage, this.state.Clicked.Montage)}
                </div>
                <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                    var prevPage = this.state.prevPage;
                    if (prevPage.length > 1) {
                        prevPage.pop();
                    }
                    this.setState({
                        CFSteps: prevPage[prevPage.length - 1],
                        prevPage: prevPage
                    })
                }}>Zurück</button>
            </div>

        const Congratulation = () =>
            <div className={this.state.ClickFunnelPage + " last"}>
                <div className="Congratulation">
                    <p><b>Herzlichen Glückwunsch</b></p>
                    <p>Ihr Angebot wurde versendet!</p>
                    <p>Bitte schauen Sie auch in Ihren Spam Ordner!</p>
                    <p></p>
                    <h3>Wollen Sie den Konfigurator nocheinmal ausführen?</h3>
                    <a style={{ cursor: "pointer" }} onClick={() => { this.init() }}>NEU KONFIGURIEREN</a>
                </div>
            </div>

        const ContactFormular = () =>
            <div className={this.state.ClickFunnelPage + " last"}>
                {window.innerWidth >= 999 ? <div className="Congratulation">
                    <span className="Check">
                        <FontAwesomeIcon icon={faCheckCircle} />
                    </span>
                    <p><b>Glückwunsch</b></p>
                    <p>Wir haben ein passendes Angebot für dich erstellt!</p>
                </div> : ""}
                <h3>Wer soll das Angebot erhalten?</h3>
                <div className="ClickFunnelContainer">
                    <div id="ContactFormular" className="ClickFunnelItem">
                        <div className="select">
                            <label>Anrede*</label>
                            <Select options={[{ value: 'Herr', label: 'Herr' }, { value: 'Frau', label: 'Frau' }]} onChange={(e) => this.handleChange(e, "Anrede")} />
                        </div>
                        <div className="halfLeft">
                            <label>Vorname*</label>
                            <input type="text" value={this.state.Customer.FirstName} onChange={(e) => this.handleChange(e,"FirstName")}></input>
                        </div>
                        <div className="halfRight">
                            <label>Nachname*</label>
                            <input type="text" value={this.state.Customer.LastName} onChange={(e) => this.handleChange(e, "LastName")}></input>
                        </div>
                        <div>
                            <label>Postleitzahl:*</label>
                            <input type="text" minlength="4" value={this.state.Customer.Zip} onChange={(e) => this.handleChange(e, "Zip")}></input>
                        </div>
                        <div className="threeThirds">
                            <label>Straße*</label>
                            <input type="text" value={this.state.Customer.Street} onChange={(e) => this.handleChange(e, "Street")}></input>
                        </div>
                        <div className="oneThird">
                            <label>Hausnummer*</label>
                            <input type="text" value={this.state.Customer.StreetNr} onChange={(e) => this.handleChange(e, "StreetNr")}></input>
                        </div>
                        <div>
                            <label>Telefon*</label>
                            <input type="text" minlength="7" value={this.state.Customer.Phone} onChange={(e) => this.handleChange(e, "Phone")}></input>
                        </div>
                        <div>
                            <label>E-Mail*</label>
                            <input type="text" value={this.state.Customer.Mail} onChange={(e) => this.handleChange(e, "Mail")}></input>
                        </div>
                        <div>
                        <input type="checkbox" id="DSGVO" value={this.state.DSGVO} onChange={(e) => this.setState({ DSGVO: e.target.checked })}></input>
                            <label id="DSGVO" for="DSGVO">Hiermit stimme ich der <a href={this.state.DSGVOLink}>Datenschutzerklärung</a> zu.*</label>
                        </div>
                    </div>
                    <button onClick={() => {
                        if (this.state.DSGVO && this.state.Customer.FirstName !== "" && this.state.Customer.LastName !== "" && this.state.Customer.Mail !== "" && this.state.Customer.Zip !== "" && this.state.Customer.Zip.length >= 4 && this.state.Customer.Phone !== "" && this.state.Customer.Street !== "" && (/^([a-zA-Z]\d{3}|^\d{2}|^\d{1}|^\d{3}|\d[a-zA-Z]|\d{2}[a-zA-Z]|\d{3}[a-zA-Z])$/).test(this.state.Customer.StreetNr) && this.state.Customer.Phone.length >= 7) {
                                this.createAngebot("anfrage")
                                this.setState({
                                    CFSteps: 19
                                })
                        }
                        else {
                            alert("Sie müssen alle Felder die mit * gekenzeichnet sind ausfüllen.")
                        }
                    }}>Angebot erhalten</button>
                    <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                        var prevPage = this.state.prevPage;
                        if (prevPage.length > 1) {
                            prevPage.pop();
                        }
                        this.setState({
                            CFSteps: prevPage[prevPage.length - 1],
                            prevPage: prevPage
                        })
                    }}>Zurück</button>
                </div>
            </div>

        const availableItem = (item) => {
            if (item !== undefined) {
                if (item[0]) {
                    if (item[0].ProductType !== "Beschlag" && this.props.wpObject.type === "Zugstangenvordach" ||
                        this.props.wpObject.type !== "Zugstangenvordach") {
                        return { display: "block" }
                    }
                    else {
                        return { display: "none" }
                    }
                }
                else {
                    return { display: "none" }
                }
            }
        }

        const popUpContent = this.state.submited ? <div className="Congratulation">
            <p><b>Herzlichen Glückwunsch</b></p>
            <p>Ihr Angebot wurde versendet!</p>
            <p>Bitte schauen Sie auch in Ihren Spam Ordner!</p>
            <h3>Wollen Sie den Konfigurator nocheinmal ausführen?</h3>
            <a onClick={() => { this.init() }}>NEU KONFIGURIEREN</a>
        </div> :
            <div>
           {window.innerWidth >= 999 ? <div className="Congratulation">
                    <span className="Check">
                        <FontAwesomeIcon icon={faCheckCircle} />
                    </span>
                    <p><b>Glückwunsch</b></p>
                    <p>Wir haben ein passendes Angebot für dich erstellt!</p>
                </div> : ""}
                <h3>Wer soll das Angebot erhalten?</h3>
                <div className="ClickFunnelContainer">
                    <div id="ContactFormular" className="ClickFunnelItem">
                        <div className="select">
                            <label>Anrede*</label>
                            <Select options={[{ value: 'Herr', label: 'Herr' }, { value: 'Frau', label: 'Frau' }]} onChange={(e) => this.handleChange(e, "Anrede")} />
                        </div>
                        <div className="halfLeft">
                            <label>Vorname*</label>
                            <input type="text" value={this.state.Customer.FirstName} onChange={(e) => this.handleChange(e,"FirstName")}></input>
                        </div>
                        <div className="halfRight">
                            <label>Nachname*</label>
                            <input type="text" value={this.state.Customer.LastName} onChange={(e) => this.handleChange(e, "LastName")}></input>
                        </div>
                        <div>
                            <label>Postleitzahl:*</label>
                            <input type="text" minlength="4" value={this.state.Customer.Zip} onChange={(e) => this.handleChange(e, "Zip")}></input>
                        </div>
                        <div className="threeThirds">
                            <label>Straße*</label>
                            <input type="text" value={this.state.Customer.Street} onChange={(e) => this.handleChange(e, "Street")}></input>
                        </div>
                        <div className="oneThird">
                            <label>Hausnummer*</label>
                            <input type="text" value={this.state.Customer.StreetNr} onChange={(e) => this.handleChange(e, "StreetNr")}></input>
                        </div>
                        <div>
                            <label>Telefon*</label>
                            <input type="text" minlength="7" value={this.state.Customer.Phone} onChange={(e) => this.handleChange(e, "Phone")}></input>
                        </div>
                        <div>
                            <label>E-Mail*</label>
                            <input type="text" value={this.state.Customer.Mail} onChange={(e) => this.handleChange(e, "Mail")}></input>
                        </div>
                        <div>
                        <input type="checkbox" id="DSGVO" value={this.state.DSGVO} onChange={(e) => this.setState({ DSGVO: e.target.checked })}></input>
                            <label id="DSGVO" for="DSGVO">Hiermit stimme ich der <a href={this.state.DSGVOLink}>Datenschutzerklärung</a> zu.*</label>
                        </div>
                    </div>
                    <button onClick={() => {
                        if (this.state.DSGVO && this.state.Customer.FirstName !== "" && this.state.Customer.LastName !== "" && this.state.Customer.Mail !== "" && this.state.Customer.Zip !== "" && this.state.Customer.Zip.length >= 4 && this.state.Customer.Phone !== "" && this.state.Customer.Street !== "" && (/^([a-zA-Z]\d{3}|^\d{2}|^\d{1}|^\d{3}|\d[a-zA-Z]|\d{2}[a-zA-Z]|\d{3}[a-zA-Z])$/).test(this.state.Customer.StreetNr)  && this.state.Customer.Phone.length >= 7) {
                                this.createAngebot("anfrage")
                                this.setState({
                                    CFSteps: 19
                                })
                        }
                        else {
                            alert("Sie müssen alle Felder die mit * gekenzeichnet sind ausfüllen.")
                        }
                    }}>Angebot erhalten</button>
                    <button className="prevPage" style={{ display: this.state.CFSteps > 0 ? this.state.CFSteps > 1 && !this.props.wpObject.type.toLowerCase().includes("solar") || this.props.wpObject.type.toLowerCase().includes("solar") ? "block" : "none" : "none"}} onClick={() => {
                        var prevPage = this.state.prevPage;
                        if (prevPage.length > 1) {
                            prevPage.pop();
                        }
                        this.setState({
                            CFSteps: prevPage[prevPage.length - 1],
                            prevPage: prevPage
                        })
                    }}>Zurück</button>
                </div>
            </div>

        const ListExtensions = this.props.wpObject.type.replace(" Alu", "") !== "Terrassenüberdachung" && this.props.wpObject.type !== "Solar-Terrassenüberdachung" ?
            <div>
                <div ref={this.refGlas} className="Extensions" style={this.props.wpObject.type !== "Freitragendes Vordach" ? availableItem(this.state.available.Glas) : { display: "none" }}>
                    <h2>Glasart auswählen</h2>
                    <ul className="ExtensionList">{Extensions(this.state.available.Glas)}</ul>
                </div>
                <div ref={this.refBefestigung} className="Extensions" style={availableItem(this.state.available.Beschlag)}>
                    <h2>{!this.props.wpObject.type.includes("Freitragendes") ? "Beschlag auswählen" : "Ausführung auswählen"}</h2>
                    <ul className="ExtensionList">{Extensions(this.state.available.Beschlag)}</ul>
                </div>
                <div className="Extensions" style={availableItem(this.state.available.LED)}>
                    <h2>Beleuchtung</h2>
                    <ul className="ExtensionList">{Extensions(this.state.available.LED)}</ul>
                </div>
                <div className="Extensions" style={availableItem(this.state.available.Traegerart)}>
                    <h2>Trägerart</h2>
                    <ul className="ExtensionList">{Extensions(this.state.available.Traegerart)}</ul>
                </div>
                <div className="Extensions" style={availableItem(this.state.available.Befestigungsmaterial)}>
                    <h2>Befestigungsmaterial</h2>
                    <ul className="ExtensionList">{Extensions(this.state.available.Befestigungsmaterial)}</ul>
                </div>
                <div ref={this.refZubehoer}>
                    <div className="Extensions" style={availableItem(this.state.available.Zubehoer)}>
                        <h2>Zubehör</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Zubehoer)}</ul>
                    </div>
                    <div className="Extensions" style={availableItem(this.state.available.Regenrinne)}>
                        <h2>Regenrinne</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Regenrinne)}</ul>
                    </div>
                    <div className="Extensions" style={{ display: "none" }}>
                        <h2>Seitenteil</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Seitenteil)}</ul>
                    </div>
                </div>
                <div className="Extensions" style={this.state.selected.Vordach !== "" ? availableItem(this.state.Products.TechnischeZeichnung) : { display: "none" }}>
                    <h2>Technische Zeichnung</h2>
                    <ul className="ExtensionList">{Extensions(this.state.Products.TechnischeZeichnung)}</ul>
                </div>
                <div ref={this.refMontage} className="Extensions" style={availableItem(this.state.available.Montage)}>
                    <h2>Montage</h2>
                    <ul className="ExtensionList">{Extensions(this.state.available.Montage)}</ul>
                </div></div> : this.props.wpObject.type.replace(" Alu", "") === "Terrassenüberdachung" ?
                <div>
                    <div ref={this.refAufbau} className="Extensions" style={availableItem(this.state.available.Aufbau)}>
                        <h2>Aufbau auswählen</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Aufbau)}</ul>
                    </div>
                    <div className="Extensions" style={availableItem(this.state.available.Unterkonstruktion)}>
                        <h2>Unterkonstruktion</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Unterkonstruktion)}</ul>
                    </div>
                    <div ref={this.refGlas} className="Extensions" style={availableItem(this.state.available.Glas)}>
                        <h2>Glasart auswählen</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Glas)}</ul>
                    </div>
                    <div ref={this.refBefestigung} className="Extensions" style={this.state.selected.Aufbau ? this.state.selected.Aufbau.ProductName === "Freistehend" ? { display: "none" } : availableItem(this.state.available.Befestigungsmaterial) : availableItem(this.state.available.Befestigungsmaterial)}>
                        <h2>Befestigungsmaterial</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Befestigungsmaterial)}</ul>
                    </div>
                    <div>
                        <div ref={this.refZubehoer} className="Extensions" style={availableItem(this.state.available.Unterdachmarkise)}>
                            <h2>Unterdachmarkise</h2>
                            <ul className="ExtensionList">{Extensions(this.state.available.Unterdachmarkise)}</ul>
                        </div>
                        <div className="Extensions" style={availableItem(this.state.available.LED)}>
                            <h2>LED</h2>
                            <ul className="ExtensionList">{Extensions(this.state.available.LED)}</ul>
                        </div>
                        <div className="Extensions" style={availableItem(this.state.available.Glasschiebeelemente)}>
                            <h2>Glasschiebeelemente</h2>
                            <ul className="ExtensionList">{Extensions(this.state.available.Glasschiebeelemente)}</ul>
                        </div>
                        <div className="Extensions" style={availableItem(this.state.available.Heizstrahler)}>
                            <h2>Heizstrahler</h2>
                            <ul className="ExtensionList">{Extensions(this.state.available.Heizstrahler)}</ul>
                        </div>
                    </div>
                    <div className="Extensions" style={this.state.selected.Vordach !== "" ? availableItem(this.state.Products.TechnischeZeichnung) : { display: "none" }}>
                        <h2>Technische Zeichnung</h2>
                        <ul className="ExtensionList">{Extensions(this.state.Products.TechnischeZeichnung)}</ul>
                    </div>
                    <div ref={this.refMontage} className="Extensions" style={availableItem(this.state.available.Montage)}>
                        <h2>Montage</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Montage)}</ul>
                    </div></div> :
                <div>
                    <div ref={this.refAufbau} className="Extensions" style={availableItem(this.state.available.Aufbau)}>
                        <h2>Aufbau auswählen</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Aufbau)}</ul>
                    </div>
                    <div className="Extensions" style={availableItem(this.state.available.Unterkonstruktion)}>
                        <h2>Unterkonstruktion</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Unterkonstruktion)}</ul>
                    </div>
                    <div ref={this.refBefestigung} className="Extensions" style={this.state.selected.Aufbau ? this.state.selected.Aufbau.ProductName === "Freistehend" ? { display: "none" } : availableItem(this.state.available.Befestigungsmaterial) : availableItem(this.state.available.Befestigungsmaterial)}>
                        <h2>Befestigungsmaterial</h2>
                        <ul className="ExtensionList">{Extensions(this.state.available.Befestigungsmaterial)}</ul>
                    </div>
                    <div ref={this.refZubehoer}>
                        <div className="Extensions" style={availableItem(this.state.available.Unterdachmarkise)}>
                            <h2>Unterdachmarkise</h2>
                            <ul className="ExtensionList">{Extensions(this.state.available.Unterdachmarkise)}</ul>
                        </div>
                        <div className="Extensions" style={availableItem(this.state.available.LED)}>
                            <h2>LED</h2>
                            <ul className="ExtensionList">{Extensions(this.state.available.LED)}</ul>
                        </div>

                        <div className="Extensions" style={availableItem(this.state.available.Heizstrahler)}>
                            <h2>Heizstrahler</h2>
                            <ul className="ExtensionList">{Extensions(this.state.available.Heizstrahler)}</ul>
                        </div>
                        <div className="Extensions" style={availableItem(this.state.available.Wechselrichter)}>
                            <h2>Wechselrichter</h2>
                            <ul className="ExtensionList">{Extensions(this.state.available.Wechselrichter)}</ul>
                        </div>
                        <div className="Extensions" style={availableItem(this.state.available.Stromspeicher)}>
                            <h2>Stromspeicher</h2>
                            <ul className="ExtensionList">{Extensions(this.state.available.Stromspeicher)}</ul>
                        </div>
                        <div className="Extensions" style={availableItem(this.state.available.Ladestation)}>
                            <h2>Ladestation </h2>
                            <ul className="ExtensionList">{Extensions(this.state.available.Ladestation)}</ul>
                        </div>
                    </div>
                </div>

        const oldConfig =  <div className="boxedConfig">
            <h2 ref={this.refMaße}>Maße eingeben</h2>
            {DetailInput}
            {window.innerWidth >= 999 ? <div className="InfoBox">
                {InfoBox}
            </div> : ""}
            {ListExtensions}
            <Popup open={this.state.trigger} onClose={() => {
                this.setState({
                    trigger: false
                })
            }} position="right center">
                <div className="AngebotPopUp">
                    <span style={{ cursor: 'pointer' }} className='close' onClick={() => this.setState({ trigger: false, submited: false })}>&times;</span>
                    <div>
                        {popUpContent}
                    </div>
                </div>
            </Popup>
            <Popup open={this.state.trigger2} position="right center">
                <div className="KonfigPopUp">
                    <span style={{ cursor: 'pointer' }} className='close' onClick={() => this.setState({ trigger2: false, submited: false })}>&times;</span>
                    {this.state.confPopUp !== "" ?
                        <div>
                            <img src={this.state.confPopUp.IMG ? this.state.confPopUp.IMG : window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png"} onError={(e) => { e.target.onerror = null; e.target.src = window.location.origin.toString() + "/wp-content/plugins/gvd/includes/img/logo.png" }}/>
                            <div className="GrundDaten">
                                <tr>
                                    <th className="thHeader">Grunddaten</th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <th>Breite:</th>
                                    <th>{this.state.confPopUp.Grunddaten.Breite}</th>
                                </tr>
                                <tr>
                                    <th>Tiefe:</th>
                                    <th>{this.state.confPopUp.Grunddaten.Tiefe}</th>
                                </tr>
                                <tr>
                                    <th>Fläche:</th>
                                    <th>{this.state.confPopUp.Grunddaten.Flaeche}</th>
                                </tr>
                                <tr>
                                    <th>Menge:</th>
                                    <th>{this.state.confPopUp.Grunddaten.Menge}</th>
                                </tr>
                                <tr>
                                    <th>Gewicht:</th>
                                    <th>{this.state.confPopUp.Grunddaten.Menge}</th>
                                </tr>
                            </div>
                            <div className="SystemDaten">
                                <tr>
                                    <th className="thHeader">Service</th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <th>Halterung:</th>
                                    <th>{this.state.confPopUp.System.Halterung}</th>
                                </tr>
                                <tr>
                                    <th>Anzahl Halterungen:</th>
                                    <th>{this.state.confPopUp.System.AnzahlHalterungen}</th>
                                </tr>
                                <tr>
                                    <th>Befestigungsmaterial:</th>
                                    <th>{this.state.confPopUp.System.Befestigungsmaterial}</th>
                                </tr>
                            </div>
                            <div className="GlasDaten">
                                <tr>
                                    <th className="thHeader">Glas</th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <th>Glasart:</th>
                                    <th>{this.state.confPopUp.Glas.Glasart}</th>
                                </tr>
                                <tr>
                                    <th>Stärke:</th>
                                    <th>{this.state.confPopUp.Glas.Stärke}</th>
                                </tr>
                            </div>
                            <div className="ZubehoerDaten">
                                <tr>
                                    <th className="thHeader">Zubehör</th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <th>Regenrinne:</th>
                                    <th>{this.state.confPopUp.Zubehoer.Regenrinne.Name}</th>
                                </tr>
                                <tr>
                                    <th>Technische Zeichnung:</th>
                                    <th>{this.state.confPopUp.Zubehoer.TechZeichnung.Name}</th>
                                </tr>
                            </div>
                            <div className="ServiceDaten">
                                <tr>
                                    <th className="thHeader">Service</th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <th>Montage:</th>
                                    <th>{this.state.confPopUp.Service.Montage.Name}</th>
                                </tr>
                            </div>
                            <div className="InfoDaten">
                                <span className="PriceText">Preis der Konfiguration</span>
                                <span className="Price">{this.state.confPopUp.Preis}</span>
                                <div className="Configurtions">
                                    <span className="configH" style={{ color: "black" }}>Ihre Konfigurationen</span>
                                    <span className="configNr" onClick={() => { this.openConfig(4) }} style={this.state.confLength >= 1 ? { color: "#ef9839", cursor: "pointer" } : { color: "white" }}>1</span>
                                    <span className="configNr" onClick={() => { this.openConfig(5) }} style={this.state.confLength >= 2 ? { color: "#ef9839", cursor: "pointer" } : { color: "white" }}>2</span>
                                    <span className="configNr" onClick={() => { this.openConfig(6) }} style={this.state.confLength >= 3 ? { color: "#ef9839", cursor: "pointer" } : { color: "white" }}>3</span>
                                </div>
                            </div>
                        </div>
                         :""}
                </div>
            </Popup>
            {window.innerWidth <= 999 ? <div className="InfoBox">
                {InfoBox}
            </div> : ""}
      </div>


        return (
            <div className="ClickFunnel">
                <div className="CFHeader"><a href={"https://" + this.state.Web}><img src={"https://" + this.state.Web + "/wp-content/plugins/gvd/includes/img/logo.png"} alt="logo"></img></a> </div>
                {this.state.Lizenz === '' ? !this.props.wpObject.type.toLowerCase().includes("solar")  ? oldConfig : renderPage() : "NICHT LIZENSIERT"}
                <a href="https://Glasvordach.de" className="copyRight">{'© ' + new Date().getFullYear() + ' Glasvordach.de'}</a> 
            </div>
        );
    }
}

Shortcode.propTypes = {
  wpObject: PropTypes.object
};